// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"jrBX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectStyles", ()=>ObjectStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
'use client';
function ObjectStyles() {
    let [background, setBackground] = (0, _react.useState)('elevated');
    let [rounding, setRounding] = (0, _react.useState)('default');
    let [shadow, setShadow] = (0, _react.useState)('elevated');
    let [border, setBorder] = (0, _react.useState)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " se11 DM8Mfn11 DncrvPU11 qH5kTnc11 UH5kTnc11 UnB1JKEb11 eb11 _Ca11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fd11 _FnuYUweb11 pv11 __Anc11",
                        children: "Background"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                        "aria-label": "Background",
                        staticColor: "auto",
                        density: "compact",
                        selectionMode: "single",
                        selectedKeys: background ? [
                            background
                        ] : [],
                        onSelectionChange: (keys)=>setBackground([
                                ...keys
                            ][0]),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "base",
                                children: "base"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "layer-1",
                                children: "layer-1"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "layer-2",
                                children: "layer-2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "elevated",
                                children: "elevated"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fd11 _FnuYUweb11 pv11 __Anc11",
                        children: "Border Radius"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                        "aria-label": "Border Radius",
                        staticColor: "auto",
                        density: "compact",
                        selectionMode: "single",
                        selectedKeys: rounding ? [
                            rounding
                        ] : [],
                        onSelectionChange: (keys)=>setRounding([
                                ...keys
                            ][0]),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "sm",
                                children: "sm"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "default",
                                children: "default"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "lg",
                                children: "lg"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "xl",
                                children: "xl"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "full",
                                children: "full"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fd11 _FnuYUweb11 pv11 __Anc11",
                        children: "Box Shadow"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                        "aria-labe": "Box Shadow",
                        staticColor: "auto",
                        density: "compact",
                        selectionMode: "single",
                        selectedKeys: shadow ? [
                            shadow
                        ] : [],
                        onSelectionChange: (keys)=>setShadow([
                                ...keys
                            ][0]),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "emphasized",
                                children: "emphasized"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "elevated",
                                children: "elevated"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fd11 _FnuYUweb11 pv11 __Anc11",
                        children: "Border Width"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                        "aria-label": "Border Width",
                        staticColor: "auto",
                        density: "compact",
                        selectionMode: "single",
                        selectedKeys: border ? [
                            border
                        ] : [],
                        onSelectionChange: (keys)=>setBorder([
                                ...keys
                            ][0]),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "1",
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "2",
                                children: "2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "4",
                                children: "4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: function anonymous(props) {
                    let rules = " ";
                    if (props.background === "elevated") rules += ' g_g11';
                    else if (props.background === "layer-2") rules += ' g_g11';
                    else if (props.background === "layer-1") rules += ' gqlRAZb11';
                    else if (props.background === "base") rules += ' gX11';
                    else if (props.background === "transparent") rules += ' g911';
                    rules += ' ZJ11';
                    rules += ' La11';
                    rules += ' _Na11';
                    rules += ' Pa11';
                    rules += ' IM11';
                    rules += ' HM11';
                    rules += ' Jd9wcl11';
                    rules += ' _oa11';
                    if (props.rounding === "full") rules += ' og11';
                    else if (props.rounding === "xl") rules += ' oB1JKEb11';
                    else if (props.rounding === "lg") rules += ' o5NLVAe11';
                    else if (props.rounding === "default") rules += ' oH5kTnc11';
                    else if (props.rounding === "sm") rules += ' oR3ltQc11';
                    else rules += ' od11';
                    if (props.rounding === "full") rules += ' ng11';
                    else if (props.rounding === "xl") rules += ' nB1JKEb11';
                    else if (props.rounding === "lg") rules += ' n5NLVAe11';
                    else if (props.rounding === "default") rules += ' nH5kTnc11';
                    else if (props.rounding === "sm") rules += ' nR3ltQc11';
                    else rules += ' nd11';
                    if (props.rounding === "full") rules += ' kg11';
                    else if (props.rounding === "xl") rules += ' kB1JKEb11';
                    else if (props.rounding === "lg") rules += ' k5NLVAe11';
                    else if (props.rounding === "default") rules += ' kH5kTnc11';
                    else if (props.rounding === "sm") rules += ' kR3ltQc11';
                    else rules += ' kd11';
                    if (props.rounding === "full") rules += ' jg11';
                    else if (props.rounding === "xl") rules += ' jB1JKEb11';
                    else if (props.rounding === "lg") rules += ' j5NLVAe11';
                    else if (props.rounding === "default") rules += ' jH5kTnc11';
                    else if (props.rounding === "sm") rules += ' jR3ltQc11';
                    else rules += ' jd11';
                    if (props.shadow === "emphasized") rules += ' _n4zCLMe11';
                    else if (props.shadow === "elevated") rules += ' _nLeasBb11';
                    else rules += ' _nd11';
                    rules += ' _jf11';
                    rules += ' ik11';
                    if (props.border === "4") rules += ' _kd11';
                    else if (props.border === "2") rules += ' _kc11';
                    else if (props.border === "1") rules += ' _kb11';
                    else rules += ' _ka11';
                    if (props.border === "4") rules += ' hd11';
                    else if (props.border === "2") rules += ' hc11';
                    else if (props.border === "1") rules += ' hb11';
                    else rules += ' ha11';
                    if (props.border === "4") rules += ' md11';
                    else if (props.border === "2") rules += ' mc11';
                    else if (props.border === "1") rules += ' mb11';
                    else rules += ' ma11';
                    if (props.border === "4") rules += ' ld11';
                    else if (props.border === "2") rules += ' lc11';
                    else if (props.border === "1") rules += ' lb11';
                    else rules += ' la11';
                    rules += ' Tf11';
                    rules += ' Qf11';
                    if (props.rounding === "full") rules += ' So11';
                    else rules += ' Sh11';
                    if (props.rounding === "full") rules += ' Ro11';
                    else rules += ' Rh11';
                    return rules;
                }({
                    background,
                    rounding,
                    shadow,
                    border
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                    className: " uj11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 pt11 JYB8I11 GYB8I11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                        style: {
                            fontFamily: 'inherit',
                            WebkitTextSizeAdjust: 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: styles.function,
                                children: "style"
                            }),
                            background || rounding || shadow || border ? '({\n  ' : '({})',
                            background && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.property,
                                        children: "backgroundColor"
                                    }),
                                    ": ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: styles.string,
                                        children: [
                                            "'",
                                            background,
                                            "'"
                                        ]
                                    }),
                                    rounding || shadow || border ? ',\n  ' : null
                                ]
                            }),
                            rounding && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.property,
                                        children: "borderRadius"
                                    }),
                                    ": ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: styles.string,
                                        children: [
                                            "'",
                                            rounding,
                                            "'"
                                        ]
                                    }),
                                    shadow || border ? ',\n  ' : null
                                ]
                            }),
                            shadow && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.property,
                                        children: "boxShadow"
                                    }),
                                    ": ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: styles.string,
                                        children: [
                                            "'",
                                            shadow,
                                            "'"
                                        ]
                                    }),
                                    border ? ',\n  ' : null
                                ]
                            }),
                            border && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.property,
                                        children: "borderWidth"
                                    }),
                                    ": ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.number,
                                        children: border
                                    }),
                                    ',\n  ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.property,
                                        children: "borderStyle"
                                    }),
                                    ": ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.string,
                                        children: "'solid'"
                                    }),
                                    ',\n  ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.property,
                                        children: "borderColor"
                                    }),
                                    ": ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: styles.string,
                                        children: "'gray-1000'"
                                    })
                                ]
                            }),
                            background || rounding || shadow || border ? '\n})' : null
                        ]
                    })
                })
            })
        ]
    });
}
const styles = {
    string: " p8wMsQe11",
    number: " pG3CxWc11",
    property: " pz2bZib11",
    function: " p37ZLpd11"
};

},{"0":"bXktf","1":"bXktf","2":"bXktf","3":"bXktf","4":"bXktf","5":"bXktf","6":"bXktf","7":"bXktf","8":"bXktf","9":"bXktf","10":"bXktf","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ToggleButton","6wKQe"],["ToggleButtonGroup","Df7oZ"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bXktf":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.0";

},{"6a05e75e64e4f862":"a1TxN"}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.0";

},{}],"2Is6Z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"6vHrA"}],"6vHrA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"3OmcS":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"dWvIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DarkMode", ()=>DarkMode);
parcelHelpers.export(exports, "Resizable", ()=>Resizable);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _reactAria = require("react-aria");
// @ts-ignore
var _s2MoveHorizontalTableWidgetSvg = require("../../../../../@react-spectrum/s2/ui-icons/S2_MoveHorizontalTableWidget.svg");
var _s2MoveHorizontalTableWidgetSvgDefault = parcelHelpers.interopDefault(_s2MoveHorizontalTableWidgetSvg);
var _exampleApp = require("./ExampleApp");
'use client';
function DarkMode() {
    let containerRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " _Pc11 od11 on5NLVAe11 n5NLVAe11 k5NLVAe11 j5NLVAe11 _nLeasBb11 -_4DHzJc-qcDErc11 FH4vLIe11 JYB8I11 GuTsfBd11 GnYB8I11 IuTsfBd11 InYB8I11 HuTsfBd11 HnYB8I11 -jmjrke-od11 -jmjrke-no5NLVAe11 -zxUfXd-_nd11",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Resizable, {
                containerRef: containerRef,
                isClipped: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Provider), {
                    colorScheme: "light",
                    styles: " ZbG0Qsc11 FWF0Qsc11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleApp.AppFrame), {
                        inert: true
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Provider), {
                colorScheme: "dark",
                styles: " _Pa11 Wr11 _lr11 _Ar11 _zr11",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleApp.AppFrame), {
                    inert: true
                })
            })
        ]
    });
}
function Resizable({ children, containerRef, isClipped, minWidth = 0 }) {
    let [percent, setPercent] = (0, _react.useState)(50);
    let ref = (0, _react.useRef)(null);
    let pos = (0, _react.useRef)(0);
    let { focusProps, isFocusVisible } = (0, _reactAria.useFocusRing)();
    let { moveProps } = (0, _reactAria.useMove)({
        onMoveStart () {
            pos.current = ref.current.getBoundingClientRect().width;
        },
        onMove (e) {
            let newPos = pos.current + (e.pointerType === 'keyboard' ? (e.deltaX || -e.deltaY) * 20 : e.deltaX);
            let constrainedPos = Math.max(minWidth, newPos);
            let percent = Math.max(0, Math.min(100, constrainedPos / containerRef.current.getBoundingClientRect().width * 100));
            setPercent(percent);
            pos.current = newPos;
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: ref,
                style: {
                    height: '100%',
                    minWidth: minWidth,
                    width: percent + '%',
                    overflow: isClipped ? 'clip' : undefined,
                    position: 'relative',
                    zIndex: isClipped ? 2 : undefined
                },
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ...(0, _reactAria.mergeProps)(focusProps, moveProps),
                role: "separator",
                tabIndex: 0,
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": percent,
                className: " _Pa11 Wa11 _la11 Se11 Re11 IJGwHDc11 HJGwHDc11 re11 _Le11 __Xc11",
                style: {
                    left: `max(${minWidth}px, ${percent}%)`,
                    zIndex: isClipped ? 4 : undefined
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " ZPcYW6d11 Fb11 gNW56Ub11 glOVIhfcebS7sd11 glOVIhfcebS7sd11 oT4Nfn11 nT4Nfn11 kT4Nfn11 jT4Nfn11"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " ";
                            if (props.isFocusVisible) rules += ' _Lf11';
                            else rules += ' _Le11';
                            rules += ' Oh11';
                            rules += ' OlOVIhfcebS7sd11';
                            rules += ' OlOVIhfcebS7sd11';
                            rules += ' _Mc11';
                            rules += ' _Kd11';
                            rules += ' og11';
                            rules += ' ng11';
                            rules += ' kg11';
                            rules += ' jg11';
                            rules += ' _Pa11';
                            rules += ' WF11';
                            rules += ' _EF11';
                            rules += ' -_8PloMd-m11';
                            rules += ' __Ya11';
                            rules += ' -_7PloMd-CoPtrc11';
                            rules += ' __Ya11';
                            rules += ' tNW56Ub11';
                            rules += ' tlOVIhfcebS7sd11';
                            rules += ' tlOVIhfcebS7sd11';
                            rules += ' -_8sjo0b-tw11';
                            rules += ' -_8sjo0b-lOVIhfctgp5Dcd11';
                            rules += ' -_8sjo0b-lOVIhfctgp5Dcd11';
                            return rules;
                        }({
                            isFocusVisible
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2MoveHorizontalTableWidgetSvgDefault.default), {
                            className: " sb11 ZCe2o8c11 FCe2o8c11"
                        })
                    })
                ]
            })
        ]
    });
}

},{"0":"1gyWI","1":"cZhmh","2":"65NaN","3":"4bpiY","4":"4DBL8","5":"fOcn5","6":"htGJu","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"31Rc2","react":"a1TxN","react-aria":[["mergeProps","aNvcY"],["useFocusRing","6TXyU"],["useMove","kqQMp"]],"../../../../../@react-spectrum/s2/ui-icons/S2_MoveHorizontalTableWidget.svg":"hoZMG","./ExampleApp":"ALRve","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hoZMG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2MoveHorizontalTableWidget = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8,
                cy: 8,
                r: 8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, #fff)",
                d: "M10 11.75a.75.75 0 0 1-.53-1.28L11.94 8 9.47 5.53a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-.53.22M6 11.75a.75.75 0 0 1-.53-.22l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 1 1 1.06 1.06L4.06 8l2.47 2.47A.75.75 0 0 1 6 11.75"
            })
        ]
    });
exports.default = SvgS2MoveHorizontalTableWidget;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ALRve":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExampleApp", ()=>ExampleApp);
parcelHelpers.export(exports, "ColorSchemeContext", ()=>ColorSchemeContext);
parcelHelpers.export(exports, "ColorSchemeProvider", ()=>ColorSchemeProvider);
parcelHelpers.export(exports, "AppFrame", ()=>AppFrame);
parcelHelpers.export(exports, "SkeletonCard", ()=>SkeletonCard);
var _jsxRuntime = require("react/jsx-runtime");
var _helpCircle = require("@react-spectrum/s2/icons/HelpCircle");
var _helpCircleDefault = parcelHelpers.interopDefault(_helpCircle);
var _appsAll = require("@react-spectrum/s2/icons/AppsAll");
var _appsAllDefault = parcelHelpers.interopDefault(_appsAll);
var _search = require("@react-spectrum/s2/icons/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
// @ts-ignore
var _adobeLogo = require("../../../src/icons/AdobeLogo");
var _s2 = require("@react-spectrum/s2");
var _reactAria = require("react-aria");
var _react = require("react");
var _exampleApp2 = require("./ExampleApp2");
var _reactDom = require("react-dom");
// @ts-ignore
var _photos = require("./app/Photos");
var _sidebar = require("./app/Sidebar");
var _accountMenu = require("./app/AccountMenu");
var _home = require("./app/Home");
var _arrows = require("./app/Arrows");
var _notifications = require("./app/Notifications");
var _ideas = require("./app/Ideas");
'use client';
const XS = `@container (min-width: ${30}rem)`;
const SM = `@container (min-width: ${40}rem)`;
const MD = `@container (min-width: ${48}rem)`;
function ExampleApp({ showArrows } = {}) {
    let [page, setPage] = (0, _react.useState)('photos');
    let [[detail, img] = [], setDetail] = (0, _react.useState)([]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeProvider, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            "data-container": true,
            className: " -_4DHzJc-0u6p5b11 Fb11 _Pc11",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AppFrame, {
                    page: page,
                    onPageChange: setPage,
                    hidden: !!detail,
                    children: [
                        page === 'photos' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _photos.Photos), {
                            onAction: setDetail
                        }),
                        page === 'home' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _home.HomePage), {}),
                        page === 'ideas' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ideas.Ideas), {})
                    ]
                }),
                !detail && page === 'home' && showArrows && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _home.HomeArrows), {}),
                !detail && page === 'photos' && showArrows && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _arrows.Arrows), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 75,
                            x1: 120,
                            x2: 160,
                            y: 130,
                            href: "Button",
                            children: "Button"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 38,
                            x1: 120,
                            x2: 160,
                            y: 618,
                            href: "ActionButton",
                            children: "ActionButton"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 632,
                            y: 24,
                            points: "662,34 662,64",
                            marker: "markerEnd",
                            href: "SearchField",
                            children: "SearchField"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 1040,
                            y: 24,
                            points: "1064,34 1064,64",
                            marker: "markerEnd",
                            href: "Popover",
                            children: "Popover"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 1206,
                            x1: 1198,
                            x2: 1158,
                            y: 82,
                            marker: "markerEnd",
                            href: "Menu",
                            children: "Menu"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 1206,
                            x1: 1198,
                            x2: 1142,
                            y: 150,
                            marker: "markerEnd",
                            href: "SegmentedControl",
                            children: "SegmentedControl"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 1206,
                            x1: 1198,
                            x2: 1142,
                            y: 350,
                            marker: "markerEnd",
                            href: "CardView",
                            children: "CardView"
                        })
                    ]
                }),
                !detail && page === 'ideas' && showArrows && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ideas.IdeasArrows), {}),
                detail && img && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Detail, {
                    detail: detail,
                    img: img,
                    setDetail: setDetail,
                    showArrows: showArrows
                })
            ]
        })
    });
}
function Detail({ detail, img, setDetail, showArrows }) {
    let [panel, setPanel] = (0, _react.useState)('properties');
    let [filters, setFilters] = (0, _react.useState)({
        brightness: 0,
        contrast: 0,
        saturation: 0
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _exampleApp2.FilterContext), {
        value: {
            ...filters,
            onChange: setFilters
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleApp2.ExampleApp2), {
                panel: panel,
                onPanelChange: setPanel,
                onBack: ()=>{
                    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
                        setDetail([]);
                        return;
                    }
                    document.startViewTransition(async ()=>{
                        (0, _reactDom.flushSync)(()=>setDetail([]));
                        img.style.viewTransitionName = 'photo';
                    }).ready.then(()=>{
                        img.style.viewTransitionName = '';
                    });
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " Za11 Fb11 sd11 eb11 _Ca11 _Nb11 Pb11",
                    style: {
                        containerType: 'size'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Image), {
                        src: detail.urls.regular,
                        width: detail.width,
                        height: detail.height,
                        alt: detail.description || detail.alt_description,
                        UNSAFE_style: {
                            viewTransitionName: 'photo',
                            '--scale': `min(100cqw / ${detail.width}, 100cqh / ${detail.height})`,
                            width: `calc(${detail.width} * var(--scale))`,
                            height: `calc(${detail.height} * var(--scale))`,
                            filter: `${filters.brightness ? `brightness(${filters.brightness + 100}%)` : ''} ${filters.contrast ? `contrast(${filters.contrast + 100}%)` : ''} ${filters.saturation ? `saturate(${filters.saturation + 100}%)` : ''}`
                        }
                    })
                })
            }),
            showArrows && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _arrows.Arrows), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                        textX: 35,
                        x1: 120,
                        x2: 160,
                        y: 82,
                        href: "ActionButton",
                        children: "ActionButton"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                        textX: 0,
                        x1: 120,
                        x2: 160,
                        y: 178,
                        href: "ToggleButtonGroup",
                        children: "ToggleButtonGroup"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                        textX: 212,
                        y: 24,
                        points: "250,34 250,64",
                        href: "Breadcrumbs",
                        children: "Breadcrumbs"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                        textX: 1040,
                        y: 24,
                        points: "1064,34 1064,64",
                        marker: "markerEnd",
                        href: "Popover",
                        children: "Popover"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                        textX: 1206,
                        x1: 1198,
                        x2: 1158,
                        y: 82,
                        href: "Menu",
                        children: "Menu"
                    }),
                    panel === 'layers' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 1206,
                            x1: 1198,
                            x2: 1050,
                            y: 168,
                            href: "TreeView",
                            children: "TreeView"
                        })
                    }),
                    panel === 'properties' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                                textX: 1206,
                                x1: 1198,
                                x2: 1100,
                                y: 168,
                                href: "Slider",
                                children: "Slider"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                                textX: 1206,
                                points: "900,290 900,280 1198,280",
                                marker: "markerStart",
                                y: 280,
                                href: "ComboBox",
                                children: "ComboBox"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                                textX: 1206,
                                x1: 1198,
                                x2: 1100,
                                y: 304,
                                href: "NumberField",
                                children: "NumberField"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                                textX: 1206,
                                x1: 1198,
                                x2: 890,
                                y: 365,
                                href: "Checkbox",
                                children: "Checkbox"
                            })
                        ]
                    }),
                    panel === 'comments' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                                textX: 1206,
                                x1: 1198,
                                x2: 1092,
                                y: 208,
                                href: "TextArea",
                                children: "TextArea"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                                textX: 1206,
                                x1: 1198,
                                x2: 1092,
                                y: 248,
                                href: "Button",
                                children: "Button"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                                textX: 1206,
                                points: "842,370 842,360 1198,360",
                                marker: "markerStart",
                                y: 360,
                                href: "Avatar",
                                children: "Avatar"
                            })
                        ]
                    }),
                    panel === 'assets' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                            textX: 1206,
                            x1: 1198,
                            x2: 1050,
                            y: 320,
                            href: "Card",
                            children: "Card"
                        })
                    })
                ]
            })
        ]
    });
}
const DEFAULT_COLOR_SCHEME = {
    colorScheme: null,
    setColorScheme () {}
};
const ColorSchemeContext = /*#__PURE__*/ (0, _react.createContext)(DEFAULT_COLOR_SCHEME);
function ColorSchemeProvider({ children }) {
    let [colorScheme, setColorScheme] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        let m = matchMedia('(prefers-color-scheme: dark)');
        let onChange = ()=>setColorScheme(null);
        m.addEventListener('change', onChange);
        return ()=>m.removeEventListener('change', onChange);
    }, []);
    let ctx = (0, _react.useContext)(ColorSchemeContext);
    if (ctx !== DEFAULT_COLOR_SCHEME) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeContext, {
        value: {
            colorScheme,
            setColorScheme
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Provider), {
            colorScheme: colorScheme || undefined,
            styles: " sc11",
            children: children
        })
    });
}
function AppFrame({ children, inert, hidden, page, onPageChange }) {
    let { direction } = (0, _reactAria.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeProvider, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            inert: inert || hidden,
            style: hidden ? {
                visibility: 'hidden',
                position: 'absolute'
            } : undefined,
            className: " se11 Ch0tsyd11 CWyB2jbw7uvU11 EPlN5qb11 DfQhdHc11 DWyB2jbuxCDJd11 Fb11 -Bu7z1c-o5NLVAe11 ol8Nknc11 nl8Nknc11 kHiwpNd11 jHiwpNd11 _Nb11 Pb11 _oa11 -_5sGM4c-_nLeasBb11 _nh6skEc11 gqlRAZb11 _Bb11",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " z8IkPye11 y8IkPye11 B8IkPye11 A8IkPye11 sd11 Tf11 Qf11 Sg11 Rf11 _oa11 UkmMJWb11 qkmMJWb11 eb11 Za11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {
                            size: 24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-d11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 sk11 sWyB2jbf11",
                            children: direction === 'rtl' ? "\u062A\u0637\u0628\u064A\u0642\u064A" : 'My App'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: " _ub11 sk11 s0EpGkbb11",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SearchField), {
                                "aria-label": direction === 'rtl' ? "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0635\u0648\u0631" : 'Search photos',
                                placeholder: direction === 'rtl' ? "\u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0635\u0648\u0631" : 'Search photos',
                                styles: " LGpDyCb11 NMjJOlc11 IM11 HM11"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: " _ub11 sb11 s0EpGkbk11"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButtonGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: " sc11 s0EpGkbk11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                                        isQuiet: true,
                                        "aria-label": "Search",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: " sk11 sVEoohbc11",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                                            isQuiet: true,
                                            "aria-label": "Help",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpCircleDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifications.Notifications), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                                            isQuiet: true,
                                            "aria-label": "Apps",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appsAllDefault.default), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountMenu.AccountMenu), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.Sidebar), {
                    page: page,
                    onPageChange: onPageChange
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "data-content": true,
                    inert: !children,
                    className: " zk52g2d11 yk52g2d11 Bk52g2d11 Ak52g2d11 gX11 _nLeasBb11 od11 oWyB2jbB1JKEb11 nd11 nWyB2jbB1JKEb11 kd11 jd11 HYB8I11 HWyB2jbB1JKEb11 Tg11 Qd11 Sg11 Rg11 sd11 _ta11 Ma11 _oa11 _Na11 Pa11",
                    children: children || /*#__PURE__*/ (0, _jsxRuntime.jsx)(DefaultContent, {})
                })
            ]
        })
    });
}
const text = " pw11 _ma11 oR3ltQc11 nR3ltQc11 kR3ltQc11 jR3ltQc11 gH11";
function DefaultContent() {
    let { direction } = (0, _reactAria.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-g11 vFHT6Dd11 xe11 _xa11 xX0cczbd11 _xX0cczba11 xfe11 _xfa11 xfX0cczbd11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 GH5kTnc11",
                children: direction === 'rtl' ? "\u0645\u0624\u062E\u0631\u064B\u0627" : 'Recents'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " se11 D3miGEc11 EfYMhHd11 _Ce11 UB1JKEb11 qB1JKEb11 JB1JKEb11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {})
                ]
            })
        ]
    });
}
function SkeletonCard() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
        size: "S",
        styles: " Za11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " Za11 f1VMfn11 gH11"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        slot: "title",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: text,
                            inert: true,
                            children: "Placeholder title"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        slot: "description",
                        UNSAFE_style: {
                            WebkitTextFillColor: 'transparent'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: text,
                            inert: true,
                            children: "This is placeholder content approximating the length of the real content to avoid layout shifting when the real content appears."
                        })
                    })
                ]
            })
        ]
    });
}

},{"0":"8LSkM","1":"97JxD","2":"jixoI","3":"faY2V","4":"3n98M","5":"46Emk","6":"hDilJ","7":"9RKRv","8":"fv41m","9":"4UXjX","10":"fCKih","11":"6dEtm","12":"8Bq3x","13":"jhlLZ","14":"86e7P","15":"lsuf9","16":"5RAoy","react/jsx-runtime":"2Is6Z","@react-spectrum/s2/icons/HelpCircle":"38wV2","@react-spectrum/s2/icons/AppsAll":"k0X7J","@react-spectrum/s2/icons/Search":"cSREm","../../../src/icons/AdobeLogo":"5Bj5G","@react-spectrum/s2":[["ActionButton","lNDRs"],["ActionButtonGroup","1RyqL"],["Card","jxfoI"],["CardPreview","jxfoI"],["Content","10r6w"],["Text","10r6w"],["Image","4LTiE"],["Provider","31Rc2"],["SearchField","5lOkR"]],"react-aria":"4k4z8","react":"a1TxN","./ExampleApp2":"khrJz","react-dom":"gC2PC","./app/Photos":"cLTse","./app/Sidebar":"lWRGx","./app/AccountMenu":"cHgid","./app/Home":"3Ke2l","./app/Arrows":"cIjW4","./app/Notifications":"l3txx","./app/Ideas":"10oan","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"khrJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterContext", ()=>FilterContext);
parcelHelpers.export(exports, "ExampleApp2", ()=>ExampleApp2);
var _jsxRuntime = require("react/jsx-runtime");
var _select = require("@react-spectrum/s2/icons/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _chevronLeft = require("@react-spectrum/s2/icons/ChevronLeft");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _brush = require("@react-spectrum/s2/icons/Brush");
var _brushDefault = parcelHelpers.interopDefault(_brush);
var _edit = require("@react-spectrum/s2/icons/Edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _shapes = require("@react-spectrum/s2/icons/Shapes");
var _shapesDefault = parcelHelpers.interopDefault(_shapes);
var _helpCircle = require("@react-spectrum/s2/icons/HelpCircle");
var _helpCircleDefault = parcelHelpers.interopDefault(_helpCircle);
var _layers = require("@react-spectrum/s2/icons/Layers");
var _layersDefault = parcelHelpers.interopDefault(_layers);
var _properties = require("@react-spectrum/s2/icons/Properties");
var _propertiesDefault = parcelHelpers.interopDefault(_properties);
var _comment = require("@react-spectrum/s2/icons/Comment");
var _commentDefault = parcelHelpers.interopDefault(_comment);
var _asset = require("@react-spectrum/s2/icons/Asset");
var _assetDefault = parcelHelpers.interopDefault(_asset);
var _appsAll = require("@react-spectrum/s2/icons/AppsAll");
var _appsAllDefault = parcelHelpers.interopDefault(_appsAll);
var _textBold = require("@react-spectrum/s2/icons/TextBold");
var _textBoldDefault = parcelHelpers.interopDefault(_textBold);
var _textItalic = require("@react-spectrum/s2/icons/TextItalic");
var _textItalicDefault = parcelHelpers.interopDefault(_textItalic);
var _textUnderline = require("@react-spectrum/s2/icons/TextUnderline");
var _textUnderlineDefault = parcelHelpers.interopDefault(_textUnderline);
var _textStrikeThrough = require("@react-spectrum/s2/icons/TextStrikeThrough");
var _textStrikeThroughDefault = parcelHelpers.interopDefault(_textStrikeThrough);
var _textSubscript = require("@react-spectrum/s2/icons/TextSubscript");
var _textSubscriptDefault = parcelHelpers.interopDefault(_textSubscript);
var _textSuperscript = require("@react-spectrum/s2/icons/TextSuperscript");
var _textSuperscriptDefault = parcelHelpers.interopDefault(_textSuperscript);
var _textAlignLeft = require("@react-spectrum/s2/icons/TextAlignLeft");
var _textAlignLeftDefault = parcelHelpers.interopDefault(_textAlignLeft);
var _textAlignCenter = require("@react-spectrum/s2/icons/TextAlignCenter");
var _textAlignCenterDefault = parcelHelpers.interopDefault(_textAlignCenter);
var _textAlignRight = require("@react-spectrum/s2/icons/TextAlignRight");
var _textAlignRightDefault = parcelHelpers.interopDefault(_textAlignRight);
var _textAlignJustify = require("@react-spectrum/s2/icons/TextAlignJustify");
var _textAlignJustifyDefault = parcelHelpers.interopDefault(_textAlignJustify);
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _exampleApp = require("./ExampleApp");
var _utils = require("@react-aria/utils");
var _reactDom = require("react-dom");
var _typography = require("./Typography");
var _hcm = require("./HCM");
var _accountMenu = require("./app/AccountMenu");
var _notifications = require("./app/Notifications");
'use client';
const FilterContext = /*#__PURE__*/ (0, _react.createContext)({
    brightness: 52,
    contrast: -47,
    saturation: 28,
    onChange: (v)=>{}
});
const SM_BREAK = 40;
const SM = `@container (width >= ${SM_BREAK}rem)`;
function ExampleApp2({ onBack, children, showPanel, panel, onPanelChange }) {
    let [selectedPanel, setSelectedPanel] = (0, _react.useState)('properties');
    let [transitioning, setTransitioning] = (0, _react.useState)(null);
    let displayPanel = panel || selectedPanel || transitioning;
    let [isLarge, setLarge] = (0, _react.useState)(true);
    let setPanel = (panel)=>{
        onPanelChange?.(panel);
        setSelectedPanel(panel);
    };
    let ref = (0, _react.useRef)(null);
    (0, _utils.useResizeObserver)({
        ref,
        onResize () {
            let width = ref.current.getBoundingClientRect().width;
            let rem = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
            let breakpoint = width / rem;
            (0, _reactDom.flushSync)(()=>{
                let matches = breakpoint >= SM_BREAK;
                setLarge(matches);
                if (!showPanel && selectedPanel && isLarge && !matches) setPanel(null);
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleApp.ColorSchemeProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: ref,
            className: " se11 CX6igfd11 C0MnCaemMZzSc11 E8hiiSb11 E0MnCaeE5iebb11 DXUsVQ11 D0MnCaeHklWk11 Fb11 -Bu7z1c-o5NLVAe11 ol8Nknc11 nl8Nknc11 kHiwpNd11 jHiwpNd11 _Nb11 Pb11 _oa11 _nLeasBb11 _Pc11 _Bb11",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " z8IkPye11 y8IkPye11 B8IkPye11 A8IkPye11 gqlRAZb11 glOVIhfcceMNLe11 glOVIhfcceMNLe11 sd11 UB1JKEb11 qB1JKEb11 eb11 Za11 Fb11 Tf11 Qf11 Sf11 Rf11 _oa11 _ka11 hc11 ma11 la11 ir11 ilOVIhfcCp4usd11 ilOVIhfcCp4usd11 _jf11 La11 _Na11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                            isQuiet: true,
                            "aria-label": "Back",
                            onPress: onBack,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronLeftDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: " _ub11 _Na11 Pa11",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Breadcrumbs), {
                                onAction: onBack,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Breadcrumb), {
                                        children: "Your files"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Breadcrumb), {
                                        children: "July final draft"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButtonGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: " sk11 s0MnCaec11",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                                            isQuiet: true,
                                            "aria-label": "Help",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpCircleDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifications.Notifications), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                                            isQuiet: true,
                                            "aria-label": "Apps",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appsAllDefault.default), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountMenu.AccountMenu), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " zLpqDSc11 yLpqDSc11 BLpqDSc11 ALpqDSc11 sk11 s0MnCaed11 _ta11 UH5kTnc11 qH5kTnc11 gqlRAZb11 glOVIhfcceMNLe11 glOVIhfcceMNLe11 Tf11 Qf11 Sf11 Rf11 _oa11 _kc11 _k0MnCaea11 ha11 ma11 la11 l0MnCaec11 ir11 ilOVIhfcCp4usd11 ilOVIhfcCp4usd11 _jf11 _Na11 Pa11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                        "aria-label": "Tools",
                        selectionMode: "single",
                        defaultSelectedKeys: [
                            'select'
                        ],
                        isQuiet: true,
                        isEmphasized: true,
                        orientation: isLarge ? 'vertical' : 'horizontal',
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "select",
                                "aria-label": "Select",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "brush",
                                "aria-label": "Brush",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _brushDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "pencil",
                                "aria-label": "Pencil",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "shapes",
                                "aria-label": "Shapes",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shapesDefault.default), {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " zk52g2d11 yk52g2d11 Bk52g2d11 Ak52g2d11 glHMo6c11 glOVIhfcceMNLe11 glOVIhfcceMNLe11 _qf11",
                    children: children
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: function anonymous(props) {
                        let rules = " ";
                        rules += ' zykvwBe11';
                        rules += ' yykvwBe11';
                        rules += ' BykvwBe11';
                        rules += ' AykvwBe11';
                        rules += ' Za11';
                        if (props.isCollapsed) rules += ' Z0MnCaeDWMfn11';
                        else rules += ' Z0MnCaetW6OHc11';
                        if (props.isCollapsed) rules += ' Fa11';
                        else rules += ' FU2bf911';
                        rules += ' F0MnCaed11';
                        if (props.isTransitioning) rules += ' Ya11';
                        rules += ' Ydklsgce11';
                        if (props.isTransitioning) rules += ' XCIisn11';
                        if (props.isTransitioning) rules += ' _2b11';
                        rules += ' _2dklsgcb11';
                        rules += ' gqlRAZb11';
                        rules += ' glOVIhfcceMNLe11';
                        rules += ' glOVIhfcceMNLe11';
                        rules += ' -Ovbhqd-gqlRAZb11';
                        rules += ' -Ovbhqd-lOVIhfcgceMNLe11';
                        rules += ' -Ovbhqd-lOVIhfcgceMNLe11';
                        rules += ' _Pa11';
                        rules += ' _P0MnCaed11';
                        rules += ' _lr11';
                        rules += ' _zr11';
                        rules += ' _qf11';
                        return rules;
                    }({
                        isCollapsed: !selectedPanel,
                        isTransitioning: !!transitioning
                    }),
                    onTransitionEnd: ()=>{
                        setTransitioning(null);
                    },
                    children: displayPanel && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " Za11 Z0MnCaetW6OHc11 Fb11 _Na11 Pa11 _oa11 _kc11 _k0MnCaea11 ha11 ma11 m0MnCaec11 la11 ir11 ilOVIhfcCp4usd11 ilOVIhfcCp4usd11 _jf11",
                        children: [
                            displayPanel === 'layers' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layers, {}),
                            displayPanel === 'properties' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Properties, {}),
                            displayPanel === 'comments' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comments, {}),
                            displayPanel === 'assets' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Assets, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " zGE37w11 yGE37w11 BGE37w11 AGE37w11 _9c11 gqlRAZb11 glOVIhfcceMNLe11 glOVIhfcceMNLe11 Tf11 Qf11 Sf11 Rf11 _oa11 _kc11 _k0MnCaea11 ha11 ma11 m0MnCaec11 la11 ir11 ilOVIhfcCp4usd11 ilOVIhfcCp4usd11 _jf11 _Na11 Pa11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                        "aria-label": "Panels",
                        orientation: isLarge ? 'vertical' : 'horizontal',
                        styles: " IM11 HM11 ZJ11",
                        isQuiet: true,
                        selectedKeys: selectedPanel ? [
                            selectedPanel
                        ] : [],
                        onSelectionChange: (keys)=>{
                            let key = [
                                ...keys
                            ][0];
                            setPanel(key);
                            if (key == null || displayPanel == null) setTransitioning(key || displayPanel);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "layers",
                                "aria-label": "Layers",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layersDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "properties",
                                "aria-label": "Properties",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertiesDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "comments",
                                "aria-label": "Comments",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commentDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                id: "assets",
                                "aria-label": "Assets",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDefault.default), {})
                            })
                        ]
                    })
                })
            ]
        })
    });
}
const text = " pw11 _ma11 oR3ltQc11 nR3ltQc11 kR3ltQc11 jR3ltQc11 gH11";
function SkeletonCard() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
        size: "XS",
        styles: " Za11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " Za11 f1VMfn11 gH11"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        slot: "title",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: text,
                            children: "Placeholder title"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        slot: "description",
                        UNSAFE_style: {
                            WebkitTextFillColor: 'transparent'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: text,
                            children: "Testing"
                        })
                    })
                ]
            })
        ]
    });
}
function Layers() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TreeView), {
        "aria-label": "Layers",
        styles: " Fb11",
        defaultExpandedKeys: [
            'g1',
            'g2'
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Layer, {
                name: "Group 1",
                id: "g1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layer, {
                        name: "Layer 1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layer, {
                        name: "Layer 2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layer, {
                        name: "Layer 3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Layer, {
                name: "Group 2",
                id: "g2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layer, {
                        name: "Layer 1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layer, {
                        name: "Layer 2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layer, {
                        name: "Layer 3"
                    })
                ]
            })
        ]
    });
}
function Layer({ id, name, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.TreeViewItem), {
        id: id,
        textValue: name,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TreeViewItemContent), {
                children: name
            }),
            children
        ]
    });
}
function Properties() {
    let { brightness, contrast, saturation, onChange } = (0, _react.useContext)(FilterContext);
    let isHCM = 'style' in (0, _react.useContext)((0, _hcm.HCMContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        role: "group",
        "aria-label": "Properties",
        className: " sd11 _ta11 UH5kTnc11 qH5kTnc11 Tt11 Qt11 St11 Rt11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Accordion), {
            density: "compact",
            isQuiet: true,
            allowsMultipleExpanded: true,
            defaultExpandedKeys: [
                'filters',
                'text'
            ],
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Disclosure), {
                    id: "filters",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DisclosureTitle), {
                            children: "Filters"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DisclosurePanel), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Form), {
                                labelPosition: "side",
                                size: "S",
                                UNSAFE_style: {
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Slider), {
                                        label: "Brightness",
                                        minValue: -100,
                                        maxValue: 100,
                                        fillOffset: 0,
                                        formatOptions: {
                                            signDisplay: 'exceptZero'
                                        },
                                        defaultValue: brightness,
                                        onChange: (brightness)=>onChange({
                                                brightness,
                                                contrast,
                                                saturation
                                            })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Slider), {
                                        label: "Contrast",
                                        minValue: -100,
                                        maxValue: 100,
                                        fillOffset: 0,
                                        formatOptions: {
                                            signDisplay: 'exceptZero'
                                        },
                                        defaultValue: contrast,
                                        onChange: (contrast)=>onChange({
                                                brightness,
                                                contrast,
                                                saturation
                                            })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Slider), {
                                        label: "Saturation",
                                        minValue: -100,
                                        maxValue: 100,
                                        fillOffset: 0,
                                        formatOptions: {
                                            signDisplay: 'exceptZero'
                                        },
                                        defaultValue: saturation,
                                        onChange: (saturation)=>onChange({
                                                brightness,
                                                contrast,
                                                saturation
                                            })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Disclosure), {
                    id: "text",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DisclosureTitle), {
                            children: "Text"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DisclosurePanel), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Form), {
                                size: "S",
                                UNSAFE_style: {
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: " sd11 UH5kTnc11 qH5kTnc11 eb11 zvoofG11",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ComboBox), {
                                                "aria-label": "Font family",
                                                defaultSelectedKey: 2,
                                                styles: " _u3mU11",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                                        children: "Open Sans"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                                        id: 2,
                                                        children: "Adobe Clean"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                                        children: "Helvetica"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                                        children: "Times New Roman"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ComboBoxItem), {
                                                        children: "Comic Sans"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
                                                "aria-label": "Font size",
                                                defaultValue: 14,
                                                styles: " _ub11"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: " sd11 UR3ltQc11 qR3ltQc11 _Cg11 _C0MnCaee11 eb11 zvoofG11",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                                                "aria-label": "Font style",
                                                density: "compact",
                                                size: "S",
                                                selectionMode: "multiple",
                                                defaultSelectedKeys: [
                                                    'bold'
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "bold",
                                                        "aria-label": "Bold",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textBoldDefault.default), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "italic",
                                                        "aria-label": "Italic",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textItalicDefault.default), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "underline",
                                                        "aria-label": "Underline",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textUnderlineDefault.default), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "strike",
                                                        "aria-label": "Strikethrough",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textStrikeThroughDefault.default), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                                                "aria-label": "Font style",
                                                density: "compact",
                                                size: "S",
                                                selectionMode: "single",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "sub",
                                                        "aria-label": "Subscript",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textSubscriptDefault.default), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "super",
                                                        "aria-label": "Superscript",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textSuperscriptDefault.default), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ToggleButtonGroup), {
                                                "aria-label": "Text align",
                                                density: "compact",
                                                size: "S",
                                                selectionMode: "single",
                                                defaultSelectedKeys: [
                                                    'left'
                                                ],
                                                disallowEmptySelection: true,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "left",
                                                        "aria-label": "Left",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAlignLeftDefault.default), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "center",
                                                        "aria-label": "Center",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAlignCenterDefault.default), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "right",
                                                        "aria-label": "Right",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAlignRightDefault.default), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToggleButton), {
                                                        id: "justify",
                                                        "aria-label": "Justify",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAlignJustifyDefault.default), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Checkbox), {
                                        defaultSelected: true,
                                        isDisabled: isHCM,
                                        children: "Wrap"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function Comments() {
    let [comments, setComments] = (0, _react.useState)([
        {
            author: 'Nikolas Gibbons',
            avatar: 'https://www.untitledui.com/images/avatars/nikolas-gibbons',
            date: '2 hours ago',
            body: 'Thanks for the feedback!'
        },
        {
            author: 'Adriana Sullivan',
            avatar: 'https://www.untitledui.com/images/avatars/adriana-sullivan',
            date: 'July 14',
            body: 'Transitions are smooth! Could we speed them up just a bit?'
        },
        {
            author: 'Frank Whitaker',
            avatar: 'https://www.untitledui.com/images/avatars/frank-whitaker?',
            date: 'July 13',
            body: 'Love the direction. Could we simplify the header a bit more?'
        }
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: "group",
        "aria-label": "Comments",
        className: " sd11 _ta11 UB1JKEb11 qB1JKEb11 Tf11 Qf11 Sf11 Rf11 Fb11 _oa11 _qf11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-e11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 plOVIhfc6LxY911 plOVIhfc6LxY911 JYB8I11 GYB8I11",
                children: "Comments"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                className: " sd11 _ta11 UH5kTnc11 qH5kTnc11 ec11",
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) e.currentTarget.requestSubmit();
                },
                action: (formData)=>{
                    setComments([
                        {
                            author: 'You',
                            avatar: 'https://i.imgur.com/xIe7Wlb.png',
                            date: 'Just now',
                            body: formData.get('comment')
                        },
                        ...comments
                    ]);
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TextArea), {
                        "aria-label": "Add a comment",
                        placeholder: "Add a comment",
                        name: "comment",
                        isRequired: true,
                        styles: " Za11"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                        type: "submit",
                        size: "S",
                        variant: "accent",
                        children: "Post"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " sd11 _ta11 UkmMJWb11 IuTsfBd11 HuTsfBd11 GuTsfBd11 Tf11 Qf11 Sf11 Rf11 _Na11 Pa11 _ub11 Ma11",
                children: comments.map((comment, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typography.Comment), {
                        ...comment
                    }, i))
            })
        ]
    });
}
function Assets() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: "group",
        "aria-label": "Assets",
        className: " Tf11 Qf11 Sf11 Rf11 _oa11 Fb11 sd11 _ta11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-e11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11",
                children: "Assets"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " se11 DhFN6qe11 __ytyCQZ11 _Ce11 Ui9a9Xd11 qi9a9Xd11 JYB8I11 GuTsfBd11 IuTsfBd11 HuTsfBd11 Tf11 Qf11 Sf11 Rf11 _ub11 Ma11 _Na11 Pa11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonCard, {})
                ]
            })
        ]
    });
}

},{"0":"hUERE","1":"ha90l","2":"hENG8","3":"kyI6e","4":"64heB","5":"hR7wr","6":"e2yDn","7":"lmBno","8":"hoIKq","9":"5c3QE","10":"4IPTS","11":"c3me8","12":"gxoUw","13":"a5fGo","14":"8miPV","15":"49ktC","16":"avsYC","17":"hpAPX","18":"76IxD","19":"jqLln","20":"dKCpm","21":"hxds5","22":"7nv10","23":"j19Ig","24":"anack","25":"a6Ynw","26":"cIusm","react/jsx-runtime":"2Is6Z","@react-spectrum/s2/icons/Select":"ePiXv","@react-spectrum/s2/icons/ChevronLeft":"5jnVm","@react-spectrum/s2/icons/Brush":"lKS2A","@react-spectrum/s2/icons/Edit":"h4rDR","@react-spectrum/s2/icons/Shapes":"2xIVU","@react-spectrum/s2/icons/HelpCircle":"38wV2","@react-spectrum/s2/icons/Layers":"fxk0C","@react-spectrum/s2/icons/Properties":"a73RX","@react-spectrum/s2/icons/Comment":"aQjFO","@react-spectrum/s2/icons/Asset":"cyNrR","@react-spectrum/s2/icons/AppsAll":"k0X7J","@react-spectrum/s2/icons/TextBold":"a2vIM","@react-spectrum/s2/icons/TextItalic":"ldbZV","@react-spectrum/s2/icons/TextUnderline":"4Hamj","@react-spectrum/s2/icons/TextStrikeThrough":"gbHpB","@react-spectrum/s2/icons/TextSubscript":"8rVRU","@react-spectrum/s2/icons/TextSuperscript":"fplc4","@react-spectrum/s2/icons/TextAlignLeft":"6S5wg","@react-spectrum/s2/icons/TextAlignCenter":"lJ2dl","@react-spectrum/s2/icons/TextAlignRight":"cSNUd","@react-spectrum/s2/icons/TextAlignJustify":"lx2Ht","@react-spectrum/s2":[["Accordion","bl35P"],["ActionButton","lNDRs"],["ActionButtonGroup","1RyqL"],["Breadcrumb","7swdD"],["Breadcrumbs","7swdD"],["Button","gZHck"],["Card","jxfoI"],["CardPreview","jxfoI"],["Checkbox","jdSVu"],["ComboBox","9azF3"],["ComboBoxItem","9azF3"],["Content","10r6w"],["Text","10r6w"],["Disclosure","jAvgn"],["DisclosurePanel","jAvgn"],["DisclosureTitle","jAvgn"],["Form","cHqN4"],["NumberField","kptFj"],["Slider","ixJJx"],["TextArea","7oxrW"],["ToggleButton","6wKQe"],["ToggleButtonGroup","Df7oZ"],["TreeView","1sDWa"],["TreeViewItem","1sDWa"],["TreeViewItemContent","1sDWa"]],"react":"a1TxN","./ExampleApp":"ALRve","@react-aria/utils":"7OAb4","react-dom":"gC2PC","./Typography":"1wAS5","./HCM":"i1ciP","./app/AccountMenu":"cHgid","./app/Notifications":"l3txx","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hUERE":[function() {},{}],"ha90l":[function() {},{}],"hENG8":[function() {},{}],"kyI6e":[function() {},{}],"64heB":[function() {},{}],"hR7wr":[function() {},{}],"e2yDn":[function() {},{}],"lmBno":[function() {},{}],"hoIKq":[function() {},{}],"5c3QE":[function() {},{}],"4IPTS":[function() {},{}],"c3me8":[function() {},{}],"gxoUw":[function() {},{}],"a5fGo":[function() {},{}],"8miPV":[function() {},{}],"49ktC":[function() {},{}],"avsYC":[function() {},{}],"hpAPX":[function() {},{}],"76IxD":[function() {},{}],"jqLln":[function() {},{}],"dKCpm":[function() {},{}],"hxds5":[function() {},{}],"7nv10":[function() {},{}],"j19Ig":[function() {},{}],"anack":[function() {},{}],"a6Ynw":[function() {},{}],"cIusm":[function() {},{}],"ePiXv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M6.281 18.547c-.292 0-.589-.058-.876-.177-.856-.355-1.387-1.151-1.387-2.078l-.004-12.47c0-.928.532-1.725 1.39-2.08.854-.354 1.796-.168 2.452.489l8.892 8.914c.655.655.84 1.594.486 2.45-.356.855-1.152 1.387-2.079 1.387h-4.078c-.197 0-.39.08-.53.22l-2.691 2.683c-.436.434-.997.662-1.575.662M6.277 3.068c-.137 0-.25.039-.3.06-.109.045-.463.228-.463.693l.004 12.471c0 .465.354.648.462.692.108.045.487.167.817-.162l2.691-2.682c.426-.424.99-.658 1.589-.658h4.078c.465 0 .648-.354.693-.462s.166-.488-.161-.816L6.795 3.29c-.174-.174-.362-.222-.518-.222"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5jnVm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.237 16.455c-.196 0-.393-.077-.54-.23L6.21 10.52c-.28-.29-.28-.749 0-1.039l5.5-5.716c.287-.3.763-.308 1.06-.02.298.286.308.76.02 1.059l-4.999 5.197 4.986 5.184c.288.297.279.772-.02 1.06-.145.14-.332.21-.52.21"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"h4rDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.78 1.757C16.51.716 14.555.858 13.33 2.08L3.079 12.334c-.32.32-.559.717-.69 1.15l-1.384 4.584c-.08.265-.007.552.188.747.142.143.334.22.53.22q.11 0 .217-.032l4.582-1.384c.434-.13.832-.368 1.151-.688L18.028 6.575c.648-.647.993-1.545.948-2.46s-.482-1.775-1.195-2.358M2.846 17.163l.98-3.246q.042-.135.113-.257l2.41 2.409q-.123.07-.259.114zM16.966 5.516l-9.525 9.526-2.475-2.476 9.425-9.425c.386-.387.896-.586 1.39-.586.38 0 .752.119 1.05.362.392.321.621.772.646 1.272.025.494-.161.977-.51 1.327"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aQjFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M6.25 19q-.151 0-.293-.06c-.277-.118-.457-.39-.457-.69V15h-.75C2.682 15 1 13.317 1 11.25v-5.5C1 3.683 2.682 2 4.75 2h10.5C17.318 2 19 3.683 19 5.75v5.5c0 2.067-1.682 3.75-3.75 3.75h-4.543L6.77 18.79c-.143.138-.33.21-.52.21M4.75 3.5C3.51 3.5 2.5 4.51 2.5 5.75v5.5c0 1.24 1.01 2.25 2.25 2.25h1.5c.414 0 .75.336.75.75v2.237l2.885-2.777c.14-.135.326-.21.52-.21h4.845c1.24 0 2.25-1.01 2.25-2.25v-5.5c0-1.24-1.01-2.25-2.25-2.25z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a2vIM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.99 2.015H5.51C4.127 2.015 3 3.192 3 4.64v1.11c0 .621.504 1.125 1.125 1.125S5.25 6.371 5.25 5.75V4.64c0-.221.138-.375.26-.375H8V15.71l.001.015H7.43c-.621 0-1.125.504-1.125 1.125s.504 1.125 1.125 1.125h4.64c.621 0 1.125-.504 1.125-1.125s-.504-1.125-1.125-1.125H11.5l.001-.015V4.265h2.49c.122 0 .26.154.26.375v1.11c0 .621.504 1.125 1.125 1.125S16.5 6.371 16.5 5.75V4.64c0-1.448-1.126-2.625-2.51-2.625"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ldbZV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.654 2.756c-.382-.48-.953-.756-1.566-.756H6.04c-.935 0-1.754.597-2.139 1.56l-.557 1.404c-.153.385.035.82.42.973.382.154.82-.034.974-.42l.557-1.403c.058-.143.282-.614.745-.614h3.72l-3.491 13H4.662c-.414 0-.75.336-.75.75s.336.75.75.75h4.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H7.823l3.492-13h3.773c.21 0 .335.118.391.188.056.072.143.22.095.425l-.25 1.077c-.094.405.157.807.56.9q.087.02.172.02c.34 0 .65-.234.73-.58l.25-1.077c.139-.598 0-1.217-.382-1.697"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Hamj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14.522 2H5.478C4.249 2 3.25 3.01 3.25 4.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.413.326-.75.728-.75H9.25v11H7.68c-.414 0-.75.336-.75.75s.336.75.75.75h4.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.57v-11h3.772c.402 0 .728.337.728.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-1.24-.999-2.25-2.228-2.25M16.25 19H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gbHpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14.5 2h-9C4.26 2 3.25 3.01 3.25 4.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.413.337-.75.75-.75h3.75v3.75c0 .414.336.75.75.75s.75-.336.75-.75V3.5h3.75c.413 0 .75.337.75.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25C16.75 3.01 15.74 2 14.5 2M16.25 9.25H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h5.5v5.75H7.7c-.414 0-.75.336-.75.75s.336.75.75.75h4.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.59v-5.75h5.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bl35P":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionContext", ()=>AccordionContext);
parcelHelpers.export(exports, "Accordion", ()=>Accordion);
parcelHelpers.export(exports, "AccordionItem", ()=>AccordionItem);
parcelHelpers.export(exports, "AccordionItemTitle", ()=>AccordionItemTitle);
parcelHelpers.export(exports, "AccordionItemHeader", ()=>AccordionItemHeader);
parcelHelpers.export(exports, "AccordionItemPanel", ()=>AccordionItemPanel);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _disclosure = require("./Disclosure");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const accordion = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g) || []).join('');
    rules += ' sd11';
    rules += ' _ta11';
    return rules;
};
const AccordionContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Accordion = /*#__PURE__*/ (0, _react.forwardRef)(function Accordion(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, AccordionContext);
    let domRef = (0, _utils.useDOMRef)(ref);
    let { UNSAFE_style, UNSAFE_className = '', size = 'M', density = 'regular', isQuiet } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosureContext).Provider, {
        value: {
            size,
            isQuiet,
            density
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DisclosureGroup), {
            ...props,
            ref: domRef,
            style: UNSAFE_style,
            className: (UNSAFE_className ?? '') + accordion(null, props.styles),
            children: props.children
        })
    });
});
const AccordionItem = /*#__PURE__*/ (0, _react.forwardRef)(function AccordionItem(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.Disclosure), {
        ...props,
        ref: ref
    });
});
const AccordionItemTitle = /*#__PURE__*/ (0, _react.forwardRef)(function AccordionItemTitle(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosureTitle), {
        ...props,
        ref: ref
    });
});
const AccordionItemHeader = /*#__PURE__*/ (0, _react.forwardRef)(function AccordionItemHeader(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosureHeader), {
        ...props,
        ref: ref
    });
});
const AccordionItemPanel = /*#__PURE__*/ (0, _react.forwardRef)(function AccordionItemPanel(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosure.DisclosurePanel), {
        ...props,
        ref: ref
    });
});

},{"0":"btVHi","react/jsx-runtime":"2Is6Z","react-aria-components":"hRrWd","./Disclosure":"jAvgn","react":"a1TxN","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"btVHi":[function() {},{}],"1wAS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Typography", ()=>Typography);
parcelHelpers.export(exports, "Comment", ()=>Comment);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
'use client';
function Typography() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " sd11 qB1JKEb11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: " gX11 Tf11 Qf11 Sf11 Rf11 _oa11 o5NLVAe11 n5NLVAe11 k5NLVAe11 j5NLVAe11 Za11",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " sd11 eb11 qH5kTnc11 GkmMJWb11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-e11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 JYB8I11 GYB8I11",
                            children: "Comments"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Style, {
                            children: "title-lg"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " sd11 _ta11 UkmMJWb11 qkmMJWb11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comment, {
                            author: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "Nikolas Gibbons",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Style, {
                                        children: "title-sm"
                                    })
                                ]
                            }),
                            avatar: "https://www.untitledui.com/images/avatars/nikolas-gibbons",
                            date: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "2 hours ago",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Style, {
                                        children: "detail-sm"
                                    })
                                ]
                            }),
                            body: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "Thanks for the feedback!",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Arrow, {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Style, {
                                        children: "body"
                                    })
                                ]
                            }),
                            showArrow: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comment, {
                            author: "Adriana Sullivan",
                            avatar: "https://www.untitledui.com/images/avatars/adriana-sullivan",
                            date: "July 14",
                            body: "Transitions are smooth! Could we speed them up just a bit?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comment, {
                            author: "Frank Whitaker",
                            avatar: "https://www.untitledui.com/images/avatars/frank-whitaker?",
                            date: "July 13",
                            body: "Love the direction. Could we simplify the header a bit more?"
                        })
                    ]
                })
            ]
        })
    });
}
const styles = {
    string: " p8wMsQe11",
    number: " pG3CxWc11",
    property: " pz2bZib11",
    function: " p37ZLpd11",
    variable: " p1gYRFc11"
};
function Style({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("pre", {
        className: " uj11 -_6BNtrc-b11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 pt11 Jahikk11 GYB8I11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: " sk11 snf11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: styles.function,
                        children: "style"
                    }),
                    '({',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: styles.property,
                        children: "font"
                    }),
                    ': '
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: styles.string,
                children: [
                    "'",
                    children,
                    "'"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " sk11 snf11",
                children: '})'
            })
        ]
    });
}
function Comment({ author, avatar, date, body }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " se11 C0zudre11 DPlN5qb11 EI24Iie11 qH5kTnc11 eb11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Avatar), {
                styles: " zQFMIBe11 yQFMIBe11 BQFMIBe11 AQFMIBe11",
                src: avatar,
                size: 32
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " zQ4PDrc11 yQ4PDrc11 BQ4PDrc11 AQ4PDrc11 uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 plOVIhfc6LxY911 plOVIhfc6LxY911 sd11 eb11 qH5kTnc11",
                children: author
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " zhEkCrc11 yhEkCrc11 BhEkCrc11 AhEkCrc11 uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-b11 vFHT6Dd11 xc11 _xa11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 pn11 plOVIhfc6LxY911 plOVIhfc6LxY911 sd11 eb11 qH5kTnc11",
                children: date
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: " zJM5Brc11 yJM5Brc11 BJM5Brc11 AJM5Brc11 uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-d11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 pt11 plOVIhfc6LxY911 plOVIhfc6LxY911 sd11 eb11 qH5kTnc11",
                children: body
            })
        ]
    });
}
function Arrow() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        height: 5,
        className: " _ub11 _va11 Na11 _qf11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                r: 2.5,
                cx: 2.5,
                cy: 2.5,
                className: " txgjhZb11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                x1: 2.5,
                y1: 2.5,
                x2: "100%",
                y2: 2.5,
                className: " VxgjhZb11",
                strokeWidth: 1.2,
                strokeLinecap: "round"
            })
        ]
    });
}

},{"0":"l8uOG","1":"bwIR2","2":"6y4w9","3":"5iQwU","4":"13usb","5":"gsZVi","6":"hAnSt","7":"jpq5u","8":"7jZGc","9":"3qXPb","10":"am0Cr","11":"aYTUY","12":"jaK4u","13":"lW03I","14":"eSeft","15":"eXjgq","16":"8kYG4","17":"64ox9","18":"5V9jE","19":"48W5O","20":"pT7Uq","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"f3T9F","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l8uOG":[function() {},{}],"bwIR2":[function() {},{}],"6y4w9":[function() {},{}],"5iQwU":[function() {},{}],"13usb":[function() {},{}],"gsZVi":[function() {},{}],"hAnSt":[function() {},{}],"jpq5u":[function() {},{}],"7jZGc":[function() {},{}],"3qXPb":[function() {},{}],"am0Cr":[function() {},{}],"aYTUY":[function() {},{}],"jaK4u":[function() {},{}],"lW03I":[function() {},{}],"eSeft":[function() {},{}],"eXjgq":[function() {},{}],"8kYG4":[function() {},{}],"64ox9":[function() {},{}],"5V9jE":[function() {},{}],"48W5O":[function() {},{}],"pT7Uq":[function() {},{}],"i1ciP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HCMContext", ()=>HCMContext);
parcelHelpers.export(exports, "HCM", ()=>HCM);
var _jsxRuntime = require("react/jsx-runtime");
var _exampleApp2 = require("./ExampleApp2");
var _react = require("react");
'use client';
const hcm = {
    '--hcm-highlight': 'rgb(26, 235, 255)',
    '--hcm-highlighttext': 'black',
    '--hcm-buttonface': 'black',
    '--hcm-buttontext': 'white',
    '--hcm-buttonborder': 'white',
    '--hcm-graytext': 'rgb(63, 242, 63)',
    '--hcm-field': 'black',
    '--hcm-background': 'black',
    '--hcm-linktext': 'yellow',
    '--hcm-mark': 'yellow'
};
const HCMContext = /*#__PURE__*/ (0, _react.createContext)({});
function HCM() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "data-hcm": true,
        style: hcm,
        className: " _oa11 FH4vLIe11 JB1JKEb11 GuTsfBd11 GnYB8I11 IuTsfBd11 InvzZ2Db11 HuTsfBd11 HnYB8I11 sd11 _Cb11 -jmjrke-od11 -jmjrke-no5NLVAe11 _yb11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: " _va11 Za11 ZnWIyurc11 -_4DHzJc-0u6p5b11",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HCMContext, {
                value: {
                    'data-hcm': true,
                    style: hcm
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleApp2.ExampleApp2), {
                    showPanel: true
                })
            })
        })
    });
}

},{"0":"IQ2ix","1":"lGAEM","react/jsx-runtime":"2Is6Z","./ExampleApp2":"khrJz","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"IQ2ix":[function() {},{}],"lGAEM":[function() {},{}],"cHgid":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountMenu", ()=>AccountMenu);
parcelHelpers.export(exports, "PopoverContextProvider", ()=>PopoverContextProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _settings = require("@react-spectrum/s2/icons/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _buildings = require("@react-spectrum/s2/icons/Buildings");
var _buildingsDefault = parcelHelpers.interopDefault(_buildings);
var _s2 = require("@react-spectrum/s2");
var _reactAria = require("react-aria");
var _react = require("react");
var _utils = require("@react-spectrum/utils");
var _reactAriaComponents = require("react-aria-components");
var _hcm = require("../HCM");
var _exampleApp = require("../ExampleApp");
'use client';
function AccountMenu() {
    let { locale } = (0, _reactAria.useLocale)();
    let { colorScheme, setColorScheme } = (0, _react.useContext)((0, _exampleApp.ColorSchemeContext));
    let prefersDark = (0, _utils.useMediaQuery)('(prefers-color-scheme: dark)');
    let isDark = colorScheme == null ? prefersDark : colorScheme === 'dark';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                isQuiet: true,
                "aria-label": "Account",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Avatar), {
                    src: "https://i.imgur.com/xIe7Wlb.png"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopoverContextProvider, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Popover), {
                    hideArrow: true,
                    placement: "bottom end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " Tp11 sd11 _ta11 Ui9a9Xd11 qi9a9Xd11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: " sd11 Ui9a9Xd11 qi9a9Xd11 eb11 Ii9a9Xd11 Hi9a9Xd11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Avatar), {
                                        src: "https://i.imgur.com/xIe7Wlb.png",
                                        size: 56
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-d11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 plOVIhfc6LxY911 plOVIhfc6LxY911",
                                                children: "Devon Govett"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fd11 _FnuYUweb11 pt11 plOVIhfc6LxY911 plOVIhfc6LxY911",
                                                children: "user@example.com"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Switch), {
                                                isSelected: isDark,
                                                onChange: (isSelected)=>setColorScheme(isSelected ? 'dark' : 'light'),
                                                styles: " JR3ltQc11",
                                                children: locale === 'ar-AE' ? "\u0627\u0644\u0645\u0638\u0647\u0631 \u0627\u0644\u062F\u0627\u0643\u0646" : 'Dark theme'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Divider), {
                                styles: " Ii9a9Xd11 Hi9a9Xd11"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                                "aria-label": "Account",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SubmenuTrigger), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildingsDefault.default), {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                                slot: "label",
                                                                children: locale === 'ar-AE' ? "\u0645\u0646\u0638\u0645\u0629" : 'Organization'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                                slot: "value",
                                                                children: "Adobe"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopoverContextProvider, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                                                            selectionMode: "single",
                                                            selectedKeys: [
                                                                'adobe'
                                                            ],
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                                                    id: "adobe",
                                                                    children: "Adobe"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                                                    id: "nike",
                                                                    children: "Nike"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                                                    id: "apple",
                                                                    children: "Apple"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuItem), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                                        slot: "label",
                                                        children: locale === 'ar-AE' ? "\u0625\u0639\u062F\u0627\u062F\u0627\u062A" : 'Settings'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuSection), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                                children: locale === 'ar-AE' ? "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062A \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629" : 'Legal notices'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                                children: locale === 'ar-AE' ? "\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C" : 'Sign out'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function PopoverContextProvider({ children }) {
    let value = (0, _react.useContext)((0, _reactAriaComponents.PopoverContext));
    let hcm = (0, _react.useContext)((0, _hcm.HCMContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.PopoverContext), {
        value: {
            ...value,
            ...hcm,
            style: {
                ...value?.style,
                ...hcm?.style
            }
        },
        children: children
    });
}

},{"0":"xPyOI","1":"965yh","2":"hVtRf","3":"h4TPR","4":"bXlko","5":"adNyV","react/jsx-runtime":"2Is6Z","@react-spectrum/s2/icons/Settings":"kzvDN","@react-spectrum/s2/icons/Buildings":"81MDh","@react-spectrum/s2":[["ActionButton","lNDRs"],["Avatar","f3T9F"],["Divider","kGk2u"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuSection","1F0Yz"],["MenuTrigger","1F0Yz"],["SubmenuTrigger","1F0Yz"],["Popover","62puW"],["Switch","dIOQS"],["Text","10r6w"]],"react-aria":"4k4z8","react":"a1TxN","@react-spectrum/utils":"5Q3yF","react-aria-components":"l4JC0","../HCM":"i1ciP","../ExampleApp":"ALRve","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"xPyOI":[function() {},{}],"965yh":[function() {},{}],"hVtRf":[function() {},{}],"h4TPR":[function() {},{}],"bXlko":[function() {},{}],"adNyV":[function() {},{}],"kzvDN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.004 12.589c-.888 0-1.753-.46-2.228-1.283-.708-1.228-.286-2.801.94-3.51.593-.343 1.285-.433 1.949-.256.663.178 1.216.604 1.56 1.197.342.594.433 1.286.256 1.949-.178.663-.603 1.216-1.197 1.56-.403.233-.845.343-1.28.343m-.93-2.033c.295.508.949.683 1.46.39.247-.142.424-.373.498-.648s.036-.564-.107-.81c-.143-.248-.373-.425-.649-.499-.275-.073-.563-.035-.81.107-.51.295-.686.949-.391 1.46"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.907 18.318c-.34 0-.682-.085-.992-.264l-.82-.473c-.893-.514-1.25-1.65-.811-2.583l.58-1.233q-.398-.546-.672-1.161l-1.357-.113C1.806 12.406 1 11.531 1 10.5v-.946c0-1.033.805-1.91 1.833-1.994l1.354-.115q.138-.313.302-.6.165-.285.37-.564l-.581-1.23c-.441-.932-.087-2.068.807-2.584l.82-.474c.893-.516 2.054-.259 2.643.59l.777 1.118q.667-.074 1.341 0l.775-1.119c.59-.85 1.751-1.11 2.644-.594l.82.473c.894.516 1.25 1.651.81 2.584l-.58 1.232q.399.548.672 1.161l1.357.113c1.028.085 1.834.96 1.835 1.991v.947c.001 1.031-.803 1.907-1.832 1.994l-1.355.115q-.136.313-.303.6-.164.284-.368.563l.58 1.23c.441.93.087 2.067-.806 2.584l-.82.475c-.894.518-2.054.258-2.643-.591l-.778-1.118q-.67.073-1.34 0l-.777 1.12c-.384.555-1.012.857-1.65.857M6.904 3.225q-.13 0-.248.066l-.82.475c-.223.129-.312.412-.202.645l.78 1.65c.125.267.083.583-.108.807-.204.24-.373.477-.517.726q-.212.37-.368.81c-.098.278-.35.472-.644.496l-1.819.154c-.262.022-.458.236-.458.499v.946c0 .258.202.477.459.498l1.82.15c.293.025.546.22.644.498.2.56.497 1.076.887 1.532.192.223.234.54.109.806l-.778 1.653c-.11.233-.02.517.203.645l.82.474c.224.13.514.063.66-.148l1.041-1.502c.168-.242.46-.369.753-.31.588.108 1.184.11 1.77 0 .29-.055.585.066.753.31l1.042 1.499c.147.21.439.276.66.147l.821-.474c.226-.13.314-.409.201-.646l-.779-1.65c-.126-.267-.084-.583.108-.807.204-.24.373-.477.515-.725h.001c.143-.248.263-.512.369-.81.098-.279.35-.473.644-.497l1.819-.153c.256-.022.458-.24.458-.499l-.001-.947c0-.262-.197-.476-.459-.498l-1.819-.15c-.294-.025-.546-.22-.645-.498-.198-.56-.496-1.075-.887-1.532-.191-.224-.234-.54-.108-.806l.777-1.653c.11-.233.02-.517-.203-.646l-.82-.473c-.224-.127-.514-.061-.66.15l-1.04 1.5c-.168.243-.46.368-.753.31-.591-.11-1.188-.11-1.77 0-.292.052-.586-.067-.754-.31L7.316 3.439c-.096-.137-.253-.213-.412-.213"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"81MDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 17H15c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.75c.414 0 .75-.337.75-.75v-6.5c0-.413-.336-.75-.75-.75H15c-.414 0-.75-.336-.75-.75S14.586 6 15 6h1.75C17.99 6 19 7.01 19 8.25v6.5c0 1.24-1.01 2.25-2.25 2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 9,
                cy: 7,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 10,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 7,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 3h-7.5C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h7.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C13 4.01 11.99 3 10.75 3M8.249 15.5H5.75v-1c0-.413.336-.75.75-.75h.999c.413 0 .75.337.75.75zm3.251-.75c0 .413-.336.75-.75.75H9.749v-1c0-1.24-1.01-2.25-2.25-2.25H6.5c-1.24 0-2.25 1.01-2.25 2.25v1h-1c-.414 0-.75-.337-.75-.75v-9.5c0-.413.336-.75.75-.75h7.5c.414 0 .75.337.75.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 9,
                cy: 10,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 15,
                cy: 10,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 15,
                cy: 13,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l3txx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notifications", ()=>Notifications);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _bell = require("@react-spectrum/s2/icons/Bell");
var _bellDefault = parcelHelpers.interopDefault(_bell);
var _typography = require("../Typography");
var _accountMenu = require("./AccountMenu");
var _reactAria = require("react-aria");
const COMMENTS = [
    {
        author: 'Nikolas Gibbons',
        avatar: 'https://www.untitledui.com/images/avatars/nikolas-gibbons',
        date: '2 hours ago',
        body: 'Thanks for the feedback!'
    },
    {
        author: 'Adriana Sullivan',
        avatar: 'https://www.untitledui.com/images/avatars/adriana-sullivan',
        date: 'July 14',
        body: 'Transitions are smooth! Could we speed them up just a bit?'
    },
    {
        author: 'Frank Whitaker',
        avatar: 'https://www.untitledui.com/images/avatars/frank-whitaker?',
        date: 'July 13',
        body: 'Love the direction. Could we simplify the header a bit more?'
    }
];
const ARABIC_COMMENTS = [
    {
        author: "\u064A\u0648\u0633\u0641 \u0627\u0644\u0639\u062A\u064A\u0628\u064A",
        avatar: 'https://www.untitledui.com/images/avatars/nikolas-gibbons',
        date: "\u0645\u0646\u0630 \u0633\u0627\u0639\u062A\u064A\u0646",
        body: "\u0634\u0643\u0631\u0627 \u0639\u0644\u0649 \u062A\u0639\u0644\u064A\u0642\u0627\u062A\u0643!"
    },
    {
        author: "\u0644\u064A\u0644\u0649 \u0627\u0644\u0633\u0627\u0644\u0645",
        avatar: 'https://www.untitledui.com/images/avatars/adriana-sullivan',
        date: "14 \u064A\u0648\u0644\u064A\u0648",
        body: "\u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644\u0627\u062A \u0633\u0644\u0633\u0629! \u0647\u0644 \u064A\u0645\u0643\u0646\u0646\u0627 \u062A\u0633\u0631\u064A\u0639\u0647\u0627 \u0642\u0644\u064A\u0644\u0627\u064B\u061F"
    },
    {
        author: "\u062E\u0627\u0644\u062F \u0628\u0646 \u0631\u0634\u064A\u062F",
        avatar: 'https://www.untitledui.com/images/avatars/frank-whitaker?',
        date: "13 \u064A\u0648\u0644\u064A\u0648",
        body: "\u0623\u0639\u062C\u0628\u0646\u064A \u0627\u0644\u0627\u062A\u062C\u0627\u0647. \u0647\u0644 \u064A\u064F\u0645\u0643\u0646\u0646\u0627 \u062A\u0628\u0633\u064A\u0637 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0623\u0643\u062B\u0631\u061F"
    }
];
function Notifications() {
    let { locale } = (0, _reactAria.useLocale)();
    let comments = locale === 'ar-AE' ? ARABIC_COMMENTS : COMMENTS;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.DialogTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButton), {
                isQuiet: true,
                "aria-label": "3 notifications",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bellDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NotificationBadge), {
                        value: 3
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountMenu.PopoverContextProvider), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Popover), {
                    styles: " LtW6OHc11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd11 _ta11 UkmMJWb11 _Na11 Pa11 _ub11 Ma11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-e11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 plOVIhfc6LxY911 plOVIhfc6LxY911 JYB8I11 GYB8I11",
                                children: locale === 'ar-AE' ? "\u0625\u0634\u0639\u0627\u0631\u0627\u062A" : 'Notifications'
                            }),
                            comments.map((comment, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typography.Comment), {
                                    ...comment
                                }, i))
                        ]
                    })
                })
            })
        ]
    });
}

},{"0":"9Zkhm","1":"61GEs","2":"5oq5m","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["DialogTrigger","eu4Kx"],["NotificationBadge","czhBl"],["Popover","62puW"]],"@react-spectrum/s2/icons/Bell":"iCEaV","../Typography":"1wAS5","./AccountMenu":"cHgid","react-aria":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Zkhm":[function() {},{}],"61GEs":[function() {},{}],"5oq5m":[function() {},{}],"iCEaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.786 12.676q-.253-.462-.511-.903c-.827-1.434-1.541-2.672-1.541-4.62 0-3.119-2.538-5.657-5.657-5.657S4.419 4.034 4.419 7.153c0 1.767-.758 3.05-1.562 4.406-.22.372-.441.746-.649 1.13-.376.697-.357 1.521.05 2.205.413.69 1.137 1.102 1.94 1.102H7.25c0 1.517 1.233 2.75 2.75 2.75s2.75-1.233 2.75-2.75h3.055c.803 0 1.528-.413 1.939-1.105.407-.688.423-1.516.042-2.215M10 17.246c-.69 0-1.25-.56-1.25-1.25h2.5c0 .69-.561 1.25-1.25 1.25m6.454-3.121c-.067.111-.263.371-.65.371H4.198c-.268 0-.511-.139-.65-.371-.065-.108-.195-.396-.019-.723.199-.368.41-.724.62-1.079.871-1.47 1.771-2.992 1.771-5.17 0-2.254 1.904-4.157 4.158-4.157s4.157 1.903 4.157 4.157c0 2.349.885 3.884 1.742 5.37.164.285.33.573.493.872.18.33.05.62-.015.73"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cLTse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Photos", ()=>Photos);
parcelHelpers.export(exports, "PhotoCard", ()=>PhotoCard);
var _jsxRuntime = require("react/jsx-runtime");
var _viewGridFluid = require("@react-spectrum/s2/icons/ViewGridFluid");
var _viewGridFluidDefault = parcelHelpers.interopDefault(_viewGridFluid);
var _viewGrid = require("@react-spectrum/s2/icons/ViewGrid");
var _viewGridDefault = parcelHelpers.interopDefault(_viewGrid);
var _s2 = require("@react-spectrum/s2");
var _reactAria = require("react-aria");
var _reactStately = require("react-stately");
var _react = require("react");
var _reactDom = require("react-dom");
'use client';
const pages = [
    ()=>require("4e51b25c30a5524a"),
    ()=>require("61fccfa9ff503107"),
    ()=>require("d4f9bb91aa163bfd"),
    ()=>require("4f2fb84a2414baa6")
];
function Photos(props) {
    let [layout, setLayout] = (0, _react.useState)('waterfall');
    let { direction } = (0, _reactAria.useLocale)();
    let list = (0, _reactStately.useAsyncList)({
        async load ({ cursor, items }) {
            let page = cursor || 1;
            let next = pages[page - 1];
            if (!next) return {
                items: []
            };
            let nextItems = await next();
            // Filter duplicates which might be returned by the API.
            let existingKeys = new Set(items.map((i)=>i.id));
            nextItems = nextItems.filter((i)=>!existingKeys.has(i.id) && (i.description || i.alt_description));
            return {
                items: nextItems,
                cursor: nextItems.length ? page + 1 : null
            };
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " sd11 _Ce11 eb11 GH5kTnc11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-g11 vFHT6Dd11 xe11 _xa11 xX0cczbd11 _xX0cczba11 xfe11 _xfa11 xfX0cczbd11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11",
                        children: direction === 'rtl' ? "\u0627\u0644\u0635\u0648\u0631" : 'Photos'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.SegmentedControl), {
                        selectedKey: layout,
                        onSelectionChange: setLayout,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                                id: "waterfall",
                                "aria-label": "Waterfall",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _viewGridFluidDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SegmentedControlItem), {
                                id: "grid",
                                "aria-label": "Grid",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _viewGridDefault.default), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.CardView), {
                "aria-label": "Nature photos",
                size: "S",
                layout: layout,
                // selectionMode="multiple"
                // selectionStyle={list.selectedKeys === 'all' || list.selectedKeys.size > 0 ? 'checkbox' : 'highlight'}
                selectedKeys: list.selectedKeys,
                onSelectionChange: list.setSelectedKeys,
                variant: "quiet",
                loadingState: list.loadingState,
                onLoadMore: list.loadMore,
                styles: " _ub11 Ma11 Kdrw1ne11 IJGwHDc11 HJGwHDc11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Collection), {
                        items: list.items,
                        dependencies: [
                            layout
                        ],
                        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PhotoCard, {
                                item: item,
                                layout: layout,
                                onAction: props.onAction
                            })
                    }),
                    (list.loadingState === 'loading' || list.loadingState === 'loadingMore') && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SkeletonCollection), {
                        children: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PhotoCard, {
                                item: {
                                    id: Math.random(),
                                    user: {
                                        name: 'Placeholder name',
                                        profile_image: {
                                            small: ''
                                        }
                                    },
                                    urls: {
                                        regular: ''
                                    },
                                    description: 'This is a fake description. Kinda long so it wraps to a new line.',
                                    alt_description: '',
                                    width: 400,
                                    height: 200 + Math.max(0, Math.round(Math.random() * 400))
                                },
                                layout: layout
                            })
                    })
                ]
            })
        ]
    });
}
function PhotoCard({ item, layout, onAction, styles }) {
    let imgRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Card), {
        id: item.id,
        styles: styles,
        textValue: item.description || item.alt_description,
        onAction: onAction && (()=>{
            if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
                onAction([
                    item,
                    imgRef.current
                ]);
                return;
            }
            imgRef.current.style.viewTransitionName = 'photo';
            document.startViewTransition(()=>{
                imgRef.current.style.viewTransitionName = '';
                (0, _reactDom.flushSync)(()=>onAction([
                        item,
                        imgRef.current
                    ]));
            });
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Image), {
                ref: imgRef,
                "data-photo-id": item.id,
                src: item.urls.regular,
                width: item.width,
                height: item.height,
                UNSAFE_style: {
                    aspectRatio: layout === 'waterfall' ? `${item.width} / ${item.height}` : undefined
                }
            })
        })
    });
}

},{"0":"dokGJ","1":"8qnNi","2":"cCO5H","react/jsx-runtime":"2Is6Z","@react-spectrum/s2/icons/ViewGridFluid":"bZCJ3","@react-spectrum/s2/icons/ViewGrid":"iwUs6","@react-spectrum/s2":[["Card","jxfoI"],["CardPreview","jxfoI"],["CardView","7Sr64"],["Collection","2Jd0Q"],["Image","4LTiE"],["SegmentedControl","hnIYG"],["SegmentedControlItem","hnIYG"],["SkeletonCollection","f83W7"]],"react-aria":"4k4z8","react-stately":"7TSdz","react":"a1TxN","react-dom":"gC2PC","4e51b25c30a5524a":"fbfyY","61fccfa9ff503107":"cOkfE","d4f9bb91aa163bfd":"8ZHqc","4f2fb84a2414baa6":"8niGK","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dokGJ":[function() {},{}],"8qnNi":[function() {},{}],"cCO5H":[function() {},{}],"f83W7":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonCollection", ()=>SkeletonCollection);
var _jsxRuntime = require("react/jsx-runtime");
var _collections = require("@react-aria/collections");
var _skeleton = require("./Skeleton");
let cache = new WeakMap();
class SkeletonNode extends (0, _collections.CollectionNode) {
    static{
        this.type = 'skeleton';
    }
}
const SkeletonCollection = (0, _collections.createLeafComponent)(SkeletonNode, (props, ref, node)=>{
    // Cache rendering based on node object identity. This allows the children function to randomize
    // its content (e.g. heights) and preserve on re-renders.
    // TODO: do we need a `dependencies` prop here?
    let cached = cache.get(node);
    if (!cached) {
        cached = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.Skeleton), {
            isLoading: true,
            children: props.children()
        });
        cache.set(node, cached);
    }
    return cached;
});

},{"react/jsx-runtime":"2Is6Z","@react-aria/collections":[["CollectionNode","ab6Rh"],["createLeafComponent","2Jd0Q"]],"./Skeleton":"1mUnF","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7TSdz":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable async loaded list data structure, and provides convenience methods to
 * update the data over time. Manages loading and error states, pagination, and sorting.
 */ parcelHelpers.export(exports, "useAsyncList", ()=>useAsyncList);
var _useListData = require("./useListData");
var _react = require("react");
function reducer(data, action) {
    let selectedKeys;
    switch(data.state){
        case 'idle':
        case 'error':
            switch(action.type){
                case 'loading':
                case 'loadingMore':
                case 'sorting':
                case 'filtering':
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: action.abortController
                    };
                case 'update':
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                case 'success':
                case 'error':
                    return data;
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case 'loading':
        case 'sorting':
        case 'filtering':
            switch(action.type){
                case 'success':
                    // Ignore if there is a newer abortcontroller in state.
                    // This means that multiple requests were going at once.
                    // We want to take only the latest result.
                    if (action.abortController !== data.abortController) return data;
                    selectedKeys = action.selectedKeys ?? data.selectedKeys;
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: 'idle',
                        items: [
                            ...action.items ?? []
                        ],
                        selectedKeys: selectedKeys === 'all' ? 'all' : new Set(selectedKeys),
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: undefined,
                        cursor: action.cursor
                    };
                case 'error':
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: 'error',
                        error: action.error,
                        abortController: undefined
                    };
                case 'loading':
                case 'loadingMore':
                case 'sorting':
                case 'filtering':
                    // We're already loading, and another load was triggered at the same time.
                    // We need to abort the previous load and start a new one.
                    data.abortController?.abort('aborting current load and starting new one');
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        abortController: action.abortController
                    };
                case 'update':
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case 'loadingMore':
            switch(action.type){
                case 'success':
                    selectedKeys = data.selectedKeys === 'all' || action.selectedKeys === 'all' ? 'all' : new Set([
                        ...data.selectedKeys,
                        ...action.selectedKeys ?? []
                    ]);
                    // Append the new items
                    return {
                        ...data,
                        state: 'idle',
                        items: [
                            ...data.items,
                            ...action.items ?? []
                        ],
                        selectedKeys,
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: undefined,
                        cursor: action.cursor
                    };
                case 'error':
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: 'error',
                        error: action.error
                    };
                case 'loading':
                case 'sorting':
                case 'filtering':
                    // We're already loading more, and another load was triggered at the same time.
                    // We need to abort the previous load more and start a new one.
                    data.abortController?.abort();
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        abortController: action.abortController
                    };
                case 'loadingMore':
                    // If already loading more and another loading more is triggered, abort the new load more since
                    // it is a duplicate request since the cursor hasn't been updated.
                    // Do not overwrite the data.abortController
                    action.abortController?.abort();
                    return data;
                case 'update':
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        default:
            throw new Error(`Invalid state "${data.state}"`);
    }
}
function useAsyncList(options) {
    const { load, sort, initialSelectedKeys, initialSortDescriptor, getKey = (item)=>item.id || item.key, initialFilterText = '' } = options;
    let [data, dispatch] = (0, _react.useReducer)(reducer, {
        state: 'idle',
        error: undefined,
        items: [],
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys),
        sortDescriptor: initialSortDescriptor,
        filterText: initialFilterText
    });
    const dispatchFetch = async (action, fn)=>{
        let abortController = new AbortController();
        try {
            dispatch({
                ...action,
                abortController
            });
            let previousFilterText = action.filterText ?? data.filterText;
            let response = await fn({
                items: data.items.slice(),
                selectedKeys: data.selectedKeys,
                sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                signal: abortController.signal,
                cursor: action.type === 'loadingMore' ? data.cursor : undefined,
                filterText: previousFilterText,
                loadingState: data.state
            });
            let filterText = response.filterText ?? previousFilterText;
            dispatch({
                type: 'success',
                ...response,
                abortController
            });
            // Fetch a new filtered list if filterText is updated via `load` response func rather than list.setFilterText
            // Only do this if not aborted (e.g. user triggers another filter action before load completes)
            if (filterText && filterText !== previousFilterText && !abortController.signal.aborted) dispatchFetch({
                type: 'filtering',
                filterText
            }, load);
        } catch (e) {
            dispatch({
                type: 'error',
                error: e,
                abortController
            });
        }
    };
    let didDispatchInitialFetch = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!didDispatchInitialFetch.current) {
            dispatchFetch({
                type: 'loading'
            }, load);
            didDispatchInitialFetch.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        items: data.items,
        selectedKeys: data.selectedKeys,
        sortDescriptor: data.sortDescriptor,
        isLoading: data.state === 'loading' || data.state === 'loadingMore' || data.state === 'sorting' || data.state === 'filtering',
        loadingState: data.state,
        error: data.error,
        filterText: data.filterText,
        getItem (key) {
            return data.items.find((item)=>getKey(item) === key);
        },
        reload () {
            dispatchFetch({
                type: 'loading'
            }, load);
        },
        loadMore () {
            // Ignore if already loading more or if performing server side filtering.
            if (data.state === 'loading' || data.state === 'loadingMore' || data.state === 'filtering' || data.cursor == null) return;
            dispatchFetch({
                type: 'loadingMore'
            }, load);
        },
        sort (sortDescriptor) {
            dispatchFetch({
                type: 'sorting',
                sortDescriptor
            }, sort || load);
        },
        ...(0, _useListData.createListActions)({
            ...options,
            getKey,
            cursor: data.cursor
        }, (fn)=>{
            dispatch({
                type: 'update',
                updater: fn
            });
        }),
        setFilterText (filterText) {
            dispatchFetch({
                type: 'filtering',
                filterText
            }, load);
        }
    };
}

},{"./useListData":"5lXoQ","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5lXoQ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable list data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useListData", ()=>useListData);
parcelHelpers.export(exports, "createListActions", ()=>createListActions);
var _react = require("react");
function useListData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id ?? item.key, filter, initialFilterText = '' } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, _react.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, _react.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...createListActions({
            getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function createListActions(opts, dispatch) {
    let { cursor, getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys
                }));
        },
        addKeysToSelection (selectedKeys) {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return state;
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: 'all'
                };
                return {
                    ...state,
                    selectedKeys: new Set([
                        ...state.selectedKeys,
                        ...selectedKeys
                    ])
                };
            });
        },
        removeKeysFromSelection (selectedKeys) {
            dispatch((state)=>{
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: new Set()
                };
                let selection = state.selectedKeys === 'all' ? new Set(state.items.map(getKey)) : new Set(state.selectedKeys);
                for (let key of selectedKeys)selection.delete(key);
                return {
                    ...state,
                    selectedKeys: selection
                };
            });
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = 'all';
                if (state.selectedKeys !== 'all') {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let updatedValue;
                if (typeof newValue === 'function') updatedValue = newValue(state.items[index]);
                else updatedValue = newValue;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        updatedValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fbfyY":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
let promise = Promise.all([
    module.bundle.load("kQzNc")
]).then(()=>{
    let originalModule = module.bundle.root("91ZFR");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
        rel: "modulepreload",
        href: module.bundle.resolve("kQzNc")
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ"}],"iKyDQ":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /* eslint-disable react/react-in-jsx-scope */ /* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResourcesProxy", ()=>createResourcesProxy);
parcelHelpers.export(exports, "waitForCSS", ()=>waitForCSS);
var _jsxRuntime = require("react/jsx-runtime");
function createResourcesProxy(module, esModule, resources, bootstrapScript) {
    if (typeof module === 'function') return createResourcesValueProxy(module, resources, bootstrapScript);
    return new Proxy(module, {
        get (target, prop, receiver) {
            if (prop === '__esModule' && esModule) return true;
            let value = Reflect.get(target, prop, receiver);
            return createResourcesValueProxy(value, resources, bootstrapScript);
        }
    });
}
let cache = new WeakMap();
function createResourcesValueProxy(value, resources, bootstrapScript) {
    if (typeof value === 'function') {
        let cached = cache.get(value);
        if (cached) return cached;
        // Detect reads of `Component.prototype.isReactComponent` or `Component.$$typeof`
        // prior to the function being called as an indication that this is a React component.
        // If so, inject the resources as a sibling of the return value.
        let isReactComponent = false;
        let prototypeProxy;
        if (typeof value.prototype === 'object') prototypeProxy = new Proxy(value.prototype, {
            get (target, prop, receiver) {
                if (prop === 'isReactComponent') isReactComponent = true;
                return Reflect.get(target, prop, receiver);
            }
        });
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                if (prototypeProxy && prop === 'prototype' && Object.getOwnPropertyDescriptor(target, 'prototype').configurable) return prototypeProxy;
                if (prop === '$$typeof') isReactComponent = true;
                if (bootstrapScript && prop === 'bootstrapScript') return bootstrapScript;
                return Reflect.get(target, prop, receiver);
            },
            apply (target, thisArg, args) {
                let result = Reflect.apply(target, thisArg, args);
                if (isReactComponent) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        resources,
                        result
                    ]
                });
                return result;
            }
        });
        cache.set(value, proxy);
        return proxy;
    } else if (value && typeof value === 'object') {
        let cached = cache.get(value);
        if (cached) return cached;
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                let value = Reflect.get(target, prop, receiver);
                return createResourcesValueProxy(value, resources, bootstrapScript);
            }
        });
        cache.set(value, proxy);
        return proxy;
    }
    return value;
}
function waitForCSS(url) {
    return new Promise((resolve, reject)=>{
        if (typeof document === 'undefined') return resolve();
        // Find a link element corresponding to this URL.
        let link = document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(url)}"]`);
        if (!link) return resolve();
        // If the link element already has a stylesheet associated with it, then it is already loaded.
        if (link.sheet) return resolve();
        link.addEventListener('load', ()=>{
            resolve();
        });
        link.addEventListener('error', (e)=>{
            reject(e);
        });
    });
}

},{"react/jsx-runtime":"2Is6Z","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"46txg":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("kQzNc").then(()=>module.bundle.root('91ZFR'));

},{}],"cOkfE":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
let promise = Promise.all([
    module.bundle.load("4XBUW")
]).then(()=>{
    let originalModule = module.bundle.root("4aS67");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
        rel: "modulepreload",
        href: module.bundle.resolve("4XBUW")
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ"}],"gBAO7":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("4XBUW").then(()=>module.bundle.root('4aS67'));

},{}],"8ZHqc":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
let promise = Promise.all([
    module.bundle.load("aarsO")
]).then(()=>{
    let originalModule = module.bundle.root("b5lTU");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
        rel: "modulepreload",
        href: module.bundle.resolve("aarsO")
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ"}],"cOXUh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("aarsO").then(()=>module.bundle.root('b5lTU'));

},{}],"8niGK":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
let promise = Promise.all([
    module.bundle.load("dvJA0")
]).then(()=>{
    let originalModule = module.bundle.root("2JLKP");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
        rel: "modulepreload",
        href: module.bundle.resolve("dvJA0")
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ"}],"jDPHI":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("dvJA0").then(()=>module.bundle.root('2JLKP'));

},{}],"lWRGx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sidebar", ()=>Sidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _add = require("@react-spectrum/s2/icons/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _home = require("@react-spectrum/s2/icons/Home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _image = require("@react-spectrum/s2/icons/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _lightbulb = require("@react-spectrum/s2/icons/Lightbulb");
var _lightbulbDefault = parcelHelpers.interopDefault(_lightbulb);
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
'use client';
const SM = `@container (min-width: ${40}rem)`;
const LG = `@container (width > ${64}rem)`;
const textStyle = function anonymous(props) {
    let rules = " ";
    if (props.state === "collapsed") rules += ' _Ia11';
    else if (props.state === "expanded") rules += ' _Ib11';
    else {
        rules += ' _Ia11';
        rules += ' _IbkYqPbb11';
    }
    rules += ' Yd11';
    rules += ' XCIisn11';
    rules += ' _2b11';
    return rules;
};
function Sidebar({ page, onPageChange }) {
    let [state, setState] = (0, _react.useState)(null);
    let { locale } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' zLpqDSc11';
            rules += ' yLpqDSc11';
            rules += ' BLpqDSc11';
            rules += ' ALpqDSc11';
            rules += ' sk11';
            rules += ' sWyB2jbd11';
            rules += ' _ta11';
            rules += ' UH5kTnc11';
            rules += ' qH5kTnc11';
            rules += ' Sf11';
            rules += ' Rf11';
            rules += ' Qf11';
            if (props.state === "collapsed") rules += ' Z4dY0ec11';
            else if (props.state === "expanded") rules += ' ZHD7UZb11';
            else {
                rules += ' Z4dY0ec11';
                rules += ' ZbkYqPbHD7UZb11';
            }
            rules += ' _Nb11';
            rules += ' Pb11';
            rules += ' YVdv3s11';
            rules += ' XCIisn11';
            rules += ' _2b11';
            return rules;
        }({
            state
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Button), {
                variant: "accent",
                styles: function anonymous(props) {
                    let rules = " ";
                    rules += ' GH5kTnc11';
                    if (props.state === "collapsed") rules += ' Z4dY0ec11';
                    else if (props.state === "expanded") rules += ' ZF3XZgc11';
                    else {
                        rules += ' Z4dY0ec11';
                        rules += ' ZbkYqPbF3XZgc11';
                    }
                    return rules;
                }({
                    state
                }),
                UNSAFE_style: {
                    alignItems: 'center',
                    justifyContent: 'start',
                    overflow: 'clip',
                    transition: 'all 300ms'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: " I1cJjHb11",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: textStyle({
                            state
                        }),
                        children: locale === 'ar-AE' ? "\u064A\u062E\u0644\u0642" : 'Create'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SideNav, {
                "aria-label": "Navigation",
                isQuiet: true,
                orientation: "vertical",
                selectedKeys: [
                    page || 'photos'
                ],
                onSelectionChange: (keys)=>onPageChange?.([
                        ...keys
                    ][0]),
                disallowEmptySelection: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SideNavItem, {
                        id: "home",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: textStyle({
                                    state
                                }),
                                children: locale === 'ar-AE' ? "\u0628\u064A\u062A" : 'Home'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SideNavItem, {
                        id: "photos",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: textStyle({
                                    state
                                }),
                                children: locale === 'ar-AE' ? "\u0627\u0644\u0635\u0648\u0631" : 'Photos'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SideNavItem, {
                        id: "ideas",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lightbulbDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: textStyle({
                                    state
                                }),
                                children: locale === 'ar-AE' ? "\u0623\u0641\u0643\u0627\u0631" : 'Ideas'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _ub11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PanelToggleButton, {
                state: state,
                setState: setState
            })
        ]
    });
}
function PanelToggleButton({ state, setState }) {
    let [isHovered, setHovered] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
        isQuiet: true,
        "aria-label": "Toggle sidebar",
        styles: " _de11",
        // @ts-ignore - should we expose this?
        onHoverChange: setHovered,
        onPress: (e)=>{
            if (state == null) {
                let container = e.target.closest('[data-container]');
                setState(container?.offsetWidth > 1024 ? 'collapsed' : 'expanded');
            } else setState(state === 'expanded' ? 'collapsed' : 'expanded');
            setHovered(false);
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PanelIcon, {
            state: state,
            isHovered: isHovered
        })
    });
}
const PanelIcon = (0, _s2.createIcon)((props1)=>{
    let { state, isHovered, ...otherProps } = props1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 20 20",
        fill: "var(--iconPrimary)",
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M15.75 18H4.25C3.00977 18 2 16.9907 2 15.75V4.25C2 3.00928 3.00977 2 4.25 2H15.75C16.9902 2 18 3.00928 18 4.25V15.75C18 16.9907 16.9902 18 15.75 18ZM4.25 3.5C3.83691 3.5 3.5 3.83643 3.5 4.25V15.75C3.5 16.1636 3.83691 16.5 4.25 16.5H15.75C16.1631 16.5 16.5 16.1636 16.5 15.75V4.25C16.5 3.83643 16.1631 3.5 15.75 3.5H4.25Z",
                fill: "var(--iconPrimary)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: 5,
                y: 5,
                rx: 0.5,
                height: 10,
                className: function anonymous(props) {
                    let rules = " ";
                    rules += ' YVdv3s11';
                    rules += ' XCIisn11';
                    rules += ' _2b11';
                    if (props.isHovered) {
                        if (props.state === "collapsed") rules += ' ZsmOfn11';
                        else if (props.state === "expanded") rules += ' Zlr4hn11';
                        else {
                            rules += ' ZsmOfn11';
                            rules += ' ZbkYqPblr4hn11';
                        }
                    } else if (props.state === "collapsed") rules += ' Zlr4hn11';
                    else if (props.state === "expanded") rules += ' ZsmOfn11';
                    else {
                        rules += ' Zlr4hn11';
                        rules += ' ZbkYqPbsmOfn11';
                    }
                    return rules;
                }({
                    state,
                    isHovered
                })
            })
        ]
    });
});
// Fake sidenav component until we have a real one
function SideNav(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButtonGroup), {
        ...props,
        className: " IiBH1vb11 sd11 _ta11 UH5kTnc11 qH5kTnc11 _oa11 Za11"
    });
}
function SideNavItem(props1) {
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ToggleButton), {
        ...props1,
        ref: ref,
        style: (0, _s2.pressScale)(ref),
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Lf11';
            else rules += ' _Le11';
            rules += ' Oh11';
            rules += ' OlOVIhfcebS7sd11';
            rules += ' OlOVIhfcebS7sd11';
            rules += ' _Mc11';
            rules += ' _Kd11';
            rules += ' g911';
            rules += ' _je11';
            rules += ' Za11';
            rules += ' M4dY0ec11';
            rules += ' _oa11';
            rules += ' Td11';
            rules += ' Qd11';
            rules += ' Sd11';
            rules += ' Rd11';
            rules += ' sd11';
            rules += ' eb11';
            rules += ' UH5kTnc11';
            rules += ' qH5kTnc11';
            rules += ' uk11';
            rules += ' ucJ9TBTb11';
            rules += ' ud3Euai11';
            rules += ' uea11';
            rules += ' ugb11';
            rules += ' uhd11';
            rules += ' uje11';
            rules += ' u2NhKxcl11';
            rules += ' uic11';
            rules += ' -_6BNtrc-c11';
            rules += ' vFHT6Dd11';
            if (props.isSelected) {
                rules += ' xd11';
                rules += ' _xa11';
                rules += ' xX0cczbc11';
                rules += ' _xX0cczba11';
            } else {
                rules += ' xb11';
                rules += ' _xa11';
            }
            rules += ' _Fd11';
            rules += ' _FnuYUweb11';
            rules += ' pt11';
            rules += ' _Xa11';
            rules += ' oH5kTnc11';
            rules += ' nH5kTnc11';
            rules += ' kH5kTnc11';
            rules += ' jH5kTnc11';
            rules += ' Yd11';
            rules += ' Xb11';
            rules += ' _2b11';
            return rules;
        },
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' _va11';
                            rules += ' ZkqjWPe11';
                            rules += ' FObNfn11';
                            rules += ' og11';
                            rules += ' ng11';
                            rules += ' kg11';
                            rules += ' jg11';
                            rules += ' Yd11';
                            rules += ' Xb11';
                            rules += ' _2b11';
                            if (props.isSelected) rules += ' g011';
                            else if (props.isHovered) rules += ' gw11';
                            else rules += ' g911';
                            return rules;
                        }(renderProps)
                    }),
                    props1.children
                ]
            })
    });
}

},{"0":"8jQpY","1":"jMnHz","2":"kM6CD","3":"hFrc4","4":"5aYoc","5":"21Xql","6":"8YweB","7":"8WOS3","8":"5dSm9","9":"bt0Jn","react/jsx-runtime":"2Is6Z","@react-spectrum/s2/icons/Add":"brWL3","@react-spectrum/s2/icons/Home":"eGxUY","@react-spectrum/s2/icons/Image":"ld4zI","@react-spectrum/s2/icons/Lightbulb":"2jxDj","@react-spectrum/s2":[["ActionButton","lNDRs"],["Button","gZHck"],["createIcon","jQAJE"],["pressScale","8Ufux"]],"react":"a1TxN","react-aria-components":[["ToggleButton","98v4o"],["ToggleButtonGroup","8CiqT"],["useLocale","4k4z8"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8jQpY":[function() {},{}],"jMnHz":[function() {},{}],"kM6CD":[function() {},{}],"hFrc4":[function() {},{}],"5aYoc":[function() {},{}],"21Xql":[function() {},{}],"8YweB":[function() {},{}],"8WOS3":[function() {},{}],"5dSm9":[function() {},{}],"bt0Jn":[function() {},{}],"brWL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 9.25h-5.5v-5.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v5.5h-5.5c-.414 0-.75.336-.75.75s.336.75.75.75h5.5v5.5c0 .414.336.75.75.75s.75-.336.75-.75v-5.5h5.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ld4zI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.5 7.521c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3M3.25 4.5h13.5c.413 0 .75.337.75.75v8.21l-1.91-1.908c-.876-.877-2.304-.877-3.18 0l-1.232 1.231c-.1.098-.257.097-.355.001L7.591 9.552c-.85-.85-2.332-.85-3.182 0L2.5 11.46V5.25c0-.413.337-.75.75-.75m0 11c-.413 0-.75-.337-.75-.75v-1.168l2.97-2.97c.293-.293.767-.293 1.06 0l3.234 3.234c.681.68 1.792.68 2.473-.001l1.233-1.233c.293-.293.767-.293 1.06 0l2.701 2.701c-.131.112-.296.187-.481.187z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3Ke2l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HomePage", ()=>HomePage);
parcelHelpers.export(exports, "HomeArrows", ()=>HomeArrows);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _dropToUpload = require("@react-spectrum/s2/illustrations/gradient/generic2/DropToUpload");
var _dropToUploadDefault = parcelHelpers.interopDefault(_dropToUpload);
var _aigenerateImage = require("@react-spectrum/s2/illustrations/gradient/generic2/AIGenerateImage");
var _aigenerateImageDefault = parcelHelpers.interopDefault(_aigenerateImage);
var _magicWand = require("@react-spectrum/s2/illustrations/gradient/generic2/MagicWand");
var _magicWandDefault = parcelHelpers.interopDefault(_magicWand);
var _properties = require("@react-spectrum/s2/illustrations/gradient/generic2/Properties");
var _propertiesDefault = parcelHelpers.interopDefault(_properties);
// @ts-ignore
var _bannerSvg = require("./banner.svg");
var _bannerSvgDefault = parcelHelpers.interopDefault(_bannerSvg);
var _photos = require("./Photos");
var _arrows = require("./Arrows");
var _react = require("react");
'use client';
function HomePage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " sd11 _ta11 Za11 Fb11 Qk11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " Sk11 Rk11 Tm11 Qm11 _va11 GerlM8c11 _oa11 sd11 _ta11 _Ca11 o5NLVAe11 n5NLVAe11 k5NLVAe11 j5NLVAe11 _Nb11 Pb11",
                style: {
                    position: 'relative',
                    isolation: 'isolate'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bannerSvgDefault.default), {
                        style: {
                            position: 'absolute',
                            zIndex: -1,
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%'
                        },
                        preserveAspectRatio: "none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: " JYB8I11 uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-g11 vFHT6Dd11 xe11 _xa11 xX0cczbd11 _xX0cczba11 xfe11 _xfa11 xfX0cczbd11 _xfX0cczba11 _Fd11 _FnuYUweb11 pm11",
                        children: "Find faster with semantic search"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-d11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 pm11 JYB8I11 GerlM8c11",
                        children: "Quickly find visuals, words, sounds, and more in your media."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                        staticColor: "auto",
                        children: "Watch tutorial"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-e11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11",
                children: "Get started"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " sd11 UB1JKEb11 qB1JKEb11 Tf11 Qf11 Sf11 Rf11 JuTsfBd11 GuTsfBd11 IuTsfBd11 HuTsfBd11 _va11 FF11 _Na11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.DropZone), {
                        styles: " _u3mU11 _va11",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.IllustratedMessage), {
                            orientation: "horizontal",
                            size: "S",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropToUploadDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Heading), {
                                    children: "Drag and drop your file"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Content), {
                                    children: "Or, select a file from your computer"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ButtonGroup), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                                        fillStyle: "outline",
                                        children: "Add photos"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
                        href: "#",
                        styles: " Np11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: " sd11 eb11 _Ca11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _aigenerateImageDefault.default), {})
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "title",
                                        children: "Generate an image"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "description",
                                        children: "Create an image from text"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
                        href: "#",
                        styles: " Np11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: " sd11 eb11 _Ca11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _magicWandDefault.default), {})
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "title",
                                        children: "Apply a preset"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "description",
                                        children: "Enhance an existing image"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
                        href: "#",
                        styles: " Np11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CardPreview), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: " sd11 eb11 _Ca11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _propertiesDefault.default), {})
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "title",
                                        children: "Adjust colors"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                                        slot: "description",
                                        children: "Manually edit an image"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-e11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 Jd9wcl11",
                children: "Recents"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " sd11 UB1JKEb11 qB1JKEb11 Tf11 Qf11 Sf11 Rf11 JuTsfBd11 GuTsfBd11 IuTsfBd11 HuTsfBd11 _va11 FF11 _Na11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _photos.PhotoCard), {
                        styles: " NU2bf911",
                        item: {
                            urls: {
                                regular: 'https://images.unsplash.com/photo-1763641683842-3b4f09950d67?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNDA4NDh8MHwxfHRvcGljfHw2c01WalRMU2tlUXx8fHx8Mnx8MTc2Mzc1NDk4OXw&ixlib=rb-4.1.0&q=80&w=1080'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _photos.PhotoCard), {
                        styles: " NU2bf911",
                        item: {
                            urls: {
                                regular: 'https://images.unsplash.com/photo-1762532985216-6561bb733c56?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNDA4NDh8MHwxfHRvcGljfHw2c01WalRMU2tlUXx8fHx8Mnx8MTc2Mzc1NDk4OXw&ixlib=rb-4.1.0&q=80&w=1080'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _photos.PhotoCard), {
                        styles: " NU2bf911",
                        item: {
                            urls: {
                                regular: 'https://images.unsplash.com/photo-1762385653060-52aa4ec2937d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNDA4NDh8MHwxfHRvcGljfHw2c01WalRMU2tlUXx8fHx8Mnx8MTc2Mzc2MTUxOHw&ixlib=rb-4.1.0&q=80&w=1080'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _photos.PhotoCard), {
                        styles: " NU2bf911",
                        item: {
                            urls: {
                                regular: 'https://images.unsplash.com/photo-1762030085994-79285eee5bc9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNDA4NDh8MHwxfHRvcGljfHw2c01WalRMU2tlUXx8fHx8Mnx8MTc2Mzc2MTUzMHw&ixlib=rb-4.1.0&q=80&w=1080'
                            }
                        }
                    })
                ]
            })
        ]
    });
}
function HomeArrows() {
    let [isScrolled, setScrolled] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let content = document.querySelector('[data-content]');
        if (content) content.onscroll = ()=>{
            setScrolled(content.scrollTop > 0);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _arrows.Arrows), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 75,
                x1: 120,
                x2: 160,
                y: 130,
                href: "Button",
                children: "Button"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 38,
                x1: 120,
                x2: 160,
                y: 618,
                href: "ActionButton",
                children: "ActionButton"
            }),
            !isScrolled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 56,
                x1: 120,
                x2: 250,
                y: 520,
                href: "DropZone",
                children: "DropZone"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 632,
                y: 24,
                points: "662,34 662,64",
                marker: "markerEnd",
                href: "SearchField",
                children: "SearchField"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 1040,
                y: 24,
                points: "1064,34 1064,64",
                marker: "markerEnd",
                href: "Popover",
                children: "Popover"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 1206,
                x1: 1198,
                x2: 1158,
                y: 82,
                marker: "markerEnd",
                href: "Menu",
                children: "Menu"
            }),
            !isScrolled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 1206,
                x1: 1198,
                x2: 1120,
                y: 520,
                href: "Card",
                children: "Card"
            })
        ]
    });
}

},{"0":"hPpbG","1":"bUAx6","2":"i6bVE","3":"aVpAN","4":"7NpnY","5":"j0QC5","6":"eZtS0","7":"jvq6y","8":"aUzfW","9":"cxFfc","10":"3ynzp","11":"1zk0Q","12":"53Oud","13":"j0pna","14":"cOE8r","15":"8Gsgu","16":"g3zyd","17":"2xQdr","18":"6Ne29","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Button","gZHck"],["ButtonGroup","PBWa0"],["Card","jxfoI"],["CardPreview","jxfoI"],["Content","10r6w"],["Heading","10r6w"],["Text","10r6w"],["DropZone","jnRZl"],["IllustratedMessage","6oPVu"]],"@react-spectrum/s2/illustrations/gradient/generic2/DropToUpload":"gCbW3","@react-spectrum/s2/illustrations/gradient/generic2/AIGenerateImage":"2gmO2","@react-spectrum/s2/illustrations/gradient/generic2/MagicWand":"co3lX","@react-spectrum/s2/illustrations/gradient/generic2/Properties":"8Ous7","./banner.svg":"3fn3c","./Photos":"cLTse","./Arrows":"cIjW4","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hPpbG":[function() {},{}],"bUAx6":[function() {},{}],"i6bVE":[function() {},{}],"aVpAN":[function() {},{}],"7NpnY":[function() {},{}],"j0QC5":[function() {},{}],"eZtS0":[function() {},{}],"jvq6y":[function() {},{}],"aUzfW":[function() {},{}],"cxFfc":[function() {},{}],"3ynzp":[function() {},{}],"1zk0Q":[function() {},{}],"53Oud":[function() {},{}],"j0pna":[function() {},{}],"cOE8r":[function() {},{}],"8Gsgu":[function() {},{}],"g3zyd":[function() {},{}],"2xQdr":[function() {},{}],"6Ne29":[function() {},{}],"6oPVu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IllustratedMessageContext", ()=>IllustratedMessageContext);
parcelHelpers.export(exports, "IllustratedMessage", ()=>IllustratedMessage);
var _jsxRuntime = require("react/jsx-runtime");
var _buttonGroup = require("./ButtonGroup");
var _content = require("./Content");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const illustratedMessage = function anonymous(props, overrides) {
    let rules = " ";
    let maxWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "L") maxWidth = true;
        rules += p[0];
    }
    rules += ' se11';
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.size === "XL") rules += ' pt11';
    else if (props.size === "L") rules += ' pt11';
    else if (props.size === "S") rules += ' pt11';
    else if (props.size === "XS") rules += ' pt11';
    else rules += ' pt11';
    if (props.orientation === "horizontal") {
        if (!maxWidth) rules += ' LMQFO0c11';
    } else if (props.orientation === "vertical") {
        if (!maxWidth) rules += ' L1pozMd11';
    }
    if (props.orientation === "horizontal") rules += ' CLJajOe11';
    else if (props.orientation === "vertical") rules += ' CPmblS11';
    if (props.orientation === "horizontal") rules += ' ERIq1Ke11';
    else if (props.orientation === "vertical") {
        if (props.size === "L") rules += ' EtEpcZc11';
        else rules += ' EkADQDc11';
    }
    if (props.orientation === "horizontal") rules += ' DOO7oyd11';
    if (props.orientation === "horizontal") rules += ' _Dc11';
    else if (props.orientation === "vertical") rules += ' _Da11';
    if (props.orientation === "vertical") rules += ' _Wa11';
    return rules;
};
const illustration = function anonymous(props) {
    let rules = " ";
    rules += ' zTZ8xtd11';
    rules += ' yTZ8xtd11';
    rules += ' BTZ8xtd11';
    rules += ' ATZ8xtd11';
    rules += ' _dc11';
    if (props.isDropTarget) rules += ' -_8sjo0b-pu11';
    else rules += ' -_8sjo0b-pt11';
    return rules;
};
const heading = function anonymous(props) {
    let rules = " ";
    rules += ' zPCJngb11';
    rules += ' yPCJngb11';
    rules += ' BPCJngb11';
    rules += ' APCJngb11';
    if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "M") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "L") {
        rules += ' -_6BNtrc-g11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-f11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "L") {
        rules += ' xd11';
        rules += ' _xa11';
        rules += ' xX0cczbc11';
        rules += ' _xX0cczba11';
        rules += ' xfd11';
        rules += ' _xfa11';
        rules += ' xfX0cczbc11';
        rules += ' _xfX0cczba11';
    } else if (props.size === "M") {
        rules += ' xd11';
        rules += ' _xa11';
        rules += ' xX0cczbc11';
        rules += ' _xX0cczba11';
        rules += ' xfd11';
        rules += ' _xfa11';
        rules += ' xfX0cczbc11';
        rules += ' _xfX0cczba11';
    } else if (props.size === "S") {
        rules += ' xd11';
        rules += ' _xa11';
        rules += ' xX0cczbc11';
        rules += ' _xX0cczba11';
        rules += ' xfd11';
        rules += ' _xfa11';
        rules += ' xfX0cczbc11';
        rules += ' _xfX0cczba11';
    }
    if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "M") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.size === "L") rules += ' po11';
    else if (props.size === "M") rules += ' po11';
    else if (props.size === "S") rules += ' po11';
    rules += ' _dd11';
    rules += ' JYB8I11';
    rules += ' GYB8I11';
    rules += ' IYB8I11';
    rules += ' HYB8I11';
    return rules;
};
const content = function anonymous(props) {
    let rules = " ";
    if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "M") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "L") {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "M") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "L") {
        rules += ' _Fb11';
        rules += ' _FnuYUwec11';
    } else if (props.size === "M") {
        rules += ' _Fb11';
        rules += ' _FnuYUwec11';
    } else if (props.size === "S") {
        rules += ' _Fb11';
        rules += ' _FnuYUwec11';
    }
    if (props.size === "L") rules += ' pt11';
    else if (props.size === "M") rules += ' pt11';
    else if (props.size === "S") rules += ' pt11';
    rules += ' zk52g2d11';
    rules += ' yk52g2d11';
    rules += ' Bk52g2d11';
    rules += ' Ak52g2d11';
    rules += ' _de11';
    return rules;
};
const buttonGroup = " zmlKpq11 ymlKpq11 BmlKpq11 AmlKpq11 JB1JKEb11";
const IllustratedMessageContext = /*#__PURE__*/ (0, _react.createContext)(null);
const IllustratedMessage = /*#__PURE__*/ (0, _react.forwardRef)(function IllustratedMessage(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, IllustratedMessageContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let { children, orientation = 'horizontal', size = 'M', UNSAFE_className = '', UNSAFE_style, isInDropZone = false, isDropTarget = false, ...otherProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _utils.filterDOMProps)(otherProps),
        style: UNSAFE_style,
        className: UNSAFE_className + illustratedMessage({
            size: props.size || 'M',
            orientation: props.orientation || 'vertical'
        }, props.styles),
        ref: domRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
            values: [
                [
                    (0, _content.HeadingContext),
                    {
                        styles: heading({
                            orientation,
                            size
                        })
                    }
                ],
                [
                    (0, _content.ContentContext),
                    {
                        styles: content({
                            size
                        })
                    }
                ],
                [
                    (0, _icon.IllustrationContext),
                    {
                        size: size === 'L' ? 'L' : 'M',
                        styles: illustration({
                            orientation,
                            size,
                            isInDropZone,
                            isDropTarget
                        })
                    }
                ],
                [
                    (0, _buttonGroup.ButtonGroupContext),
                    {
                        styles: buttonGroup
                    }
                ]
            ],
            children: children
        })
    });
});

},{"0":"hQwdt","1":"l0tle","2":"8HwQe","3":"4oeOP","4":"f4PXn","react/jsx-runtime":"2Is6Z","./ButtonGroup":"PBWa0","./Content":"10r6w","react-aria-components":"bA6Cz","react":"a1TxN","@react-aria/utils":"3upVm","./Icon":"jQAJE","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hQwdt":[function() {},{}],"l0tle":[function() {},{}],"8HwQe":[function() {},{}],"4oeOP":[function() {},{}],"f4PXn":[function() {},{}],"3fn3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBanner = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 1280,
        height: 322,
        fill: "none",
        viewBox: "0 0 1280 322",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#banner_svg__a)",
                d: "M0 0h1280v322H0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                id: "banner_svg__c",
                width: 810,
                height: 814,
                x: 819,
                y: -427,
                maskUnits: "userSpaceOnUse",
                style: {
                    maskType: "alpha"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                    cx: 1224.11,
                    cy: -20.292,
                    fill: "url(#banner_svg__b)",
                    rx: 404.81,
                    ry: 406.707,
                    transform: "rotate(-180 1224.11 -20.292)"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                mask: "url(#banner_svg__c)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                    cx: 1224.11,
                    cy: -20.292,
                    fill: "#EB1000",
                    rx: 404.81,
                    ry: 406.707,
                    transform: "rotate(-180 1224.11 -20.292)"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "banner_svg__a",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(10.734 -483.09 686.975)scale(1181.17)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.251,
                                stopColor: "light-dark(#FFD5E3, #5D0022)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.745,
                                stopColor: "light-dark(#F02D6E, #E02665)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.895,
                                stopColor: "light-dark(#30A7FE, #03638C)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "banner_svg__b",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 406.707 -404.81 0 1224.11 -20.292)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopOpacity: 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
exports.default = SvgBanner;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cIjW4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Arrows", ()=>Arrows);
parcelHelpers.export(exports, "Arrow", ()=>Arrow);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
function Arrows({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 1324 700",
        style: {
            position: 'absolute',
            insetInline: -150,
            insetBlock: -50,
            width: 'calc(100% + 300px)',
            height: 'calc(100% + 100px)',
            pointerEvents: 'none'
        },
        className: " sk11 s6aDQqcb11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("marker", {
                        id: "arrow",
                        viewBox: "0 0 6 6",
                        refX: 3,
                        refY: 3,
                        markerWidth: 6,
                        markerHeight: 6,
                        orient: "auto-start-reverse",
                        fill: "light-dark(black,white)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            r: 3,
                            cx: 3,
                            cy: 3
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                        id: "app-mask",
                        maskUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: "100%",
                                height: "100%",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                x: 150,
                                y: 50,
                                width: 1024,
                                height: 600,
                                fill: "black"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                        id: "app-mask2",
                        maskUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: "100%",
                                height: "100%",
                                fill: "black"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                x: 150,
                                y: 50,
                                width: 1024,
                                height: 600,
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
}
function Arrow({ href, children, textX, x1, x2, points, y, marker = 'markerEnd' }) {
    let markerProps = marker === 'none' ? {} : {
        [marker]: 'url(#arrow)'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            points ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                points: points,
                ...markerProps,
                stroke: "white",
                fill: "none",
                mask: "url(#app-mask)"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                x1: x1,
                y1: y,
                x2: x2,
                y2: y,
                ...markerProps,
                stroke: "white",
                mask: "url(#app-mask)"
            }),
            points ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                points: points,
                ...markerProps,
                stroke: "light-dark(black,white)",
                fill: "none",
                mask: "url(#app-mask2)"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                x1: x1,
                y1: y,
                x2: x2,
                y2: y,
                ...markerProps,
                stroke: "light-dark(black,white)",
                mask: "url(#app-mask2)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Link), {
                href: href,
                target: "_blank",
                isQuiet: true,
                isStandalone: true,
                staticColor: "white",
                UNSAFE_style: {
                    pointerEvents: 'auto'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                    x: textX,
                    y: y + 3,
                    fill: "currentColor",
                    textDecoration: "inherit",
                    children: children
                })
            })
        ]
    });
}

},{"0":"4xj5j","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"42COX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4xj5j":[function() {},{}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _skeleton = require("./Skeleton");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf11';
    else rules += ' _Le11';
    if (props.isStaticColor) rules += ' Oe11';
    else rules += ' Oh11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' _Mc11';
    rules += ' _Kd11';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr11';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s11';
    rules += ' oR3ltQc11';
    rules += ' nR3ltQc11';
    rules += ' kR3ltQc11';
    rules += ' jR3ltQc11';
    if (props.isStandalone) {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.isStandalone) {
        rules += ' xc11';
        rules += ' _xa11';
    }
    if (props.isStandalone) {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.isStaticColor) rules += ' pl11';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po11';
        else if (props.isFocusVisible) rules += ' po11';
        else if (props.isHovered) rules += ' po11';
        else rules += ' pt11';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps11';
        else if (props.isFocusVisible) rules += ' ps11';
        else if (props.isHovered) rules += ' ps11';
        else rules += ' pu11';
    }
    rules += ' plOVIhfcA5Qiqd11';
    rules += ' plOVIhfcA5Qiqd11';
    rules += ' Yd11';
    rules += ' Xb11';
    rules += ' _2b11';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb11';
                rules += ' __Va11';
            } else if (props.isHovered) {
                rules += ' _Xb11';
                rules += ' __Va11';
            } else rules += ' _Xa11';
        }
    } else {
        rules += ' _Xb11';
        rules += ' __Va11';
    }
    rules += ' __ca11';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _utils1.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react-aria-components":"fOCdV","react":"a1TxN","./Skeleton":"1mUnF","@react-spectrum/utils":"jqfrX","@react-aria/utils":"2ViQu","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"10oan":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ideas", ()=>Ideas);
parcelHelpers.export(exports, "IdeasArrows", ()=>IdeasArrows);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _folder = require("@react-spectrum/s2/icons/Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _reactAria = require("react-aria");
var _reactStately = require("react-stately");
var _arrows = require("./Arrows");
function Ideas() {
    let { locale } = (0, _reactAria.useLocale)();
    let list = (0, _reactStately.useAsyncList)({
        async load () {
            let res = await require("1ee1cb50ec4d8645");
            let items = res.filter((topic)=>!!topic.preview_photos);
            return {
                items
            };
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-g11 vFHT6Dd11 xe11 _xa11 xX0cczbd11 _xX0cczba11 xfe11 _xfa11 xfX0cczbd11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11",
                children: locale === 'ar-AE' ? "\u0623\u0641\u0643\u0627\u0631" : 'Ideas'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.CardView), {
                "aria-label": "Ideas",
                loadingState: list.loadingState,
                onLoadMore: list.loadMore,
                styles: " _ub11 Ma11 Kdrw1ne11 IJGwHDc11 HJGwHDc11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Collection), {
                        items: list.items,
                        children: (topic)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TopicCard, {
                                topic: topic
                            })
                    }),
                    (list.loadingState === 'loading' || list.loadingState === 'loadingMore') && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.SkeletonCollection), {
                        children: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TopicCard, {
                                topic: {
                                    id: Math.random().toString(36),
                                    title: 'Topic title',
                                    total_photos: 80,
                                    links: {
                                        html: ''
                                    },
                                    preview_photos: [
                                        {
                                            id: 'a',
                                            urls: {
                                                small: ''
                                            }
                                        },
                                        {
                                            id: 'b',
                                            urls: {
                                                small: ''
                                            }
                                        },
                                        {
                                            id: 'c',
                                            urls: {
                                                small: ''
                                            }
                                        },
                                        {
                                            id: 'd',
                                            urls: {
                                                small: ''
                                            }
                                        }
                                    ]
                                }
                            })
                    })
                ]
            })
        ]
    });
}
function TopicCard({ topic }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Card), {
        href: topic.links.html,
        target: "_blank",
        textValue: topic.title,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.CollectionCardPreview), {
                children: topic.preview_photos.slice(0, 4).map((photo)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Image), {
                        alt: "",
                        src: photo.urls.small
                    }, photo.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Content), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        slot: "title",
                        children: topic.title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd11 eb11 UH5kTnc11 qH5kTnc11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _folderDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Text), {
                                slot: "description",
                                children: [
                                    topic.total_photos.toLocaleString(),
                                    " photos"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function IdeasArrows() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _arrows.Arrows), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 75,
                x1: 120,
                x2: 160,
                y: 130,
                href: "Button",
                children: "Button"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 38,
                x1: 120,
                x2: 160,
                y: 618,
                href: "ActionButton",
                children: "ActionButton"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 632,
                y: 24,
                points: "662,34 662,64",
                marker: "markerEnd",
                href: "SearchField",
                children: "SearchField"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 1040,
                y: 24,
                points: "1064,34 1064,64",
                marker: "markerEnd",
                href: "Popover",
                children: "Popover"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 1206,
                x1: 1198,
                x2: 1158,
                y: 82,
                marker: "markerEnd",
                href: "Menu",
                children: "Menu"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrows.Arrow), {
                textX: 1206,
                x1: 1198,
                x2: 1142,
                y: 350,
                marker: "markerEnd",
                href: "Card.html#collection",
                children: "CollectionCard"
            })
        ]
    });
}

},{"0":"hAFZA","1":"i2UXh","2":"jGhVy","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Card","jxfoI"],["CollectionCardPreview","jxfoI"],["CardView","7Sr64"],["Collection","2Jd0Q"],["Content","10r6w"],["Text","10r6w"],["Image","4LTiE"],["SkeletonCollection","f83W7"]],"@react-spectrum/s2/icons/Folder":"dLqBo","react-aria":"4k4z8","react-stately":"7TSdz","./Arrows":"cIjW4","1ee1cb50ec4d8645":"l356m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hAFZA":[function() {},{}],"i2UXh":[function() {},{}],"jGhVy":[function() {},{}],"dLqBo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.75 5h-5.964c-.218 0-.424-.095-.567-.259L8.516 2.776C8.088 2.283 7.468 2 6.816 2H3.25C2.01 2 1 3.01 1 4.25v10.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-7.5C19 6.01 17.99 5 16.75 5M3.25 3.5h3.565c.218 0 .424.095.567.259L8.458 5H2.5v-.75c0-.413.336-.75.75-.75M17.5 14.75c0 .413-.336.75-.75.75H3.25c-.414 0-.75-.337-.75-.75V6.5h14.25c.414 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l356m":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
let promise = Promise.all([
    module.bundle.load("63IPP")
]).then(()=>{
    let originalModule = module.bundle.root("95QG0");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
        rel: "modulepreload",
        href: module.bundle.resolve("63IPP")
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ"}],"8bVwg":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("63IPP").then(()=>module.bundle.root('95QG0'));

},{}],"8LSkM":[function() {},{}],"97JxD":[function() {},{}],"jixoI":[function() {},{}],"faY2V":[function() {},{}],"3n98M":[function() {},{}],"46Emk":[function() {},{}],"hDilJ":[function() {},{}],"9RKRv":[function() {},{}],"fv41m":[function() {},{}],"4UXjX":[function() {},{}],"fCKih":[function() {},{}],"6dEtm":[function() {},{}],"8Bq3x":[function() {},{}],"jhlLZ":[function() {},{}],"86e7P":[function() {},{}],"lsuf9":[function() {},{}],"5RAoy":[function() {},{}],"1gyWI":[function() {},{}],"cZhmh":[function() {},{}],"65NaN":[function() {},{}],"4bpiY":[function() {},{}],"4DBL8":[function() {},{}],"fOcn5":[function() {},{}],"htGJu":[function() {},{}],"hNDse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mobile", ()=>Mobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAria = require("react-aria");
// @ts-ignore
var _iphoneFrameWebp = require("url:@react-spectrum/docs/pages/assets/iphone-frame.webp");
var _iphoneFrameWebpDefault = parcelHelpers.interopDefault(_iphoneFrameWebp);
// @ts-ignore
var _iphoneMaskWebp = require("url:@react-spectrum/docs/pages/assets/iphone-mask.webp");
var _iphoneMaskWebpDefault = parcelHelpers.interopDefault(_iphoneMaskWebp);
var _lucideReact = require("lucide-react");
var _s2 = require("@react-spectrum/s2");
var _menuHamburger = require("@react-spectrum/s2/icons/MenuHamburger");
var _menuHamburgerDefault = parcelHelpers.interopDefault(_menuHamburger);
var _search = require("@react-spectrum/s2/icons/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _more = require("@react-spectrum/s2/icons/More");
var _moreDefault = parcelHelpers.interopDefault(_more);
// @ts-ignore
var _adobeLogo = require("../../../src/icons/AdobeLogo");
var _utils = require("@react-spectrum/docs/pages/react-aria/home/utils");
'use client';
const translate = (x, y)=>`translate(${x}px, ${y}px)`;
function Mobile() {
    let containerRef = (0, _react.useRef)(null);
    let toolbarRef = (0, _react.useRef)(null);
    let fingerRef = (0, _react.useRef)(null);
    let textFieldRef = (0, _react.useRef)(null);
    let buttonRef = (0, _react.useRef)(null);
    let [value, setValue] = (0, _react.useState)('');
    let [isAnimating, setAnimating] = (0, _react.useState)(false);
    (0, _utils.useIntersectionObserver)(toolbarRef, (0, _react.useCallback)(()=>{
        if (matchMedia('(prefers-reduced-motion)').matches) return;
        let cancel = (0, _utils.animate)([
            {
                time: 500,
                perform () {
                    setAnimating(true);
                }
            },
            {
                time: 1000,
                perform () {
                    let node = textFieldRef.current.getInputElement().parentElement;
                    fingerRef.current.animate({
                        transform: translate(node.offsetLeft + 40, node.offsetTop + node.offsetHeight / 2 - fingerRef.current.offsetHeight / 2)
                    }, {
                        duration: 1000,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                }
            },
            {
                time: 250,
                perform () {
                    fingerRef.current.animate({
                        opacity: [
                            0.5,
                            0.8,
                            0.5,
                            0
                        ]
                    }, {
                        duration: 800,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                }
            },
            {
                time: 2280,
                async perform () {
                    let node = textFieldRef.current.getInputElement();
                    fakeFocus(node, 'focus');
                    await new Promise((res)=>setTimeout(res, 800));
                    setValue('');
                    for (let c of 'user@example.com'){
                        setValue((value)=>value + c);
                        await new Promise((res)=>setTimeout(res, 80));
                    }
                }
            },
            {
                time: 250,
                perform () {
                    fingerRef.current.animate({
                        opacity: [
                            0,
                            0.5
                        ]
                    }, {
                        duration: 500,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                }
            },
            {
                time: 1200,
                perform () {
                    let node = buttonRef.current.UNSAFE_getDOMNode();
                    fingerRef.current.animate({
                        transform: translate(node.offsetLeft + node.offsetWidth / 2 - fingerRef.current.offsetWidth / 2, node.offsetTop + node.offsetHeight / 2 - fingerRef.current.offsetHeight / 2)
                    }, {
                        duration: 1000,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                }
            },
            {
                time: 300,
                perform () {
                    let node = textFieldRef.current.getInputElement();
                    fakeFocus(node, 'blur');
                    fingerRef.current.animate({
                        opacity: [
                            0.5,
                            0.8,
                            0.5
                        ]
                    }, {
                        duration: 550,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                    pointer(buttonRef, 'pointerdown');
                }
            },
            {
                time: 500,
                perform () {
                    pointer(buttonRef, 'pointerup');
                }
            },
            {
                time: 500,
                perform () {
                    let node = buttonRef.current.UNSAFE_getDOMNode();
                    fingerRef.current.animate({
                        transform: translate(node.offsetLeft, 300)
                    }, {
                        duration: 1000,
                        fill: 'forwards',
                        easing: 'ease-in-out'
                    });
                }
            },
            {
                time: 0,
                perform () {
                    setAnimating(false);
                }
            }
        ]);
        return ()=>{
            cancel();
            setValue('');
            setAnimating(false);
            fingerRef.current.getAnimations().forEach((a)=>a.cancel());
        };
    }, []));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        inert: isAnimating || undefined,
        className: " Za11 Fb11 LpmHXIc11 Mgzz1he11 IM11 HM11 GaT6Oqc11 __mc11 _qf11",
        style: {
            backgroundImage: `url(${(0, _iphoneFrameWebpDefault.default).split('?')[0]})`
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: " Za11 Fb11 _oa11 sd11 _ta11 gqlRAZb11",
            style: {
                maskImage: `url(${(0, _iphoneMaskWebpDefault.default).split('?')[0]}), linear-gradient(#fff 0 0)`,
                maskSize: '100%',
                maskComposite: 'exclude',
                padding: '8%',
                paddingBottom: 0
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " sd11 eb11 UR3ltQc11 qR3ltQc11 Si11 Ri11 Tf11 Qf11 _oa11 uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-c11 vFHT6Dd11 xc11 _xa11 _Fd11 _FnuYUweb11 pt11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Clock, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: " _ub11"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.WifiIcon), {
                            className: " ZxhYlec11 FxhYlec11"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            viewBox: "0 0 28 24",
                            className: " FCe2o8c11 VOIem5c11",
                            fill: "none",
                            strokeWidth: "1",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: "20",
                                    height: "10",
                                    x: "2",
                                    y: "7",
                                    rx: "3",
                                    ry: "3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                    width: "13",
                                    height: "7",
                                    x: "3.5",
                                    y: "8.5",
                                    rx: "2",
                                    ry: "2",
                                    fill: "currentColor",
                                    stroke: "none"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "25",
                                    x2: "25",
                                    y1: "11",
                                    y2: "13",
                                    strokeWidth: "2"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " _ub11",
                    style: {
                        '--s2-scale': '1.25',
                        '--s2-font-size-base': '17'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd11 _ta11 Fb11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                ref: toolbarRef,
                                className: " z8IkPye11 y8IkPye11 B8IkPye11 A8IkPye11 sd11 UB1JKEb11 qB1JKEb11 eb11 Za11 Te11 Qe11 Se11 Re11 _oa11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuHamburgerDefault.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " _ub11"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreDefault.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Avatar), {
                                        src: "https://i.imgur.com/xIe7Wlb.png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                ref: containerRef,
                                className: " zk52g2d11 yk52g2d11 Bk52g2d11 Ak52g2d11 gX11 _ub11 Ma11 Za11 _Nb11 Pb11 Se11 Re11 Te11 _oa11 _Pc11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-d11 vFHT6Dd11 xd11 _xa11 xX0cczbc11 _xX0cczba11 xfd11 _xfa11 xfX0cczbc11 _xfX0cczba11 _Fd11 _FnuYUweb11 po11 GB1JKEb11",
                                        children: "Subscribe to our newsletter"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Form), {
                                        labelPosition: "side",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.TextField), {
                                                label: "Email",
                                                placeholder: "Enter your email",
                                                ref: textFieldRef,
                                                value: value,
                                                onChange: setValue
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                                                variant: "accent",
                                                ref: buttonRef,
                                                styles: " zhJUGr11 __Ac11",
                                                children: "Subscribe"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Finger, {
                                        ref: fingerRef
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function Clock() {
    let formatter = (0, _reactAria.useDateFormatter)({
        timeStyle: 'short'
    });
    let [time, setTime] = (0, _react.useState)(()=>new Date(2025, 0, 1));
    (0, _react.useEffect)(()=>{
        setTime(new Date());
    }, []);
    (0, _react.useEffect)(()=>{
        let nextMinute = Math.floor((Date.now() + 60000) / 60000) * 60000;
        let timeout = setTimeout(()=>{
            setTime(new Date());
        }, nextMinute - Date.now());
        return ()=>clearTimeout(timeout);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: formatter.format(time)
    });
}
function Finger({ ref }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        style: {
            transform: translate(0, 300)
        },
        className: " _9G1Ky11 _Ob11 _Pa11 Wr11 _Er11 Z3JjxG11 F3JjxG11 og11 ng11 kg11 jg11 _jf11 _kb11 hb11 mb11 lb11 ix5KoT11 gx5KoT11 _IqmMfn11"
    });
}
function pointer(ref, type) {
    ref.current?.UNSAFE_getDOMNode().dispatchEvent(new PointerEvent(type, {
        pointerType: 'mouse',
        pointerId: 1,
        bubbles: true,
        detail: 1
    }));
}
function fakeFocus(node, type) {
    Object.defineProperty(document, 'activeElement', {
        value: node,
        configurable: true
    });
    let relatedTarget = type === 'focus' ? document.activeElement : null;
    node.dispatchEvent(new FocusEvent(type, {
        relatedTarget
    }));
    node.dispatchEvent(new FocusEvent(type === 'blur' ? 'focusout' : 'focusin', {
        bubbles: true,
        relatedTarget
    }));
    // @ts-ignore
    delete document.activeElement;
}

},{"0":"bXktf","1":"bXktf","2":"bXktf","3":"bXktf","4":"bXktf","5":"bXktf","6":"bXktf","7":"bXktf","8":"bXktf","9":"bXktf","10":"bXktf","11":"bXktf","12":"bXktf","13":"bXktf","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria":"l0ABP","url:@react-spectrum/docs/pages/assets/iphone-frame.webp":"lHyEh","url:@react-spectrum/docs/pages/assets/iphone-mask.webp":"4K5TK","lucide-react":[["WifiIcon","biA3B","default"]],"@react-spectrum/s2":[["Avatar","f3T9F"],["Button","gZHck"],["Form","cHqN4"],["TextField","7oxrW"]],"@react-spectrum/s2/icons/MenuHamburger":"bneuv","@react-spectrum/s2/icons/Search":"cSREm","@react-spectrum/s2/icons/More":"gP3id","../../../src/icons/AdobeLogo":"5Bj5G","@react-spectrum/docs/pages/react-aria/home/utils":"6X865","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l0ABP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized date formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the date formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useDateFormatter", ()=>useDateFormatter);
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _context = require("./context");
var _react = require("react");
function useDateFormatter(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, _utils.useDeepMemo)(options ?? {}, isEqual);
    let { locale } = (0, _context.useLocale)();
    return (0, _react.useMemo)(()=>new (0, _date.DateFormatter)(locale, options), [
        locale,
        options
    ]);
}
function isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}

},{"@internationalized/date":"6ueXY","@react-aria/utils":"6otos","./context":"4k4z8","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6ueXY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** A wrapper around Intl.DateTimeFormat that fixes various browser bugs, and polyfills new features. */ parcelHelpers.export(exports, "DateFormatter", ()=>DateFormatter);
let formatterCache = new Map();
class DateFormatter {
    constructor(locale, options = {}){
        this.formatter = getCachedDateFormatter(locale, options);
        this.options = options;
    }
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === 'function') // @ts-ignore
        return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === 'function') // @ts-ignore
        return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if (hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === 'ethiopic-amete-alem') resolvedOptions.calendar = 'ethioaa';
        return resolvedOptions;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {
    }
};
function getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        let defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref ?? defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let _hasBuggyHour12Behavior = null;
function hasBuggyHour12Behavior() {
    if (_hasBuggyHour12Behavior == null) _hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return _hasBuggyHour12Behavior;
}
let _hasBuggyResolvedHourCycle = null;
function hasBuggyResolvedHourCycle() {
    if (_hasBuggyResolvedHourCycle == null) _hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return _hasBuggyResolvedHourCycle;
}
function getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    let formatter = getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === 'hour').value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === 'hour').value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6otos":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepMemo", ()=>useDeepMemo);
var _react = require("react");
function useDeepMemo(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, _react.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lHyEh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("dC9AI");

},{}],"4K5TK":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("gYUzO");

},{}],"biA3B":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Wifi);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 20 0",
            key: "dnpr2z"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 14 0",
            key: "1x1e6c"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ]
];
const Wifi = (0, _createLucideIconJsDefault.default)("wifi", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gsSty":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"a1TxN","./shared/src/utils.js":"lfP1m","./Icon.js":"d0fsO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lfP1m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d0fsO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"a1TxN","./defaultAttributes.js":"9Rm8m","./shared/src/utils.js":"lfP1m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Rm8m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6X865":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationQueue", ()=>animationQueue);
parcelHelpers.export(exports, "animate", ()=>animate);
parcelHelpers.export(exports, "useIntersectionObserver", ()=>useIntersectionObserver);
var _react = require("react");
async function* createAnimationQueue() {
    while(true){
        let { isCanceled, run } = yield;
        if (!isCanceled) await run();
    }
}
let animationQueue = createAnimationQueue();
animationQueue.next(); // advance to first yield
function animate(steps) {
    let cancelCurrentStep;
    async function run() {
        for (let step of steps)try {
            step.perform();
            let { promise, cancel } = sleep(step.time);
            cancelCurrentStep = cancel;
            await promise;
        } catch  {
            break;
        }
    }
    let job = {
        isCanceled: false,
        run
    };
    animationQueue.next(job);
    return ()=>{
        job.isCanceled = true;
        if (cancelCurrentStep) cancelCurrentStep();
    };
}
function sleep(ms) {
    let timeout;
    let cancel;
    let promise = new Promise((resolve, reject)=>{
        timeout = setTimeout(resolve, ms);
        cancel = reject;
    });
    return {
        promise,
        cancel () {
            clearTimeout(timeout);
            cancel();
        }
    };
}
function useIntersectionObserver(ref, onIntersect) {
    (0, _react.useEffect)(()=>{
        let element = ref.current;
        if (!element) return;
        let cancel = undefined;
        let observer = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) cancel = onIntersect();
            else if (typeof cancel === 'function') {
                cancel();
                cancel = undefined;
            }
        }, {
            threshold: 1
        });
        observer.observe(element);
        return ()=>{
            if (typeof cancel === 'function') cancel();
            observer.unobserve(element);
        };
    }, [
        ref,
        onIntersect
    ]);
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jeZ4J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Rems", ()=>Rems);
var _jsxRuntime = require("react/jsx-runtime");
var _exampleApp2 = require("./ExampleApp2");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
'use client';
function Rems() {
    let [value, setValue] = (0, _react.useState)(16);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Slider), {
                label: "Font size",
                minValue: 8,
                maxValue: 40,
                value: value,
                onChange: setValue,
                labelPosition: "side",
                size: "L",
                // @ts-ignore
                PRIVATE_staticColor: true,
                styles: " LhAHjGc11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _oa11 FH4vLIe11 JB1JKEb11 GuTsfBd11 GnYB8I11 IuTsfBd11 InYB8I11 HuTsfBd11 HnYB8I11 -_4DHzJc-0u6p5b11 -jmjrke-od11 -jmjrke-no5NLVAe11",
                style: {
                    '--rem': value + 'px'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleApp2.ExampleApp2), {
                    showPanel: true
                })
            })
        ]
    });
}

},{"0":"bXktf","1":"bXktf","react/jsx-runtime":"2Is6Z","./ExampleApp2":"khrJz","@react-spectrum/s2":"ixJJx","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aERNd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icons", ()=>Icons);
parcelHelpers.export(exports, "Illustrations", ()=>Illustrations);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
// @ts-ignore
var _s2IconAFSvg = require("/packages/@react-spectrum/s2/s2wf-icons/S2_Icon_[A-F]*.svg");
var _s2IconAFSvgDefault = parcelHelpers.interopDefault(_s2IconAFSvg);
// @ts-ignore
var _aGTsx = require("/packages/@react-spectrum/s2/spectrum-illustrations/gradient/generic1/[A-G]*.tsx");
var _aGTsxDefault = parcelHelpers.interopDefault(_aGTsx);
var _s2 = require("@react-spectrum/s2");
'use client';
function Icons() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconGrid, {
        icons: (0, _s2IconAFSvgDefault.default),
        size: 32
    });
}
function Illustrations() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.IllustrationContext).Provider, {
        value: {
            size: 'S'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconGrid, {
            icons: (0, _aGTsxDefault.default),
            size: 48,
            intensity: 0.2
        })
    });
}
function IconGrid({ icons, size, radius = 4 * size, intensity = 0.5 }) {
    let [width, setWidth] = (0, _react.useState)(0);
    let [pos, setPos] = (0, _react.useState)(null);
    let [transition, setTransition] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " se11 JerlM8c11 _Ce11",
        style: {
            gridTemplateColumns: `repeat(auto-fit, calc(${size}px * var(--s2-scale, 1)))`,
            gridAutoRows: `calc(${size}px * var(--s2-scale, 1))`,
            // Display 6 rows of 32px icons
            maxHeight: `calc(${Math.floor(192 / size) * size}px * var(--s2-scale, 1))`,
            overflow: 'clip'
        },
        onPointerEnter: (e)=>{
            if (e.pointerType === 'mouse') {
                setWidth(e.currentTarget.getBoundingClientRect().width);
                setTransition(true);
                setTimeout(()=>{
                    setTransition(false);
                }, 250);
            }
        },
        onPointerMove: (e)=>{
            if (e.pointerType === 'mouse') {
                let rect = e.currentTarget.getBoundingClientRect();
                setPos({
                    x: e.clientX - rect.x,
                    y: e.clientY - rect.y
                });
            }
        },
        onPointerLeave: (e)=>{
            setPos(null);
            if (e.pointerType === 'mouse') setTransition(true);
        },
        children: Object.values(icons).map((icon, i)=>{
            let scale = 1;
            let opacity = 1;
            if (pos) {
                let cols = Math.floor(width / size);
                let row = Math.floor(i / cols);
                let col = i % cols;
                let gap = (width - cols * size) / (cols - 1);
                let colWidth = size + gap;
                let cx = col * colWidth + size / 2;
                let cy = row * size + size / 2;
                let dx = pos.x - cx;
                let dy = pos.y - cy;
                let dist = Math.sqrt(dx * dx + dy * dy);
                let falloff = Math.max(0, 1 - dist / radius);
                scale = 1 + falloff * intensity;
                opacity = Math.max(0.6, 1 - dist / 400 * intensity);
            }
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " sd11 eb11 _Ca11",
                style: {
                    scale,
                    opacity,
                    transition: transition ? 'scale 150ms, opacity 250ms' : undefined
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(icon.default, {
                    size: "S"
                })
            }, i);
        })
    });
}

},{"0":"bXktf","1":"bXktf","react/jsx-runtime":"2Is6Z","react":"a1TxN","/packages/@react-spectrum/s2/s2wf-icons/S2_Icon_[A-F]*.svg":"74dxS","/packages/@react-spectrum/s2/spectrum-illustrations/gradient/generic1/[A-G]*.tsx":"zfibg","@react-spectrum/s2":"jQAJE","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"74dxS":[function(require,module,exports,__globalThis) {
const _temp0 = require("22ea10de82191a23");
const _temp1 = require("6a494b871c3693dc");
const _temp2 = require("f684debcd7561bb6");
const _temp3 = require("b35fbaaf2e74d4f4");
const _temp4 = require("f742e1fe503cf36d");
const _temp5 = require("b05f72463ccd046d");
const _temp6 = require("c08e161e345d7f");
const _temp7 = require("1ce7f64cd319722d");
const _temp8 = require("c175cc8daa87dfc5");
const _temp9 = require("e8bc79b9c16c0b71");
const _temp10 = require("9f4555f8cf526ad1");
const _temp11 = require("38af270afd5f42d");
const _temp12 = require("78d58ef22f0a0114");
const _temp13 = require("681464bb0949faa");
const _temp14 = require("7a92c69733da844c");
const _temp15 = require("ae351a136d8921c2");
const _temp16 = require("c44981913887dc6a");
const _temp17 = require("9cd1f31a7aafc9ac");
const _temp18 = require("e55e577b3c40d4af");
const _temp19 = require("60600b06ba310b90");
const _temp20 = require("a7f821fa92a3f9fa");
const _temp21 = require("b16a4fecaf4654c5");
const _temp22 = require("fdf3bea5374de66");
const _temp23 = require("443a12539a71ab9e");
const _temp24 = require("aab834e9cbf3cda8");
const _temp25 = require("b93272a878873282");
const _temp26 = require("79cdd36a5a7435f9");
const _temp27 = require("51af5aeb0a9593ad");
const _temp28 = require("504daced72f27389");
const _temp29 = require("2e81aede48274ae1");
const _temp30 = require("d800f0f56e647d68");
const _temp31 = require("41346183f885f199");
const _temp32 = require("152440846a319b3a");
const _temp33 = require("3d6200304c1583bd");
const _temp34 = require("a7a0365cfe8327d7");
const _temp35 = require("3af246373369013b");
const _temp36 = require("a400a49d0e9d8d8a");
const _temp37 = require("9b100662175635cb");
const _temp38 = require("312d1cc73e850820");
const _temp39 = require("57ccc929f8fe1ea5");
const _temp40 = require("b70c554608dc000e");
const _temp41 = require("f362e5c1b8df465a");
const _temp42 = require("3d5e384d20f7a047");
const _temp43 = require("b939b120d262d0c5");
const _temp44 = require("84929f66f20c0603");
const _temp45 = require("ecf8f34107ecbcc1");
const _temp46 = require("a81028116365dfe5");
const _temp47 = require("e125d13bdb239803");
const _temp48 = require("572c59566976151f");
const _temp49 = require("196358ebfa7b6aa");
const _temp50 = require("e035cce2850178f6");
const _temp51 = require("b2c06619221f8388");
const _temp52 = require("e6d6d703f13d74e5");
const _temp53 = require("b9148241927bb0d2");
const _temp54 = require("2e193f4a14ec827");
const _temp55 = require("87131ba9dd2ae1e0");
const _temp56 = require("bbfb0d6f9a5d4f91");
const _temp57 = require("80cf030247a39252");
const _temp58 = require("84f6e9309a29277c");
const _temp59 = require("6156113b7af0778e");
const _temp60 = require("a4923242450d03b6");
const _temp61 = require("fb9e39d52626fa16");
const _temp62 = require("e7d04495c5eec01a");
const _temp63 = require("6fe239fa6ac3011b");
const _temp64 = require("6620a7e30c626b89");
const _temp65 = require("2743e437e09c1555");
const _temp66 = require("a01618504bc3a25d");
const _temp67 = require("7f8b1e8ae6051ade");
const _temp68 = require("277ed689fef364f1");
const _temp69 = require("71bbc8b1143601ea");
const _temp70 = require("1f0d9583d1f9d15b");
const _temp71 = require("c573c892febb80d3");
const _temp72 = require("8826759295d20c5a");
const _temp73 = require("45e219f5da8a9f65");
const _temp74 = require("a308ee402b1ea4d2");
const _temp75 = require("cfd9d2a4b251275f");
const _temp76 = require("cd80d320530d9de7");
const _temp77 = require("3204425227cabf61");
const _temp78 = require("32f4561b0f259626");
const _temp79 = require("a6d23796b28fe66b");
const _temp80 = require("7ac2bfb847904a2f");
const _temp81 = require("a7b0b22e8436592e");
const _temp82 = require("abad28d289577b12");
const _temp83 = require("8ec2ed6334adaaf4");
const _temp84 = require("fcacd946baced24d");
const _temp85 = require("af99db704f3603c4");
const _temp86 = require("be3e81348a878e24");
const _temp87 = require("f9160bf4ce9c062c");
const _temp88 = require("481c92ccef22bc5f");
const _temp89 = require("965d5353da26ca9d");
const _temp90 = require("254548cfa14e2d4");
const _temp91 = require("b981ec9aa3aeab90");
const _temp92 = require("af8a4ba07fc90502");
const _temp93 = require("36d29c7cca068399");
const _temp94 = require("7907f3f728d597d8");
const _temp95 = require("d89795e16c0a23b6");
const _temp96 = require("73a6240574d69419");
const _temp97 = require("4f26f54708506ad3");
const _temp98 = require("d51e68a5233da376");
const _temp99 = require("dc38e842fdd13bf9");
const _temp100 = require("6eea65035fc5e03");
const _temp101 = require("7b6f4b3f905a0e87");
const _temp102 = require("1673a4f5e6db817e");
const _temp103 = require("ed1915515d73d532");
const _temp104 = require("9947540d615b66bd");
const _temp105 = require("727756ed3a052e3e");
const _temp106 = require("e1db011946639c32");
const _temp107 = require("5f8c5af9705ee6b9");
const _temp108 = require("bc04f581482e245");
const _temp109 = require("168308869a3b3fa8");
const _temp110 = require("1310c63d688f10ab");
const _temp111 = require("7a0df299f01e3123");
const _temp112 = require("41eb48722eb183de");
const _temp113 = require("ae9cd2ff087e9d84");
const _temp114 = require("63b1476b2ad276b1");
const _temp115 = require("b096cfcb8d5b9485");
const _temp116 = require("60d5fef6f1bfec04");
const _temp117 = require("e1aabea95740854f");
const _temp118 = require("258eed6ddf7842b4");
const _temp119 = require("21e5b7285f122fc5");
const _temp120 = require("235b31169ffbeccb");
const _temp121 = require("f295949f90497e4b");
const _temp122 = require("2f0bb4d1ab9939c9");
const _temp123 = require("87d7fab47e926958");
const _temp124 = require("3049aede7c8e01e0");
const _temp125 = require("2b94aa296880a3ed");
const _temp126 = require("9e8811c9c628962a");
const _temp127 = require("632bce3abd75ad4e");
const _temp128 = require("18436cee77735b7d");
const _temp129 = require("447b13664dbd70ad");
const _temp130 = require("89f0c672a2b63ae");
const _temp131 = require("ca7074fc8d0eeead");
const _temp132 = require("d7440c1aacf6d163");
const _temp133 = require("efd11e039f58f6f0");
const _temp134 = require("cae10d29618e6997");
const _temp135 = require("c4e49074126e0f22");
const _temp136 = require("c5a8bea32a6b37bf");
const _temp137 = require("1cb7a96b4c3e40c4");
const _temp138 = require("8956c16054e27de8");
const _temp139 = require("e004ad85ce7b0614");
const _temp140 = require("e2fadb053b857606");
const _temp141 = require("f760fdd1a8533298");
const _temp142 = require("41e874fec7f19094");
const _temp143 = require("32ac7b0ce19c6d2");
const _temp144 = require("c175ae360f239ab2");
const _temp145 = require("534ba73c123c3442");
const _temp146 = require("dd9baa5a8a7062af");
const _temp147 = require("4be409afe01215bb");
const _temp148 = require("cb7fbc766a0c4ba8");
const _temp149 = require("809a69d84a7bfcb4");
const _temp150 = require("3aa8773c520343dc");
const _temp151 = require("440ddd3cbc77b72b");
const _temp152 = require("97415a79e985f3c0");
const _temp153 = require("da395f8ec1f234a2");
const _temp154 = require("7e28c7d1662e7de8");
const _temp155 = require("c7bff70cb9218693");
const _temp156 = require("9ad8d2dbdd6d2bdd");
const _temp157 = require("a5133aadbe540278");
const _temp158 = require("8232effc69a19ff6");
const _temp159 = require("6638297e322cad0e");
const _temp160 = require("dd4f2dc45a6341aa");
const _temp161 = require("ea535226d262b799");
const _temp162 = require("8c5c740c3dfd7613");
const _temp163 = require("dc6b8bfd99dd3252");
const _temp164 = require("302a668d5edba305");
const _temp165 = require("9fac1f4a919cba71");
const _temp166 = require("6c85e44b006b7d53");
const _temp167 = require("3355abc8b8f48701");
const _temp168 = require("40ee6f426b1bd818");
module.exports = {
    "BC_20_N": _temp0,
    "ccessibility_20_N": _temp1,
    "ddCircle_20_N": _temp2,
    "ddContent_20_N": _temp3,
    "dd_20_N": _temp4,
    "lertDiamond_20_N": _temp5,
    "lertTriangle_20_N": _temp6,
    "lignBottom_20_N": _temp7,
    "lignCenter_20_N": _temp8,
    "lignLeft_20_N": _temp9,
    "lignMiddle_20_N": _temp10,
    "lignRight_20_N": _temp11,
    "lignTop_20_N": _temp12,
    "nimationNo_20_N": _temp13,
    "nimation_20_N": _temp14,
    "pp_20_N": _temp15,
    "ppsAll_20_N": _temp16,
    "pps_20_N": _temp17,
    "rchive_20_N": _temp18,
    "rrowHeadTool_20_N": _temp19,
    "rtboard_20_N": _temp20,
    "spectRatio_20_N": _temp21,
    "sset_20_N": _temp22,
    "ttach_20_N": _temp23,
    "udioWave_20_N": _temp24,
    "utoSelectSubject_20_N": _temp25,
    "ackground_20_N": _temp26,
    "adgeVerified_20_N": _temp27,
    "ellRotated_20_N": _temp28,
    "ell_20_N": _temp29,
    "etaApp_20_N": _temp30,
    "inoculars_20_N": _temp31,
    "lur_20_N": _temp32,
    "ookmark_20_N": _temp33,
    "rand_20_N": _temp34,
    "riefcase_20_N": _temp35,
    "rightnessContrast_20_N": _temp36,
    "rush_20_N": _temp37,
    "ug_20_N": _temp38,
    "uilding_20_N": _temp39,
    "uildings_20_N": _temp40,
    "CLibrary_20_N": _temp41,
    "alendarAdd_20_N": _temp42,
    "alendarDay_20_N": _temp43,
    "alendarEdit_20_N": _temp44,
    "alendarWeek_20_N": _temp45,
    "alendar_20_N": _temp46,
    "allCenter_20_N": _temp47,
    "ameraProperties_20_N": _temp48,
    "amera_20_N": _temp49,
    "ancel_20_N": _temp50,
    "hannel_20_N": _temp51,
    "hartBarVert_20_N": _temp52,
    "hartPie_20_N": _temp53,
    "hartTrend_20_N": _temp54,
    "hat_20_N": _temp55,
    "heckBox_20_N": _temp56,
    "heckmarkCircle_20_N": _temp57,
    "heckmark_20_N": _temp58,
    "hevronDoubleLeft_20_N": _temp59,
    "hevronDoubleRight_20_N": _temp60,
    "hevronDown_20_N": _temp61,
    "hevronLeft_20_N": _temp62,
    "hevronRight_20_N": _temp63,
    "hevronUp_20_N": _temp64,
    "ircle_20_N": _temp65,
    "lockPending_20_N": _temp66,
    "lock_20_N": _temp67,
    "loseCaptions_20_N": _temp68,
    "loseCircle_20_N": _temp69,
    "lose_20_N": _temp70,
    "loudStateDisconnected_20_N": _temp71,
    "loudStateError_20_N": _temp72,
    "loudStateInProgress_20_N": _temp73,
    "loudStateOnline_20_N": _temp74,
    "loudStatePaused_20_N": _temp75,
    "loudStatePending_20_N": _temp76,
    "loudStateSlowConnection_20_N": _temp77,
    "loud_20_N": _temp78,
    "ode_20_N": _temp79,
    "ollection_20_N": _temp80,
    "olorFill_20_N": _temp81,
    "olorHarmony_20_N": _temp82,
    "olor_20_N": _temp83,
    "ommentCheckmark_20_N": _temp84,
    "ommentHide_20_N": _temp85,
    "ommentRemove_20_N": _temp86,
    "ommentShow_20_N": _temp87,
    "ommentText_20_N": _temp88,
    "omment_20_N": _temp89,
    "ommunity_20_N": _temp90,
    "ompare_20_N": _temp91,
    "ontextualTaskBar_20_N": _temp92,
    "ontrast_20_N": _temp93,
    "opy_20_N": _temp94,
    "ornerRadiusBottomLeft_20_N": _temp95,
    "ornerRadiusBottomRight_20_N": _temp96,
    "ornerRadiusEach_20_N": _temp97,
    "ornerRadiusTopLeft_20_N": _temp98,
    "ornerRadiusTopRight_20_N": _temp99,
    "ornerRadius_20_N": _temp100,
    "ropRotate_20_N": _temp101,
    "rop_20_N": _temp102,
    "ursorClick_20_N": _temp103,
    "ut_20_N": _temp104,
    "ataAdd_20_N": _temp105,
    "ataRefresh_20_N": _temp106,
    "ataSettings_20_N": _temp107,
    "ataUpload_20_N": _temp108,
    "ata_20_N": _temp109,
    "elete_20_N": _temp110,
    "eviceAll_20_N": _temp111,
    "eviceDesktopMobile_20_N": _temp112,
    "eviceDesktop_20_N": _temp113,
    "eviceLaptop_20_N": _temp114,
    "eviceMobile_20_N": _temp115,
    "eviceMultiscreen_20_N": _temp116,
    "evicePhone_20_N": _temp117,
    "eviceTablet_20_N": _temp118,
    "irectSelect_20_N": _temp119,
    "iscover_20_N": _temp120,
    "istributeBottomEdge_20_N": _temp121,
    "istributeHorizontalCenter_20_N": _temp122,
    "istributeLeftEdge_20_N": _temp123,
    "istributeRightEdge_20_N": _temp124,
    "istributeSpaceHorizontally_20_N": _temp125,
    "istributeSpaceVertically_20_N": _temp126,
    "istributeTopEdge_20_N": _temp127,
    "istributeVerticalCenter_20_N": _temp128,
    "ownload_20_N": _temp129,
    "raw_20_N": _temp130,
    "uplicate_20_N": _temp131,
    "ditNo_20_N": _temp132,
    "dit_20_N": _temp133,
    "ducation_20_N": _temp134,
    "ffectBorder_20_N": _temp135,
    "ffects_20_N": _temp136,
    "mail_20_N": _temp137,
    "moji_20_N": _temp138,
    "nterprise_20_N": _temp139,
    "rase_20_N": _temp140,
    "xportTo_20_N": _temp141,
    "xport_20_N": _temp142,
    "xposure_20_N": _temp143,
    "yedropper_20_N": _temp144,
    "eedback_20_N": _temp145,
    "ileAdd_20_N": _temp146,
    "ileConvert_20_N": _temp147,
    "ileText_20_N": _temp148,
    "ileUser_20_N": _temp149,
    "ile_20_N": _temp150,
    "iles_20_N": _temp151,
    "ilmstrip_20_N": _temp152,
    "ilter_20_N": _temp153,
    "ilters_20_N": _temp154,
    "indAndReplace_20_N": _temp155,
    "lag_20_N": _temp156,
    "lipHorizontal_20_N": _temp157,
    "lipVertical_20_N": _temp158,
    "olderAdd_20_N": _temp159,
    "olderBreadcrumb_20_N": _temp160,
    "olderClock_20_N": _temp161,
    "olderMoveTo_20_N": _temp162,
    "olderOpen_20_N": _temp163,
    "olderSearch_20_N": _temp164,
    "older_20_N": _temp165,
    "ontPicker_20_N": _temp166,
    "ullScreenExit_20_N": _temp167,
    "ullScreen_20_N": _temp168
};

},{"22ea10de82191a23":"d10jd","6a494b871c3693dc":"cDsa5","f684debcd7561bb6":"k8LxT","b35fbaaf2e74d4f4":"hkDsd","f742e1fe503cf36d":"brWL3","b05f72463ccd046d":"921LY","c08e161e345d7f":"jyuVv","1ce7f64cd319722d":"7jtI9","c175cc8daa87dfc5":"1N7d5","e8bc79b9c16c0b71":"f6GNw","9f4555f8cf526ad1":"lJNcY","38af270afd5f42d":"3I1Mp","78d58ef22f0a0114":"3y532","681464bb0949faa":"bd98e","7a92c69733da844c":"7K1NW","ae351a136d8921c2":"hd9GI","c44981913887dc6a":"k0X7J","9cd1f31a7aafc9ac":"8M00f","e55e577b3c40d4af":"2NbrT","60600b06ba310b90":"la2Hs","a7f821fa92a3f9fa":"UmfPO","b16a4fecaf4654c5":"01pVK","fdf3bea5374de66":"cyNrR","443a12539a71ab9e":"5Pkgy","aab834e9cbf3cda8":"jF3g4","b93272a878873282":"gpJrx","79cdd36a5a7435f9":"kN69E","51af5aeb0a9593ad":"4xe3L","504daced72f27389":"cQVAx","2e81aede48274ae1":"iCEaV","d800f0f56e647d68":"2370J","41346183f885f199":"gj1GO","152440846a319b3a":"krWIU","3d6200304c1583bd":"dU6kd","a7a0365cfe8327d7":"b2D5l","3af246373369013b":"1nyHS","a400a49d0e9d8d8a":"8zJWv","9b100662175635cb":"lKS2A","312d1cc73e850820":"6y5M5","57ccc929f8fe1ea5":"28VQl","b70c554608dc000e":"81MDh","f362e5c1b8df465a":"dk7oT","3d5e384d20f7a047":"aL1zM","b939b120d262d0c5":"bimOU","84929f66f20c0603":"5Rdp8","ecf8f34107ecbcc1":"827by","a81028116365dfe5":"3yrCq","e125d13bdb239803":"8F2MX","572c59566976151f":"g2mMq","196358ebfa7b6aa":"jjTpg","e035cce2850178f6":"M4C9q","b2c06619221f8388":"iIgvl","e6d6d703f13d74e5":"2lNmz","b9148241927bb0d2":"bDzGq","2e193f4a14ec827":"c4s9O","87131ba9dd2ae1e0":"iaAWm","bbfb0d6f9a5d4f91":"in5JG","80cf030247a39252":"6hpGX","84f6e9309a29277c":"1QXwE","6156113b7af0778e":"hmKpo","a4923242450d03b6":"1TE6V","fb9e39d52626fa16":"erT5A","e7d04495c5eec01a":"5jnVm","6fe239fa6ac3011b":"kmqkh","6620a7e30c626b89":"jSLkY","2743e437e09c1555":"4exIF","a01618504bc3a25d":"kKJJv","7f8b1e8ae6051ade":"iihF3","277ed689fef364f1":"jS6vK","71bbc8b1143601ea":"k1FvW","1f0d9583d1f9d15b":"aI18O","c573c892febb80d3":"727hu","8826759295d20c5a":"2H4mr","45e219f5da8a9f65":"1X7NR","a308ee402b1ea4d2":"3NngQ","cfd9d2a4b251275f":"2EIpu","cd80d320530d9de7":"5MXoX","3204425227cabf61":"eR09f","32f4561b0f259626":"1huEG","a6d23796b28fe66b":"8rpVg","7ac2bfb847904a2f":"aWHKw","a7b0b22e8436592e":"jBc3C","abad28d289577b12":"8oMAI","8ec2ed6334adaaf4":"fTKa2","fcacd946baced24d":"14bSM","af99db704f3603c4":"llsW4","be3e81348a878e24":"3G75z","f9160bf4ce9c062c":"ihnDL","481c92ccef22bc5f":"fLdl8","965d5353da26ca9d":"aQjFO","254548cfa14e2d4":"dRvKc","b981ec9aa3aeab90":"bB4qC","af8a4ba07fc90502":"iAwMm","36d29c7cca068399":"jAv02","7907f3f728d597d8":"6imrL","d89795e16c0a23b6":"uJMHG","73a6240574d69419":"5Tiyw","4f26f54708506ad3":"jUoeK","d51e68a5233da376":"8JlGs","dc38e842fdd13bf9":"eDnn5","6eea65035fc5e03":"lwOQJ","7b6f4b3f905a0e87":"901M5","1673a4f5e6db817e":"bZPpG","ed1915515d73d532":"01Om8","9947540d615b66bd":"7CXbj","727756ed3a052e3e":"7TXs3","e1db011946639c32":"5i8F6","5f8c5af9705ee6b9":"cHrqP","bc04f581482e245":"l6Fye","168308869a3b3fa8":"77KV8","1310c63d688f10ab":"elAa6","7a0df299f01e3123":"4sR3H","41eb48722eb183de":"6ZTaF","ae9cd2ff087e9d84":"g9qPz","63b1476b2ad276b1":"auIka","b096cfcb8d5b9485":"7DJon","60d5fef6f1bfec04":"8DFUz","e1aabea95740854f":"6988a","258eed6ddf7842b4":"WD2xG","21e5b7285f122fc5":"2qhE3","235b31169ffbeccb":"6D32N","f295949f90497e4b":"jyhIC","2f0bb4d1ab9939c9":"bFGRm","87d7fab47e926958":"iq2rD","3049aede7c8e01e0":"aXPzo","2b94aa296880a3ed":"1PyrC","9e8811c9c628962a":"fk1ac","632bce3abd75ad4e":"hHUco","18436cee77735b7d":"KLXIn","447b13664dbd70ad":"jifhr","89f0c672a2b63ae":"fSeMY","ca7074fc8d0eeead":"bHSBe","d7440c1aacf6d163":"lB02x","efd11e039f58f6f0":"h4rDR","cae10d29618e6997":"bf5nW","c4e49074126e0f22":"RFzUR","c5a8bea32a6b37bf":"jyYA8","1cb7a96b4c3e40c4":"a0yC6","8956c16054e27de8":"cHQyX","e004ad85ce7b0614":"lift3","e2fadb053b857606":"8Xxyi","f760fdd1a8533298":"l22kS","41e874fec7f19094":"ldsyU","32ac7b0ce19c6d2":"4rCzU","c175ae360f239ab2":"euK87","534ba73c123c3442":"iz1uk","dd9baa5a8a7062af":"2sRPb","4be409afe01215bb":"1FyXF","cb7fbc766a0c4ba8":"8dGEU","809a69d84a7bfcb4":"1Dl3M","3aa8773c520343dc":"99rjs","440ddd3cbc77b72b":"b0jYl","97415a79e985f3c0":"lbNh6","da395f8ec1f234a2":"6kxa6","7e28c7d1662e7de8":"frTYk","c7bff70cb9218693":"lCGFj","9ad8d2dbdd6d2bdd":"83kmp","a5133aadbe540278":"2IzpU","8232effc69a19ff6":"4vT2q","6638297e322cad0e":"7YABU","dd4f2dc45a6341aa":"eTHST","ea535226d262b799":"jYQ0I","8c5c740c3dfd7613":"g0aKy","dc6b8bfd99dd3252":"llhOx","302a668d5edba305":"hGSuR","9fac1f4a919cba71":"dLqBo","6c85e44b006b7d53":"lVbjz","3355abc8b8f48701":"4j7PJ","40ee6f426b1bd818":"6KAi8"}],"1N7d5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.75 11h-3V9h1C12.99 9 14 7.99 14 6.75v-1.5C14 4.01 12.99 3 11.75 3h-1V1.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75V3h-1C7.01 3 6 4.01 6 5.25v1.5C6 7.99 7.01 9 8.25 9h1v2h-3C5.01 11 4 12.01 4 13.25v1.5C4 15.99 5.01 17 6.25 17h3v1.25c0 .414.336.75.75.75s.75-.336.75-.75V17h3c1.24 0 2.25-1.01 2.25-2.25v-1.5c0-1.24-1.01-2.25-2.25-2.25M7.5 6.75v-1.5c0-.413.336-.75.75-.75h3.5c.414 0 .75.337.75.75v1.5c0 .413-.336.75-.75.75h-3.5c-.414 0-.75-.337-.75-.75m7 8c0 .413-.336.75-.75.75h-7.5c-.414 0-.75-.337-.75-.75v-1.5c0-.413.336-.75.75-.75h7.5c.414 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"f6GNw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10.75 9h-3.5C6.01 9 5 7.99 5 6.75v-1.5C5 4.01 6.01 3 7.25 3h3.5C11.99 3 13 4.01 13 5.25v1.5C13 7.99 11.99 9 10.75 9m-3.5-4.5c-.414 0-.75.337-.75.75v1.5c0 .413.336.75.75.75h3.5c.414 0 .75-.337.75-.75v-1.5c0-.413-.336-.75-.75-.75zM14.75 17h-7.5C6.01 17 5 15.99 5 14.75v-1.5C5 12.01 6.01 11 7.25 11h7.5c1.24 0 2.25 1.01 2.25 2.25v1.5c0 1.24-1.01 2.25-2.25 2.25m-7.5-4.5c-.414 0-.75.337-.75.75v1.5c0 .413.336.75.75.75h7.5c.414 0 .75-.337.75-.75v-1.5c0-.413-.336-.75-.75-.75zM2.75 19c-.414 0-.75-.336-.75-.75V1.75c0-.414.336-.75.75-.75s.75.336.75.75v16.5c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3I1Mp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.75 9h-3.5C8.01 9 7 7.99 7 6.75v-1.5C7 4.01 8.01 3 9.25 3h3.5C13.99 3 15 4.01 15 5.25v1.5C15 7.99 13.99 9 12.75 9m-3.5-4.5c-.414 0-.75.337-.75.75v1.5c0 .413.336.75.75.75h3.5c.414 0 .75-.337.75-.75v-1.5c0-.413-.336-.75-.75-.75zM12.75 17h-7.5C4.01 17 3 15.99 3 14.75v-1.5C3 12.01 4.01 11 5.25 11h7.5c1.24 0 2.25 1.01 2.25 2.25v1.5c0 1.24-1.01 2.25-2.25 2.25m-7.5-4.5c-.414 0-.75.337-.75.75v1.5c0 .413.336.75.75.75h7.5c.414 0 .75-.337.75-.75v-1.5c0-.413-.336-.75-.75-.75zM17.25 19c-.414 0-.75-.336-.75-.75V1.75c0-.414.336-.75.75-.75s.75.336.75.75v16.5c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3yrCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 3h-2V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3 2 4.01 2 5.25v10.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V5.25C18 4.01 16.99 3 15.75 3M4.25 4.5h2V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.414 0 .75.337.75.75V7h-13V5.25c0-.413.336-.75.75-.75m11.5 12H4.25c-.414 0-.75-.337-.75-.75V8.5h13v7.25c0 .413-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 10,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 5,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 9,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 2,
                x: 13,
                y: 13,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jjTpg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 17H3.25C2.01 17 1 15.99 1 14.75v-7.5C1 6.01 2.01 5 3.25 5h1.823c.286 0 .543-.16.67-.414l.172-.342C6.298 3.477 7.069 3 7.927 3h4.146c.858 0 1.629.477 2.012 1.244l.171.342c.128.255.385.414.671.414h1.823C17.99 5 19 6.01 19 7.25v7.5c0 1.24-1.01 2.25-2.25 2.25M3.25 6.5c-.414 0-.75.337-.75.75v7.5c0 .413.336.75.75.75h13.5c.414 0 .75-.337.75-.75v-7.5c0-.413-.336-.75-.75-.75h-1.823c-.858 0-1.629-.477-2.012-1.244l-.171-.342c-.128-.255-.385-.414-.671-.414H7.927c-.286 0-.543.16-.67.414l-.172.342C6.702 6.023 5.931 6.5 5.073 6.5z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 14.5c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4M10 8c-1.378 0-2.5 1.121-2.5 2.5S8.622 13 10 13s2.5-1.121 2.5-2.5S11.378 8 10 8"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1QXwE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.864 15.734c-.222 0-.433-.098-.576-.27l-3.747-4.497c-.266-.319-.222-.792.096-1.057.317-.265.79-.223 1.056.096l3.154 3.786 7.44-9.469c.255-.326.728-.382 1.052-.127.326.256.383.728.127 1.053L8.454 15.447c-.14.179-.352.284-.579.287z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aI18O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m11.06 10 5.207-5.206c.293-.293.293-.768 0-1.06s-.767-.294-1.06 0L10 8.938 4.793 3.733c-.293-.293-.767-.293-1.06 0s-.293.768 0 1.06L8.939 10l-5.206 5.206c-.293.293-.293.768 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L10 11.062l5.207 5.206c.146.146.338.22.53.22s.384-.074.53-.22c.293-.293.293-.768 0-1.06z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7CXbj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.477 7.606q-.121.001-.242-.04c-.392-.132-.602-.56-.468-.95L12.5 1.518c.134-.393.558-.604.951-.47s.603.56.469.952l-1.733 5.097c-.107.312-.398.508-.71.508"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M19.12 6.718c-.135-.393-.56-.604-.952-.469l-7.29 2.48c-.332.112-.692.168-1.132.232-.652.095-1.463.406-2.31.863-.031-.762-.327-1.514-.907-2.095-1.226-1.227-3.221-1.225-4.448 0-1.227 1.227-1.227 3.222 0 4.449.613.613 1.419.92 2.225.92.777 0 1.553-.294 2.158-.867.017-.011.037-.016.055-.029 1.135-.872 2.228-1.415 2.98-1.644l-.271.907c-.09.299-.187.535-.306.745-.274.485-.605.983-.955 1.441-.011.015-.013.032-.023.046-1.173 1.23-1.162 3.182.047 4.39.613.614 1.42.92 2.225.92s1.61-.306 2.223-.92c1.227-1.226 1.227-3.22 0-4.447-.583-.583-1.34-.88-2.106-.91.125-.251.238-.52.332-.834l.51-1.7c.062-.018.123-.027.185-.048l7.29-2.48c.393-.132.603-.559.47-.95m-15.978 4.4c-.642-.642-.642-1.686 0-2.328.32-.32.742-.481 1.164-.481.42 0 .841.16 1.163.481.64.642.64 1.686 0 2.327-.643.644-1.685.64-2.327 0m8.237 5.91c-.643.641-1.685.64-2.327 0-.642-.642-.642-1.686 0-2.328.64-.638 1.686-.64 2.327 0 .642.642.642 1.686 0 2.327"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"elAa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.249 15.021c-.4 0-.733-.317-.748-.72l-.25-6.5c-.017-.414.307-.763.72-.779H8c.4 0 .733.317.748.72l.25 6.5c.017.414-.307.763-.72.778zM11.751 15.021h-.03c-.413-.016-.737-.365-.72-.779l.25-6.5c.015-.403.348-.72.748-.72h.03c.413.016.737.365.72.779l-.25 6.5c-.015.403-.348.72-.748.72"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17 4h-3.5v-.75C13.5 2.01 12.49 1 11.25 1h-2.5C7.51 1 6.5 2.01 6.5 3.25V4H3c-.414 0-.75.336-.75.75s.336.75.75.75h.52l.422 10.342C3.99 17.052 4.98 18 6.19 18h7.62c1.211 0 2.2-.948 2.248-2.158L16.48 5.5H17c.414 0 .75-.336.75-.75S17.414 4 17 4m-9-.75c0-.413.337-.75.75-.75h2.5c.413 0 .75.337.75.75V4H8zm6.56 12.531c-.017.404-.346.719-.75.719H6.19c-.404 0-.733-.315-.75-.719L5.02 5.5h9.96z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g9qPz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14 18.5H6c-.414 0-.75-.336-.75-.75S5.586 17 6 17h8c.414 0 .75.336.75.75s-.336.75-.75.75M16.75 16H3.25C2.01 16 1 14.99 1 13.75v-8.5C1 4.01 2.01 3 3.25 3h13.5C17.99 3 19 4.01 19 5.25v8.5c0 1.24-1.01 2.25-2.25 2.25M3.25 4.5c-.413 0-.75.337-.75.75v8.5c0 .413.337.75.75.75h13.5c.413 0 .75-.337.75-.75v-8.5c0-.413-.337-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"WD2xG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 9.998,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M3.25 2.998h13.5c1.24 0 2.25 1.01 2.25 2.25v9.5c0 1.24-1.01 2.25-2.25 2.25H3.25c-1.24 0-2.25-1.01-2.25-2.25v-9.5c0-1.24 1.01-2.25 2.25-2.25m13.5 12.5c.413 0 .75-.337.75-.75v-9.5c0-.413-.337-.75-.75-.75H3.25c-.413 0-.75.337-.75.75v9.5c0 .413.337.75.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iz1uk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.25 19q-.151 0-.294-.06c-.276-.118-.456-.39-.456-.69V15h-.75C2.683 15 1 13.317 1 11.25v-5.5C1 3.683 2.683 2 4.75 2h10.5C17.317 2 19 3.683 19 5.75v5.5c0 2.067-1.683 3.75-3.75 3.75h-4.543l-3.936 3.79c-.143.138-.33.21-.521.21M4.75 3.5C3.51 3.5 2.5 4.51 2.5 5.75v5.5c0 1.24 1.01 2.25 2.25 2.25h1.5c.414 0 .75.336.75.75v2.236l2.884-2.776c.14-.135.326-.21.52-.21h4.846c1.24 0 2.25-1.01 2.25-2.25v-5.5c0-1.24-1.01-2.25-2.25-2.25z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5.5,
                cy: 8.5,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 8.5,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.5,
                cy: 8.5,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8dGEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m16.34 5.296-3.62-3.622c-.42-.42-1-.66-1.591-.66H5.25C4.01 1.015 3 2.025 3 3.265v12.484c0 1.24 1.01 2.25 2.25 2.25h9.5c1.24 0 2.25-1.01 2.25-2.25V6.887c0-.6-.234-1.166-.66-1.591m-1.06 1.06c.046.047.074.104.106.159H12.25c-.413 0-.75-.337-.75-.75V2.628c.055.033.114.06.16.106zm-.53 10.142h-9.5c-.413 0-.75-.337-.75-.75V3.265c0-.413.337-.75.75-.75H10v3.25c0 1.24 1.01 2.25 2.25 2.25h3.25v7.733c0 .413-.337.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 11.498H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6c.414 0 .75.336.75.75s-.336.75-.75.75M13 14.498H7c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"99rjs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.341 5.28 12.72 1.66c-.425-.426-.99-.66-1.59-.66H5.25C4.01 1 3 2.01 3 3.25v12.5C3 16.99 4.01 18 5.25 18h9.5c1.24 0 2.25-1.01 2.25-2.25V6.871c0-.592-.24-1.172-.659-1.59m-1.06 1.06c.045.046.073.105.105.16H12.25c-.414 0-.75-.337-.75-.75V2.614c.055.032.113.06.159.106zM14.75 16.5h-9.5c-.414 0-.75-.337-.75-.75V3.25c0-.413.336-.75.75-.75H10v3.25C10 6.99 11.01 8 12.25 8h3.25v7.75c0 .413-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lbNh6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.25 7h-.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.917 7h-.5c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M8.584 7h-.5c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M5.25 7h-.5C4.336 7 4 6.664 4 6.25s.336-.75.75-.75h.5c.414 0 .75.336.75.75S5.664 7 5.25 7M15.25 14.5h-.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M11.917 14.5h-.5c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M8.584 14.5h-.5c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75M5.25 14.5h-.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.5c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 17H3.25C2.01 17 1 15.99 1 14.75v-9.5C1 4.01 2.01 3 3.25 3h13.5C17.99 3 19 4.01 19 5.25v9.5c0 1.24-1.01 2.25-2.25 2.25M3.25 4.5c-.414 0-.75.337-.75.75v9.5c0 .413.336.75.75.75h13.5c.414 0 .75-.337.75-.75v-9.5c0-.413-.336-.75-.75-.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"zfibg":[function(require,module,exports,__globalThis) {
const _temp0 = require("3e70dea49296d8e4");
const _temp1 = require("8eda0cadd1cdbf66");
const _temp2 = require("1e4224735850d166");
const _temp3 = require("ec0a9443342e1c43");
const _temp4 = require("e7e135f997a171d4");
const _temp5 = require("f57cff6577a4c574");
const _temp6 = require("f1dec440eb577384");
const _temp7 = require("d22dbdb42aa83307");
const _temp8 = require("95dbf7fedd0f22");
const _temp9 = require("94a24f52f667c194");
const _temp10 = require("dac94c6481c64738");
const _temp11 = require("f7a223dce2525153");
const _temp12 = require("560b1fc0c6672b0d");
const _temp13 = require("b584c3ce3cfd1a28");
const _temp14 = require("6f1b5753473ed140");
const _temp15 = require("71f56aef76146487");
const _temp16 = require("2eaceda764cdb72");
const _temp17 = require("6734ab69c184fb92");
const _temp18 = require("8acbe23f63001b06");
const _temp19 = require("b5833717d065bb1a");
const _temp20 = require("1291ee8ae0c0b9d2");
const _temp21 = require("4a8c579abf4b5bbf");
const _temp22 = require("daa1c16800168338");
const _temp23 = require("95ca887f0658f91d");
const _temp24 = require("9cfadcc70678cb35");
const _temp25 = require("2f33adcf9fc2e7ac");
const _temp26 = require("dc160b4ae28d7ce7");
const _temp27 = require("4b681c03bd6e364f");
const _temp28 = require("3724b4cbf03afe9a");
const _temp29 = require("e894ca28fd048a8");
const _temp30 = require("e92e5a50b5e6a9e7");
const _temp31 = require("507e23acc1fa23e");
const _temp32 = require("d99c7d96cbacf895");
const _temp33 = require("6d25ac0669ed737e");
const _temp34 = require("b0f24f32c656f25e");
const _temp35 = require("86974b3e1cee817e");
const _temp36 = require("94b94f7390928a02");
const _temp37 = require("b89e1e98becd8147");
const _temp38 = require("9499496cc05afd1");
const _temp39 = require("4271157bdd23dea9");
const _temp40 = require("e939a2cf61e28fc0");
const _temp41 = require("8b8065c782283c13");
const _temp42 = require("e9978250f8477e49");
const _temp43 = require("479d462f6405a798");
const _temp44 = require("431b54b87b45984a");
const _temp45 = require("d1224343720b4490");
const _temp46 = require("21eb963e9f173536");
const _temp47 = require("b184e6ca27e15d58");
const _temp48 = require("62b5bd2f670f2136");
const _temp49 = require("bf3848ddb3cb2723");
const _temp50 = require("368a506ce5a80c64");
const _temp51 = require("deec1f8811ea2a61");
const _temp52 = require("22cf496ea86138da");
const _temp53 = require("185a734fcae08419");
const _temp54 = require("77d933355b9322b1");
const _temp55 = require("c0d25e0a1f9626d6");
const _temp56 = require("a60fde4f620381a");
const _temp57 = require("ba2b45ef6114ee64");
const _temp58 = require("448bf87893d04e22");
const _temp59 = require("8f2e2ff81829e139");
const _temp60 = require("2d669ee7e92e913f");
const _temp61 = require("aeba6fc136d7b96a");
const _temp62 = require("544b79f04de7b352");
const _temp63 = require("e8ede6a9421cbae9");
const _temp64 = require("b4d27155f5d2a7c2");
const _temp65 = require("82bda3a6338d340c");
const _temp66 = require("395a7c88219e9a10");
const _temp67 = require("ab12900fc1b393cc");
const _temp68 = require("68ccbcd8f12c2ce4");
const _temp69 = require("9baebdd3547fcdc0");
const _temp70 = require("424e8bcc706b5e1a");
const _temp71 = require("f865565c417ff2e2");
module.exports = {
    "IGenerate": _temp0,
    "IGenerateImage": _temp1,
    "Ichat": _temp2,
    "ccessibility": _temp3,
    "nimation": _temp4,
    "pps": _temp5,
    "rtboard": _temp6,
    "ssets": _temp7,
    "udioWave": _temp8,
    "adgeVerified": _temp9,
    "ell": _temp10,
    "olt": _temp11,
    "rand": _temp12,
    "riefcase": _temp13,
    "rightnessContrast": _temp14,
    "rowser": _temp15,
    "rush": _temp16,
    "uildTable": _temp17,
    "uildings": _temp18,
    "alendar": _temp19,
    "amera": _temp20,
    "ardTapPayment": _temp21,
    "hannel": _temp22,
    "hartAreaStack": _temp23,
    "hatbubble": _temp24,
    "heckmark": _temp25,
    "lipboard": _temp26,
    "lock": _temp27,
    "loud": _temp28,
    "loudUpload": _temp29,
    "odeBrackets": _temp30,
    "olor": _temp31,
    "ommentText": _temp32,
    "onfetti": _temp33,
    "onversationbubbles": _temp34,
    "rop": _temp35,
    "ursor": _temp36,
    "ut": _temp37,
    "ata": _temp38,
    "ataAnalytics": _temp39,
    "esktop": _temp40,
    "iamond": _temp41,
    "ocument": _temp42,
    "ownload": _temp43,
    "ropToUpload": _temp44,
    "ducation": _temp45,
    "ffects": _temp46,
    "moji": _temp47,
    "mptyStateExport": _temp48,
    "xplosion": _temp49,
    "xportTo": _temp50,
    "xposure": _temp51,
    "ileImage": _temp52,
    "ileShared": _temp53,
    "ileText": _temp54,
    "ileVideo": _temp55,
    "ileZip": _temp56,
    "ilmstrip": _temp57,
    "ilter": _temp58,
    "ilters": _temp59,
    "ireworks": _temp60,
    "lag": _temp61,
    "lagCheckmark": _temp62,
    "lagCross": _temp63,
    "olderClose": _temp64,
    "olderOpen": _temp65,
    "olderShared": _temp66,
    "earSetting": _temp67,
    "ift": _temp68,
    "lobe": _temp69,
    "lobeGrid": _temp70,
    "raphBarChart": _temp71
};

},{"3e70dea49296d8e4":"l3Hza","8eda0cadd1cdbf66":"4PAM8","1e4224735850d166":"9QwJC","ec0a9443342e1c43":"1XwTL","e7e135f997a171d4":"gD4GR","f57cff6577a4c574":"T9ZLI","f1dec440eb577384":"yT7oo","d22dbdb42aa83307":"8mBp6","95dbf7fedd0f22":"hPr4e","94a24f52f667c194":"csZiV","dac94c6481c64738":"iSDZg","f7a223dce2525153":"bIkVd","560b1fc0c6672b0d":"4tYaF","b584c3ce3cfd1a28":"fi9Bg","6f1b5753473ed140":"lWhHV","71f56aef76146487":"gp5R9","2eaceda764cdb72":"iCgMs","6734ab69c184fb92":"loXrT","8acbe23f63001b06":"91Uor","b5833717d065bb1a":"fBDS2","1291ee8ae0c0b9d2":"6lgV2","4a8c579abf4b5bbf":"3XLkp","daa1c16800168338":"hhqlq","95ca887f0658f91d":"6SKjY","9cfadcc70678cb35":"94wVJ","2f33adcf9fc2e7ac":"9MIHx","dc160b4ae28d7ce7":"3d7wX","4b681c03bd6e364f":"N174r","3724b4cbf03afe9a":"iIWnO","e894ca28fd048a8":"b2eQp","e92e5a50b5e6a9e7":"d1eFs","507e23acc1fa23e":"9Q9oJ","d99c7d96cbacf895":"iDLi4","6d25ac0669ed737e":"1ReqF","b0f24f32c656f25e":"8AR0h","86974b3e1cee817e":"4DWoN","94b94f7390928a02":"hvjtV","b89e1e98becd8147":"8Gr0F","9499496cc05afd1":"k8rmp","4271157bdd23dea9":"eHVZM","e939a2cf61e28fc0":"liZ4p","8b8065c782283c13":"c3ZM2","e9978250f8477e49":"7neWy","479d462f6405a798":"5wtWW","431b54b87b45984a":"31xYA","d1224343720b4490":"gD8JL","21eb963e9f173536":"aAN8U","b184e6ca27e15d58":"deLX9","62b5bd2f670f2136":"cifcc","bf3848ddb3cb2723":"k8zJ7","368a506ce5a80c64":"3Ykxh","deec1f8811ea2a61":"817xM","22cf496ea86138da":"eMsEB","185a734fcae08419":"d4K3F","77d933355b9322b1":"9JGb8","c0d25e0a1f9626d6":"d4Ej5","a60fde4f620381a":"544yl","ba2b45ef6114ee64":"aDNoU","448bf87893d04e22":"k74aO","8f2e2ff81829e139":"4PuMK","2d669ee7e92e913f":"8NEyY","aeba6fc136d7b96a":"H9h76","544b79f04de7b352":"dFij3","e8ede6a9421cbae9":"2YHMf","b4d27155f5d2a7c2":"j55y7","82bda3a6338d340c":"957Z0","395a7c88219e9a10":"4DM6V","ab12900fc1b393cc":"jZeBG","68ccbcd8f12c2ce4":"8muEX","9baebdd3547fcdc0":"aqJ7U","424e8bcc706b5e1a":"kbYRW","f865565c417ff2e2":"gMm0k"}],"99ubT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "States", ()=>States);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
'use client';
function States() {
    let ref = (0, _react.useRef)(null);
    let [isPressed, setPressed] = (0, _react.useState)(false);
    let [isHovered, setHovered] = (0, _react.useState)(false);
    let [variant, setVariant] = (0, _react.useState)('accent');
    let [isDisabled, setDisabled] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " se11 Cb24z611 CqVWUq0b11 DM8Mfn11 DqQHViNd11 EqPlN5qb11 qYB8I11 qqs7Vxmb11 Us7Vxmb11 UqYB8I11 eb11 g_g11 od11 on5NLVAe11 nd11 nn5NLVAe11 kd11 kn5NLVAe11 jd11 jn5NLVAe11 _n4zCLMe11 Th11 Qh11 Sh11 Rh11 JYB8I11 GuTsfBd11 GnYB8I11 IuTsfBd11 InYB8I11 HuTsfBd11 HnYB8I11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " zxR4vs11 yxR4vs11 BxR4vs11 AxR4vs11 sd11 _ta11 eb11 eqd11 UB1JKEb11 qB1JKEb11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Picker), {
                        label: "Variant",
                        labelPosition: "side",
                        value: variant,
                        onChange: (key)=>setVariant(key),
                        styles: " ZA2gjzc11",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "accent",
                                children: "accent"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                                id: "negative",
                                children: "negative"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Checkbox), {
                        isSelected: isDisabled,
                        onChange: setDisabled,
                        children: "Disabled"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " zZKv3Id11 yZKv3Id11 BZKv3Id11 AZKv3Id11 sd11 eb11 _Ca11",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                    ref: ref,
                    onPressChange: setPressed,
                    onHoverChange: setHovered,
                    isDisabled: isDisabled,
                    className: (renderProps)=>(function anonymous(props) {
                            let rules = " ";
                            if (props.isFocusVisible) rules += ' _Lf11';
                            else rules += ' _Le11';
                            rules += ' Oh11';
                            rules += ' OlOVIhfcebS7sd11';
                            rules += ' OlOVIhfcebS7sd11';
                            rules += ' _Mc11';
                            rules += ' _Kd11';
                            rules += ' uk11';
                            rules += ' ucJ9TBTb11';
                            rules += ' ud3Euai11';
                            rules += ' uea11';
                            rules += ' ugb11';
                            rules += ' uhd11';
                            rules += ' uje11';
                            rules += ' u2NhKxcl11';
                            rules += ' uic11';
                            rules += ' -_6BNtrc-e11';
                            rules += ' vFHT6Dd11';
                            rules += ' xc11';
                            rules += ' _xa11';
                            rules += ' _Fd11';
                            rules += ' _FnuYUweb11';
                            if (props.isDisabled) rules += ' pp11';
                            else rules += ' pr11';
                            rules += ' _4c11';
                            rules += ' FRuFGYc11';
                            rules += ' Sw11';
                            rules += ' Rw11';
                            rules += ' _je11';
                            rules += ' oh11';
                            rules += ' nh11';
                            rules += ' kh11';
                            rules += ' jh11';
                            rules += ' Yd11';
                            rules += ' Xb11';
                            rules += ' _2b11';
                            rules += ' __ca11';
                            if (props.isDisabled) rules += ' gH11';
                            else if (props.variant === "negative") {
                                if (props.isPressed) rules += ' g884m811';
                                else if (props.isHovered) rules += ' gt11';
                                else rules += ' g_d11';
                            } else if (props.variant === "accent") {
                                if (props.isPressed) rules += ' glnzVfe11';
                                else if (props.isHovered) rules += ' gY11';
                                else rules += ' g311';
                            }
                            rules += ' -F_-FBaYFfc11';
                            return rules;
                        })({
                            ...renderProps,
                            variant
                        }),
                    children: "Action"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Divider), {
                orientation: "vertical",
                styles: " zsbzJv11 ysbzJv11 BsbzJv11 AsbzJv11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                className: " uj11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 pt11 JYB8I11 GuTsfBd11 GnYB8I11 z27eCrc11 y27eCrc11 B27eCrc11 A27eCrc11 _Na11 Pa11 IuTsfBd11 InYB8I11 HuTsfBd11 HnYB8I11",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                    style: {
                        fontFamily: 'inherit',
                        WebkitTextSizeAdjust: 'none'
                    },
                    children: [
                        '<',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.function,
                            children: "Button"
                        }),
                        '\n  ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.property,
                            children: "className"
                        }),
                        '={',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.variable,
                            children: "states"
                        }),
                        ' => ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.function,
                            children: "style"
                        }),
                        '({\n    ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.property,
                            children: "backgroundColor"
                        }),
                        ': {\n      ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.property,
                            children: "default"
                        }),
                        ': {\n        ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.property,
                            children: "variant"
                        }),
                        ': {\n          ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: highlight({
                                isHighlighted: variant === 'accent' && !isDisabled
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: styles.property,
                                children: "accent"
                            })
                        }),
                        ': {\n            ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: highlight({
                                isHighlighted: variant === 'accent' && !isHovered && !isPressed && !isDisabled
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.property,
                                    children: "default"
                                }),
                                ": ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.string,
                                    children: "'accent-900'"
                                }),
                                ',\n            '
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: highlight({
                                isHighlighted: variant === 'accent' && isHovered && !isPressed && !isDisabled
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.property,
                                    children: "isHovered"
                                }),
                                ": ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.string,
                                    children: "'accent-1000'"
                                }),
                                ',\n            '
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: highlight({
                                isHighlighted: variant === 'accent' && isPressed && !isDisabled
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.property,
                                    children: "isPressed"
                                }),
                                ": ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.string,
                                    children: "'accent-1100'"
                                }),
                                '\n          '
                            ]
                        }),
                        '},\n          ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: highlight({
                                isHighlighted: variant === 'negative' && !isDisabled
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: styles.property,
                                children: "negative"
                            })
                        }),
                        ': {\n            ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: highlight({
                                isHighlighted: variant === 'negative' && !isHovered && !isPressed && !isDisabled
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.property,
                                    children: "default"
                                }),
                                ": ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.string,
                                    children: "'negative-900'"
                                }),
                                ',\n            '
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: highlight({
                                isHighlighted: variant === 'negative' && isHovered && !isPressed && !isDisabled
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.property,
                                    children: "isHovered"
                                }),
                                ": ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.string,
                                    children: "'negative-1000'"
                                }),
                                ',\n            '
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: highlight({
                                isHighlighted: variant === 'negative' && isPressed && !isDisabled
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.property,
                                    children: "isPressed"
                                }),
                                ": ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.string,
                                    children: "'negative-1100'"
                                }),
                                '\n          '
                            ]
                        }),
                        '}\n        ',
                        '},\n        ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: highlight({
                                isHighlighted: isDisabled
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.property,
                                    children: "isDisabled"
                                }),
                                ": ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: styles.string,
                                    children: "'gray-100'"
                                }),
                                '\n      '
                            ]
                        }),
                        '}\n    ',
                        '}\n  ',
                        '})({...',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.variable,
                            children: "states"
                        }),
                        ", ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.variable,
                            children: "variant"
                        }),
                        '})}>\n',
                        '  Action\n',
                        '</',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: styles.function,
                            children: "Button"
                        }),
                        '>'
                    ]
                })
            })
        ]
    });
}
const styles = {
    string: " p8wMsQe11",
    number: " pG3CxWc11",
    property: " pz2bZib11",
    function: " p37ZLpd11",
    variable: " p1gYRFc11"
};
const highlight = function anonymous(props) {
    let rules = " ";
    if (props.isHighlighted) {
        rules += ' xd11';
        rules += ' _xa11';
        rules += ' xX0cczbc11';
        rules += ' _xX0cczba11';
    }
    return rules;
};

},{"0":"bXktf","1":"bXktf","2":"bXktf","3":"bXktf","4":"bXktf","5":"bXktf","6":"bXktf","7":"bXktf","8":"bXktf","9":"bXktf","10":"bXktf","11":"bXktf","12":"bXktf","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Checkbox","jdSVu"],["Divider","kGk2u"],["Picker","akpch"],["PickerItem","akpch"]],"react":"a1TxN","react-aria-components":"9G5XO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i0WOf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Responsive", ()=>Responsive);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _darkMode = require("./DarkMode");
var _exampleApp = require("./ExampleApp");
'use client';
function Responsive() {
    let containerRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " JYB8I11 GuTsfBd11 GnYB8I11 IuTsfBd11 InYB8I11 HuTsfBd11 HnYB8I11 -jmjrke-od11 -jmjrke-no5NLVAe11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " _Pc11 F4dY0ec11 Z8Mqurc11 _oa11 _kb11 hb11 mb11 lb11 ileetpd11 _jf11 GB1JKEb11 gOijsW11 oH5kTnc11 nH5kTnc11 kH5kTnc11 jH5kTnc11 _Nb11 Pb11 sk11 snb11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MiniTicks, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tick, {
                        name: "default",
                        pos: 0
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tick, {
                        name: "xs",
                        pos: 480
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tick, {
                        name: "sm",
                        pos: 640
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tick, {
                        name: "md",
                        pos: 768
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tick, {
                        name: "lg",
                        pos: 1024
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tick, {
                        name: "xl",
                        pos: 1280
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: containerRef,
                className: " _Pc11 Fdrw1ne11 sk11 snb11",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _darkMode.Resizable), {
                    minWidth: 330,
                    containerRef: containerRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleApp.ExampleApp), {})
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _Pc11 Fdrw1ne11 sb11 snk11",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exampleApp.ExampleApp), {})
            })
        ]
    });
}
function Tick({ name, pos }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            insetInlineStart: (pos - 1) / 16 + 'rem'
        },
        className: " _Pa11 _ka11 ha11 mb11 la11 i1gTUEb11 _jf11 St11 uj11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 p13PTIc11 Fb11 sd11 eb11",
        children: name
    });
}
function MiniTicks() {
    let ticks = [];
    for(let i = 0; i < 1536; i += 16)ticks.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            insetInlineStart: (i - 1) / 16 + 'rem',
            height: i % 64 === 0 ? 6 : 4
        },
        className: " _Pa11 _ka11 ha11 mb11 la11 i1gTUEb11 _jf11 _lr11"
    }, i));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: ticks
    });
}

},{"0":"bXktf","1":"bXktf","2":"bXktf","3":"bXktf","4":"bXktf","5":"bXktf","react/jsx-runtime":"2Is6Z","react":"a1TxN","./DarkMode":"dWvIx","./ExampleApp":"ALRve","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g1Xtq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReduceMotion", ()=>ReduceMotion);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAria = require("react-aria");
var _s2 = require("@react-spectrum/s2");
'use client';
function ReduceMotion() {
    let ref = (0, _react.useRef)(null);
    let [reduceMotion, setReduceMotion] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (matchMedia('(prefers-reduced-motion)').matches) setReduceMotion(true);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAria.UNSAFE_PortalProvider), {
        getContainer: ()=>ref.current,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ToastContainer), {
                // @ts-ignore
                PRIVATE_forceReducedMotion: reduceMotion
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: ref,
                className: " _ZyU6og11 FtW6OHc11 _Nb11 Pb11 g_g11 _nLeasBb11 od11 on5NLVAe11 nd11 nn5NLVAe11 kd11 kn5NLVAe11 jd11 jn5NLVAe11 Tk11 Qk11 Sk11 Rk11 sd11 _ta11 _tnc11 eb11 ena11 _Cg11 _Cna11 UB1JKEb11 qB1JKEb11 _oa11 JYB8I11 GuTsfBd11 GnYB8I11 IuTsfBd11 InYB8I11 HuTsfBd11 HnYB8I11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                        size: "L",
                        onPress: ()=>(0, _s2.ToastQueue).positive('Toast complete!'),
                        variant: "secondary",
                        children: "Show toast"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Switch), {
                        size: "XL",
                        isSelected: reduceMotion,
                        onChange: setReduceMotion,
                        children: "Reduce motion"
                    })
                ]
            })
        ]
    });
}

},{"0":"bXktf","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria":"8uUhJ","@react-spectrum/s2":[["Button","gZHck"],["Switch","dIOQS"],["ToastContainer","9R0uF"],["ToastQueue","9R0uF"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"doN2j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Colors", ()=>Colors);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
'use client';
function Colors({ scales }) {
    let [current, setCurrent] = (0, _react.useState)('red-400');
    let swatches = scales.map((scale, i)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
            children: scale.map(([name, className])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
                    className: String(className),
                    "aria-label": name,
                    onHoverStart: ()=>setCurrent(name),
                    onFocus: ()=>setCurrent(name),
                    onAction: ()=>setCurrent(name)
                }, String(name)))
        }, i);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("pre", {
                className: " uj11 -_6BNtrc-c11 vFHT6Dd11 xb11 _xa11 _Fb11 _FnuYUwec11 pt11 JYB8I11",
                children: [
                    current && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                        style: {
                            fontFamily: 'inherit',
                            WebkitTextSizeAdjust: 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: styles.function,
                                children: "style"
                            }),
                            '({',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: styles.property,
                                children: "color"
                            }),
                            ': ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: styles.string,
                                children: `'${current}'`
                            }),
                            '})'
                        ]
                    }),
                    !current && /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
                "aria-label": "Colors",
                layout: "grid",
                className: " se11 DmpAl5d11 UR3ltQc11 qR3ltQc11",
                children: swatches
            })
        ]
    });
}
const styles = {
    string: " p8wMsQe11",
    number: " pG3CxWc11",
    property: " pz2bZib11",
    function: " p37ZLpd11",
    variable: " p1gYRFc11"
};

},{"0":"bXktf","1":"bXktf","2":"bXktf","3":"bXktf","4":"bXktf","5":"bXktf","6":"bXktf","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"dNdIK","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ilALz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchMenuWrapper);
parcelHelpers.export(exports, "SearchMenuButton", ()=>SearchMenuButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _searchMenuTrigger = require("./SearchMenuTrigger");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../../../@react-spectrum/s2/src/Modal");
var _settingsContext = require("./SettingsContext");
'use client';
const MobileSearchMenu = /*#__PURE__*/ (0, _react.lazy)(()=>require("cca13004895a0b79").then(({ MobileSearchMenu })=>({
            default: MobileSearchMenu
        })));
function SearchMenuWrapper({ children }) {
    let { colorScheme } = (0, _settingsContext.useSettings)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " sk11 spd11",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ButtonContext), {
                    value: {
                        onHoverStart: ()=>(0, _searchMenuTrigger.preloadSearchMenu)(),
                        onPress: ()=>window.dispatchEvent(new CustomEvent('show-search-menu'))
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " sd11 spk11",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DialogTrigger), {
                    children: [
                        children,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modal.Modal), {
                            size: "fullscreenTakeover",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Provider), {
                                colorScheme: colorScheme,
                                background: "layer-2",
                                styles: " Fb11",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileSearchMenu, {
                                    initialTag: "components"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function SearchMenuButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["ButtonContext","9G5XO"],["DialogTrigger","l2uUY"]],"./SearchMenuTrigger":"kwXgr","@react-spectrum/s2":"31Rc2","react":"a1TxN","../../../@react-spectrum/s2/src/Modal":"iUTZq","./SettingsContext":"7F6kW","cca13004895a0b79":"7lJJo","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4oKuc":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"7lJJo":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("lC5w8"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("dgnbp"),
    module.bundle.load("klVgk"),
    module.bundle.load("6qO4J"),
    module.bundle.load("hkpo7"),
    module.bundle.load("2zFmR"),
    module.bundle.load("dwEcD"),
    module.bundle.load("gTWSG"),
    module.bundle.load("gcN5T"),
    module.bundle.load("BPsbn"),
    module.bundle.load("lH05e"),
    module.bundle.load("45RYB"),
    module.bundle.load("kIvY2"),
    module.bundle.load("gq8cw")
]).then(()=>{
    let originalModule = module.bundle.root("7ohac");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("dgnbp")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("lC5w8"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("klVgk")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("6qO4J")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("hkpo7")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("2zFmR")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("dwEcD")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("gTWSG")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("gcN5T")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("BPsbn")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("lH05e")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("45RYB")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("kIvY2")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("gq8cw")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"dV7R8":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("gq8cw"),
    module.bundle.load("kIvY2"),
    module.bundle.load("45RYB"),
    module.bundle.load("lH05e"),
    module.bundle.load("BPsbn"),
    module.bundle.load("gcN5T"),
    module.bundle.load("gTWSG"),
    module.bundle.load("dwEcD"),
    module.bundle.load("2zFmR"),
    module.bundle.load("hkpo7"),
    module.bundle.load("6qO4J"),
    module.bundle.load("klVgk"),
    require("bc455535e22ecafe")(module.bundle.resolve("lC5w8")),
    module.bundle.load("dgnbp")
]).then(()=>module.bundle.root('7ohac'));

},{"bc455535e22ecafe":"819rl"}],"819rl":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"e87h6"}],"e87h6":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"amG4b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactAriaComponents = require("react-aria-components");
var _contrast = require("@react-spectrum/s2/icons/Contrast");
var _contrastDefault = parcelHelpers.interopDefault(_contrast);
var _lighten = require("@react-spectrum/s2/icons/Lighten");
var _lightenDefault = parcelHelpers.interopDefault(_lighten);
var _s2 = require("@react-spectrum/s2");
var _searchMenuTrigger = require("@react-spectrum/s2-docs/src/SearchMenuTrigger");
var _searchMenuTriggerDefault = parcelHelpers.interopDefault(_searchMenuTrigger);
var _utils = require("@react-aria/utils");
var _settingsContext = require("@react-spectrum/s2-docs/src/SettingsContext");
var _link = require("@react-spectrum/s2-docs/src/Link");
var _pageUtils = require("@react-spectrum/s2-docs/src/pageUtils");
var _githubLogo = require("@react-spectrum/s2-docs/src/icons/GithubLogo");
var _githubLogoDefault = parcelHelpers.interopDefault(_githubLogo);
var _npmLogo = require("@react-spectrum/s2-docs/src/icons/NpmLogo");
'use client';
const colorSchemeToggleStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf11';
    else rules += ' _Le11';
    rules += ' Ok11';
    rules += ' _Mc11';
    rules += ' _Kd11';
    rules += ' uk11';
    rules += ' ucJ9TBTb11';
    rules += ' ud3Euai11';
    rules += ' uea11';
    rules += ' ugb11';
    rules += ' uhd11';
    rules += ' uje11';
    rules += ' u2NhKxcl11';
    rules += ' uic11';
    rules += ' -_6BNtrc-c11';
    rules += ' vFHT6Dd11';
    rules += ' xb11';
    rules += ' _xa11';
    rules += ' _Fd11';
    rules += ' _FnuYUweb11';
    rules += ' px11';
    rules += ' _Xa11';
    rules += ' Yd11';
    rules += ' Xb11';
    rules += ' _2b11';
    if (props.isFocusVisible) rules += ' gX1r4Le11';
    else if (props.isHovered) rules += ' gX1r4Le11';
    else rules += ' g911';
    rules += ' Z4dY0ec11';
    rules += ' F4dY0ec11';
    rules += ' sd11';
    rules += ' eb11';
    rules += ' _Ca11';
    rules += ' o5NLVAe11';
    rules += ' n5NLVAe11';
    rules += ' k5NLVAe11';
    rules += ' j5NLVAe11';
    rules += ' _ka11';
    rules += ' ha11';
    rules += ' ma11';
    rules += ' la11';
    return rules;
};
const whiteIconStyle = " -_8sjo0b-tw11 ZifsFYc11 FifsFYc11";
const iconContainerStyles = " _Pc11 ZifsFYc11 FifsFYc11";
function ColorSchemeToggle() {
    let { colorScheme, toggleColorScheme, systemColorScheme } = (0, _settingsContext.useSettings)();
    let isOverriding = colorScheme !== systemColorScheme;
    let label = isOverriding ? `Using ${colorScheme} mode (press to follow system)` : `Using system ${systemColorScheme} mode (press to switch)`;
    let ref = (0, _react.useRef)(null);
    let isDark = colorScheme === 'dark';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ref: ref,
        "aria-label": label,
        onPress: toggleColorScheme,
        className: (renderProps)=>colorSchemeToggleStyles(renderProps),
        style: (0, _s2.pressScale)(ref),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: iconContainerStyles,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contrastDefault.default), {
                    styles: whiteIconStyle,
                    UNSAFE_style: {
                        position: 'absolute',
                        inset: 0,
                        opacity: isDark ? 0 : 1,
                        transform: isDark ? 'rotate(-90deg) scale(0.5)' : 'rotate(0deg) scale(1)',
                        transition: 'opacity 200ms ease-out, transform 200ms ease-out'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lightenDefault.default), {
                    styles: whiteIconStyle,
                    UNSAFE_style: {
                        position: 'absolute',
                        inset: 0,
                        opacity: isDark ? 1 : 0,
                        transform: isDark ? 'rotate(0deg) scale(1)' : 'rotate(90deg) scale(0.5)',
                        transition: 'opacity 200ms ease-out, transform 200ms ease-out'
                    }
                })
            ]
        })
    });
}
function HomeHeader() {
    const [searchOpen, setSearchOpen] = (0, _react.useState)(false);
    const searchMenuId = (0, _react.useId)();
    let renderCallback = (0, _react.useRef)(null);
    let iconRef = (0, _react.useRef)(null);
    let labelRef = (0, _react.useRef)(null);
    let searchRef = (0, _react.useRef)(null);
    let openSearchMenu = async ()=>{
        if (!document.startViewTransition) {
            setSearchOpen((prev)=>!prev);
            return;
        }
        // Preload SearchMenu so it is ready to render immediately.
        await (0, _searchMenuTrigger.preloadSearchMenu)();
        // Don't transition the entire page.
        document.documentElement.style.viewTransitionName = 'none';
        if (window.scrollY === 0) {
            iconRef.current.style.viewTransitionName = 'search-menu-icon';
            labelRef.current.style.viewTransitionName = 'search-menu-label';
            searchRef.current.style.viewTransitionName = 'search-menu-search-field';
        }
        let viewTransition = document.startViewTransition(()=>{
            // Wait until next render. Using flushSync causes flickering.
            return new Promise((resolve)=>{
                iconRef.current.style.viewTransitionName = '';
                labelRef.current.style.viewTransitionName = '';
                searchRef.current.style.viewTransitionName = '';
                renderCallback.current = resolve;
                setSearchOpen((prev)=>!prev);
            });
        });
        viewTransition.finished.then(()=>{
            document.documentElement.style.viewTransitionName = '';
        });
    };
    let closeSearchMenu = ()=>{
        if (!document.startViewTransition) {
            setSearchOpen(false);
            return;
        }
        document.documentElement.style.viewTransitionName = 'none';
        let viewTransition = document.startViewTransition(()=>{
            return new Promise((resolve)=>{
                renderCallback.current = resolve;
                setSearchOpen(false);
                if (window.scrollY === 0) {
                    iconRef.current.style.viewTransitionName = 'search-menu-icon';
                    labelRef.current.style.viewTransitionName = 'search-menu-label';
                    searchRef.current.style.viewTransitionName = 'search-menu-search-field';
                }
            });
        });
        viewTransition.finished.then(()=>{
            document.documentElement.style.viewTransitionName = '';
            iconRef.current.style.viewTransitionName = '';
            labelRef.current.style.viewTransitionName = '';
            searchRef.current.style.viewTransitionName = '';
        });
    };
    (0, _utils.useLayoutEffect)(()=>{
        renderCallback.current?.();
        renderCallback.current = null;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
        className: " IM11 HM11 Te11 Tpg11 Qf11 Se11 Re11 LvKf6o11 sd11 eb11 _Ce11 _Pc11 _Bb11",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                href: ".",
                staticColor: "white",
                UNSAFE_style: {
                    lineHeight: '0'
                },
                styles: " _9d11 IYB8I11 I8dxarcPBur111",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: " sh11 eb11 qi9a9Xd11 qp5NLVAe11 _Xa11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            ref: iconRef,
                            style: {
                                display: searchOpen ? 'none' : undefined
                            },
                            "aria-label": "Adobe",
                            className: " Z70iMJe11 F70iMJe11",
                            viewBox: "0 0 501.71 444.05",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "m297.58 444.05-36.45-101.4h-91.46l76.87-193.53 116.65 294.93h138.52L316.8 0H186.23L0 444.05h297.58z",
                                fill: "#fff"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            ref: labelRef,
                            className: " uk11 ucJ9TBTb11 ud3Euai11 uea11 ugb11 uhd11 uje11 u2NhKxcl11 uic11 -_6BNtrc-f11 vFHT6Dd11 xe11 _xa11 xX0cczbd11 _xX0cczba11 _Fd11 _FnuYUweb11 px11",
                            style: {
                                display: searchOpen ? 'none' : undefined
                            },
                            children: "React Spectrum"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _Pa11 _Ar11 Za11 sk11 sqd11 _Ca11",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    ref: searchRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchMenuTriggerDefault.default), {
                        onOpen: openSearchMenu,
                        onClose: closeSearchMenu,
                        isSearchOpen: searchOpen,
                        overlayId: searchMenuId,
                        staticColor: "white"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " sd11 eb11 UR3ltQc11 qR3ltQc11 __Ac11",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                        staticColor: "white",
                        href: "getting-started",
                        styles: " sk11 snd11",
                        children: "Docs"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                        staticColor: "white",
                        href: "releases/",
                        styles: " sk11 snd11",
                        children: "Releases"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                        staticColor: "white",
                        href: (0, _pageUtils.getBaseUrl)('react-aria') + '/blog/',
                        rel: "noopener noreferrer",
                        styles: " sk11 snd11",
                        children: "Blog"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                        staticColor: "white",
                        "aria-label": "GitHub",
                        href: "https://github.com/adobe/react-spectrum",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _githubLogoDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                        staticColor: "white",
                        "aria-label": "npm",
                        href: "https://npmjs.com/@react-spectrum/s2",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _npmLogo.NpmLogo), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Divider), {
                        orientation: "vertical",
                        staticColor: "white",
                        UNSAFE_style: {
                            marginBlock: 4
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeToggle, {})
                ]
            })
        ]
    });
}

},{"0":"bXktf","1":"bXktf","2":"bXktf","3":"bXktf","4":"bXktf","5":"bXktf","6":"bXktf","7":"bXktf","8":"bXktf","9":"bXktf","10":"bXktf","11":"bXktf","12":"bXktf","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"9G5XO","@react-spectrum/s2/icons/Contrast":"jAv02","@react-spectrum/s2/icons/Lighten":"8rFkP","@react-spectrum/s2":[["Divider","kGk2u"],["pressScale","8Ufux"]],"@react-spectrum/s2-docs/src/SearchMenuTrigger":"kwXgr","@react-aria/utils":"2ViQu","@react-spectrum/s2-docs/src/SettingsContext":"7F6kW","@react-spectrum/s2-docs/src/Link":"el6b6","@react-spectrum/s2-docs/src/pageUtils":"73Jzg","@react-spectrum/s2-docs/src/icons/GithubLogo":"dcOQ5","@react-spectrum/s2-docs/src/icons/NpmLogo":"dCdiF","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lRLG7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReleaseLink", ()=>ReleaseLink);
var _jsxRuntime = require("react/jsx-runtime");
var _link = require("@react-spectrum/s2-docs/src/Link");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
'use client';
function ReleaseLink() {
    let ref = (0, _react.useRef)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _link.BaseLink), {
        href: "releases/v1-0-0",
        ref: ref,
        style: (0, _s2.pressScale)(ref, {
            backdropFilter: 'blur(20px)'
        }),
        className: function anonymous(props) {
            let rules = " ";
            rules += ' gIcXhre11';
            rules += ' _nLeasBb11';
            rules += ' og11';
            rules += ' ng11';
            rules += ' kg11';
            rules += ' jg11';
            rules += ' Tf11';
            rules += ' Qf11';
            rules += ' Sh11';
            rules += ' Rh11';
            rules += ' IYB8I11';
            rules += ' InpRvasd11';
            rules += ' GerlM8c11';
            rules += ' _Pc11';
            rules += ' _Nb11';
            rules += ' Pb11';
            rules += ' sd11';
            rules += ' _tc11';
            rules += ' qH5kTnc11';
            rules += ' eb11';
            rules += ' _Lf11';
            rules += ' O6aUFLe11';
            rules += ' _Mb11';
            rules += ' ZJ11';
            rules += ' pt11';
            rules += ' _pa11';
            rules += ' Yd11';
            rules += ' Xb11';
            rules += ' _2b11';
            if (props.isHovered) {
                rules += ' _Xb11';
                rules += ' __Va11';
            } else rules += ' _Xa11';
            return rules;
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.StatusLight), {
                variant: "positive",
                size: "XL",
                children: "Spectrum 2 is now stable!"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 10 10",
                fill: "currentColor",
                "aria-hidden": "true",
                "aria-label": "",
                width: "16",
                height: "16",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M9.26 4.406 6.528 1.672A.84.84 0 0 0 5.34 2.859l1.3 1.301H1.396a.84.84 0 0 0 0 1.68H6.64l-1.301 1.3a.84.84 0 0 0 1.188 1.188l2.734-2.734a.84.84 0 0 0 0-1.188z"
                })
            })
        ]
    });
}

},{"0":"bXktf","react/jsx-runtime":"2Is6Z","@react-spectrum/s2-docs/src/Link":"el6b6","@react-spectrum/s2":[["pressScale","8Ufux"],["StatusLight","f1osu"]],"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"f1osu":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusLightContext", ()=>StatusLightContext);
parcelHelpers.export(exports, "StatusLight", ()=>StatusLight);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _skeleton = require("./Skeleton");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const StatusLightContext = /*#__PURE__*/ (0, _react.createContext)(null);
const wrapper = function anonymous(props, overrides) {
    let rules = " ";
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd11';
    rules += ' Uc11';
    rules += ' Usd11';
    rules += ' qc11';
    rules += ' qsd11';
    rules += ' ea11';
    if (!width) rules += ' ZJ11';
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.variant === "neutral") rules += ' pn11';
    else rules += ' pt11';
    rules += ' __ca11';
    return rules;
};
const light = function anonymous(props) {
    let rules = " ";
    if (props.size === "XL") rules += ' ZokSYvd11';
    else if (props.size === "L") rules += ' ZAMzobb11';
    else if (props.size === "M") rules += ' ZDldWXb11';
    else if (props.size === "S") rules += ' Z7wvBT11';
    if (props.size === "XL") rules += ' FokSYvd11';
    else if (props.size === "L") rules += ' FAMzobb11';
    else if (props.size === "M") rules += ' FDldWXb11';
    else if (props.size === "S") rules += ' F7wvBT11';
    if (props.isSkeleton) rules += ' tn11';
    else if (props.variant === "silver") rules += ' te11';
    else if (props.variant === "brown") rules += ' th11';
    else if (props.variant === "cinnamon") rules += ' tj11';
    else if (props.variant === "turquoise") rules += ' tb11';
    else if (props.variant === "pink") rules += ' to11';
    else if (props.variant === "yellow") rules += ' tl11';
    else if (props.variant === "seafoam") rules += ' tc11';
    else if (props.variant === "indigo") rules += ' td11';
    else if (props.variant === "magenta") rules += ' tp11';
    else if (props.variant === "purple") rules += ' ti11';
    else if (props.variant === "fuchsia") rules += ' tk11';
    else if (props.variant === "cyan") rules += ' ts11';
    else if (props.variant === "chartreuse") rules += ' tg11';
    else if (props.variant === "celery") rules += ' tv11';
    else if (props.variant === "negative") rules += ' tq11';
    else if (props.variant === "notice") rules += ' tm11';
    else if (props.variant === "positive") rules += ' tt11';
    else if (props.variant === "neutral") rules += ' tf11';
    else if (props.variant === "informative") rules += ' tu11';
    rules += ' _Ne11';
    rules += ' Pe11';
    return rules;
};
const StatusLight = /*#__PURE__*/ (0, _react.forwardRef)(function StatusLight(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, StatusLightContext);
    let { children, size = 'M', variant = 'neutral', role, UNSAFE_className = '', UNSAFE_style, styles } = props;
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    !children && props['aria-label'];
    !role && (props['aria-label'] || props['aria-labelledby']);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _utils.filterDOMProps)(props, {
            labelable: !!role
        }),
        ref: domRef,
        role: role,
        style: UNSAFE_style,
        className: UNSAFE_className + wrapper({
            size,
            variant
        }, styles),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    className: light({
                        size,
                        variant,
                        isSkeleton
                    }),
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        r: "50%",
                        cx: "50%",
                        cy: "50%"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: children
            })
        ]
    });
});

},{"0":"hD24H","1":"jVrEL","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react":"a1TxN","@react-aria/utils":"3upVm","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./Skeleton":"1mUnF","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hD24H":[function() {},{}],"jVrEL":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.fillStyle === "outline") rules += ' pm11';
    else if (props.fillStyle === "subtle") rules += ' pm11';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg11';
        else if (props.variant === "chartreuse") rules += ' pg11';
        else if (props.variant === "yellow") rules += ' pg11';
        else if (props.variant === "orange") rules += ' pg11';
        else if (props.variant === "notice") rules += ' pg11';
        else rules += ' px11';
    }
    rules += ' sd11';
    rules += ' ea11';
    rules += ' egLWx3bb11';
    rules += ' _oa11';
    rules += ' Sv11';
    rules += ' SgLWx3bd11';
    rules += ' Rv11';
    rules += ' RgLWx3bd11';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc11';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG11';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c11';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc11';
    } else if (!minWidth) rules += ' N4dY0ec11';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec11';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn11';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b11';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd11';
    else rules += ' -SFnbic-_Jb11';
    rules += ' -Bu7z1c-oH5kTnc11';
    rules += ' oj11';
    rules += ' nj11';
    rules += ' kj11';
    rules += ' jj11';
    rules += ' qc11';
    rules += ' qsd11';
    rules += ' -Qg41Lb-IAxCW0c11';
    rules += ' -Qg41Lb-gLWx3bIYB8I11';
    rules += ' MAyFGYc11';
    rules += ' Td11';
    rules += ' Qd11';
    rules += ' -aRvJDd-Tu7Fubd11';
    rules += ' _Ca11';
    if (props.fillStyle === "outline") rules += ' g_g11';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f11';
        else if (props.variant === "cinnamon") rules += ' gP11';
        else if (props.variant === "brown") rules += ' gO11';
        else if (props.variant === "turquoise") rules += ' gy11';
        else if (props.variant === "pink") rules += ' gT11';
        else if (props.variant === "magenta") rules += ' gS11';
        else if (props.variant === "fuchsia") rules += ' gR11';
        else if (props.variant === "purple") rules += ' gM11';
        else if (props.variant === "indigo") rules += ' gK11';
        else if (props.variant === "blue") rules += ' gG11';
        else if (props.variant === "cyan") rules += ' gC11';
        else if (props.variant === "seafoam") rules += ' gz11';
        else if (props.variant === "green") rules += ' gA11';
        else if (props.variant === "celery") rules += ' gv11';
        else if (props.variant === "chartreuse") rules += ' gJ11';
        else if (props.variant === "yellow") rules += ' gW11';
        else if (props.variant === "orange") rules += ' gV11';
        else if (props.variant === "red") rules += ' gU11';
        else if (props.variant === "gray") rules += ' gI11';
        else if (props.variant === "negative") rules += ' gU11';
        else if (props.variant === "notice") rules += ' gV11';
        else if (props.variant === "positive") rules += ' gA11';
        else if (props.variant === "neutral") rules += ' gI11';
        else if (props.variant === "informative") rules += ' gG11';
        else if (props.variant === "accent") rules += ' gG11';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm11';
        else if (props.variant === "cinnamon") rules += ' gq11';
        else if (props.variant === "brown") rules += ' gn11';
        else if (props.variant === "turquoise") rules += ' g511';
        else if (props.variant === "pink") rules += ' gx11';
        else if (props.variant === "magenta") rules += ' gD11';
        else if (props.variant === "fuchsia") rules += ' gr11';
        else if (props.variant === "purple") rules += ' go11';
        else if (props.variant === "indigo") rules += ' gl11';
        else if (props.variant === "blue") rules += ' g211';
        else if (props.variant === "cyan") rules += ' gk11';
        else if (props.variant === "seafoam") rules += ' g411';
        else if (props.variant === "green") rules += ' g111';
        else if (props.variant === "celery") rules += ' g711';
        else if (props.variant === "chartreuse") rules += ' gp11';
        else if (props.variant === "yellow") rules += ' gN11';
        else if (props.variant === "orange") rules += ' gQ11';
        else if (props.variant === "red") rules += ' gB11';
        else if (props.variant === "gray") rules += ' g611';
        else if (props.variant === "negative") rules += ' gB11';
        else if (props.variant === "notice") rules += ' gQ11';
        else if (props.variant === "positive") rules += ' g111';
        else if (props.variant === "neutral") rules += ' g611';
        else if (props.variant === "informative") rules += ' g211';
        else if (props.variant === "accent") rules += ' g211';
    }
    rules += ' _jf11';
    rules += ' _kJ8iPYd11';
    rules += ' hXMFGYc11';
    rules += ' mc11';
    rules += ' lc11';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS11';
        else if (props.variant === "notice") rules += ' i9VrKkd11';
        else if (props.variant === "positive") rules += ' ip17Jm11';
        else if (props.variant === "neutral") rules += ' i0ruhAb11';
        else if (props.variant === "informative") rules += ' iG1ze4d11';
        else if (props.variant === "accent") rules += ' iG1ze4d11';
    } else rules += ' iA11';
    rules += ' -_8sjo0b-t5ZbAob11';
    if (props.size === "XL") rules += ' -M_-MBaYFfc11';
    else if (props.size === "L") rules += ' -M_-M3JjxG11';
    else if (props.size === "S") rules += ' -M_-MCe2o8c11';
    else if (props.size === "XS") rules += ' -M_-MifsFYc11';
    else rules += ' -M_-M4dY0ec11';
    rules += ' -_k_-_kc11';
    rules += ' -h_-hc11';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG11';
                        rules += ' QAzEcG11';
                        rules += ' _Jb11';
                        rules += ' _Nc11';
                        rules += ' Pc11';
                        rules += ' _Yb11';
                        if (props.overflowMode === "wrap") rules += ' _7b11';
                        else if (props.overflowMode === "truncate") rules += ' _7c11';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _reactAriaComponents.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja11"
                    }),
                    styles: " ZuUmpre11 FuUmpre11 I67logd11 _va11"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _utils.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components":[["Provider","bA6Cz"],["TextContext","jt9fm"]],"@react-aria/utils":"3upVm","./Icon":"jQAJE","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"iQ1Sx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearButton", ()=>ClearButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _cross = require("../ui-icons/Cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _react = require("react");
var _pressScale = require("./pressScale");
var _utils = require("@react-spectrum/utils");
const focusRingStyles = {
    outlineStyle: {
        "default": "none",
        isFocusVisible: "solid"
    },
    outlineColor: {
        "default": "focus-ring",
        forcedColors: "Highlight"
    },
    outlineWidth: 2,
    outlineOffset: 2
};
const visibleClearButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf11';
    else rules += ' _Le11';
    if (props.isStaticColor) rules += ' Ok11';
    else {
        rules += ' Oh11';
        rules += ' OlOVIhfcebS7sd11';
        rules += ' OlOVIhfcebS7sd11';
    }
    rules += ' _Mc11';
    rules += ' _Kc11';
    rules += ' sd11';
    rules += ' eb11';
    rules += ' _Ca11';
    rules += ' Fb11';
    if (props.size === "XL") rules += ' ZBaYFfc11';
    else if (props.size === "L") rules += ' Z3JjxG11';
    else if (props.size === "S") rules += ' ZCe2o8c11';
    else if (props.size === "XS") rules += ' ZifsFYc11';
    else rules += ' Z4dY0ec11';
    rules += ' _va11';
    rules += ' og11';
    rules += ' ng11';
    rules += ' kg11';
    rules += ' jg11';
    rules += ' _je11';
    rules += ' g911';
    rules += ' _oa11';
    rules += ' Td11';
    rules += ' Qd11';
    rules += ' Sd11';
    rules += ' Rd11';
    rules += ' p40ub4c11';
    rules += ' -_8sjo0b-t5ZbAob11';
    return rules;
};
const ClearButton = /*#__PURE__*/ (0, _react.forwardRef)(function ClearButton(props, ref) {
    let { size = 'M', isStaticColor = false, ...rest } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...rest,
        ref: domRef,
        style: (0, _pressScale.pressScale)(domRef),
        className: (renderProps)=>visibleClearButton({
                ...renderProps,
                size,
                isStaticColor
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
            size: props.size
        })
    });
});

},{"0":"jHckW","react/jsx-runtime":"2Is6Z","react-aria-components":"9G5XO","../ui-icons/Cross":"5E2vn","react":"a1TxN","./pressScale":"8Ufux","@react-spectrum/utils":"jqfrX","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jHckW":[function() {},{}],"hMlI1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * GridLayout is a virtualizer Layout implementation
 * that arranges its items in a grid.
 * The items are sized between a minimum and maximum size
 * depending on the width of the container.
 */ parcelHelpers.export(exports, "GridLayout", ()=>GridLayout);
var _virtualizer = require("@react-stately/virtualizer");
const DEFAULT_OPTIONS = {
    minItemSize: new (0, _virtualizer.Size)(200, 200),
    maxItemSize: new (0, _virtualizer.Size)(Infinity, Infinity),
    preserveAspectRatio: false,
    minSpace: new (0, _virtualizer.Size)(18, 18),
    maxSpace: Infinity,
    maxColumns: Infinity,
    dropIndicatorThickness: 2
};
class GridLayout extends (0, _virtualizer.Layout) {
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return newOptions.maxColumns !== oldOptions.maxColumns || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || newOptions.preserveAspectRatio !== oldOptions.preserveAspectRatio || !(newOptions.minItemSize || DEFAULT_OPTIONS.minItemSize).equals(oldOptions.minItemSize || DEFAULT_OPTIONS.minItemSize) || !(newOptions.maxItemSize || DEFAULT_OPTIONS.maxItemSize).equals(oldOptions.maxItemSize || DEFAULT_OPTIONS.maxItemSize) || !(newOptions.minSpace || DEFAULT_OPTIONS.minSpace).equals(oldOptions.minSpace || DEFAULT_OPTIONS.minSpace) || newOptions.maxHorizontalSpace !== oldOptions.maxHorizontalSpace;
    }
    update(invalidationContext) {
        let { minItemSize = DEFAULT_OPTIONS.minItemSize, maxItemSize = DEFAULT_OPTIONS.maxItemSize, preserveAspectRatio = DEFAULT_OPTIONS.preserveAspectRatio, minSpace = DEFAULT_OPTIONS.minSpace, maxHorizontalSpace = DEFAULT_OPTIONS.maxSpace, maxColumns = DEFAULT_OPTIONS.maxColumns, dropIndicatorThickness = DEFAULT_OPTIONS.dropIndicatorThickness } = invalidationContext.layoutOptions || {};
        this.dropIndicatorThickness = dropIndicatorThickness;
        let visibleWidth = this.virtualizer.visibleRect.width;
        // The max item width is always the entire viewport.
        // If the max item height is infinity, scale in proportion to the max width.
        let maxItemWidth = Math.min(maxItemSize.width, visibleWidth);
        let maxItemHeight = Number.isFinite(maxItemSize.height) ? maxItemSize.height : Math.floor(minItemSize.height / minItemSize.width * maxItemWidth);
        // Compute the number of rows and columns needed to display the content
        let columns = Math.floor(visibleWidth / (minItemSize.width + minSpace.width));
        let numColumns = Math.max(1, Math.min(maxColumns, columns));
        this.numColumns = numColumns;
        // Compute the available width (minus the space between items)
        let width = visibleWidth - minSpace.width * Math.max(0, numColumns);
        // Compute the item width based on the space available
        let itemWidth = Math.floor(width / numColumns);
        itemWidth = Math.max(minItemSize.width, Math.min(maxItemWidth, itemWidth));
        // Compute the item height, which is proportional to the item width
        let t = (itemWidth - minItemSize.width) / Math.max(1, maxItemWidth - minItemSize.width);
        let itemHeight = minItemSize.height + Math.floor((maxItemHeight - minItemSize.height) * t);
        itemHeight = Math.max(minItemSize.height, Math.min(maxItemHeight, itemHeight));
        // Compute the horizontal spacing, content height and horizontal margin
        let horizontalSpacing = Math.min(Math.max(maxHorizontalSpace, minSpace.width), Math.floor((visibleWidth - numColumns * itemWidth) / (numColumns + 1)));
        this.gap = new (0, _virtualizer.Size)(horizontalSpacing, minSpace.height);
        this.margin = Math.floor((visibleWidth - numColumns * itemWidth - horizontalSpacing * (numColumns + 1)) / 2);
        // If there is a skeleton loader within the last 2 items in the collection, increment the collection size
        // so that an additional row is added for the skeletons.
        let collection = this.virtualizer.collection;
        let collectionSize = collection.size;
        let lastKey = collection.getLastKey();
        for(let i = 0; i < 2 && lastKey != null; i++){
            let item = collection.getItem(lastKey);
            if (item?.type === 'skeleton') {
                collectionSize++;
                break;
            }
            lastKey = collection.getKeyBefore(lastKey);
        }
        let rows = Math.ceil(collectionSize / numColumns);
        let iterator = collection[Symbol.iterator]();
        let y = rows > 0 ? minSpace.height : 0;
        let newLayoutInfos = new Map();
        let skeleton = null;
        let skeletonCount = 0;
        for(let row = 0; row < rows; row++){
            let maxHeight = 0;
            let rowLayoutInfos = [];
            for(let col = 0; col < numColumns; col++){
                // Repeat skeleton until the end of the current row.
                let node = skeleton || iterator.next().value;
                if (!node) break;
                // We will add the loader after the skeletons so skip here
                if (node.type === 'loader') continue;
                if (node.type === 'skeleton') skeleton = node;
                let key = skeleton ? `${skeleton.key}-${skeletonCount++}` : node.key;
                let oldLayoutInfo = this.layoutInfos.get(key);
                let content = node;
                if (skeleton) content = oldLayoutInfo && oldLayoutInfo.content.key === key ? oldLayoutInfo.content : {
                    ...skeleton,
                    key
                };
                let x = horizontalSpacing + col * (itemWidth + horizontalSpacing) + this.margin;
                let height = itemHeight;
                let estimatedSize = !preserveAspectRatio;
                if (oldLayoutInfo && estimatedSize) {
                    height = oldLayoutInfo.rect.height;
                    estimatedSize = invalidationContext.layoutOptionsChanged || invalidationContext.sizeChanged || oldLayoutInfo.estimatedSize || oldLayoutInfo.content !== content;
                }
                let rect = new (0, _virtualizer.Rect)(x, y, itemWidth, height);
                let layoutInfo = new (0, _virtualizer.LayoutInfo)(node.type, key, rect);
                layoutInfo.estimatedSize = estimatedSize;
                layoutInfo.allowOverflow = true;
                layoutInfo.content = content;
                newLayoutInfos.set(key, layoutInfo);
                rowLayoutInfos.push(layoutInfo);
                maxHeight = Math.max(maxHeight, layoutInfo.rect.height);
            }
            for (let layoutInfo of rowLayoutInfos)layoutInfo.rect.height = maxHeight;
            y += maxHeight + minSpace.height;
            // Keep adding skeleton rows until we fill the viewport
            if (skeleton && row === rows - 1 && y < this.virtualizer.visibleRect.height) rows++;
        }
        // Always add the loader sentinel if present in the collection so we can make sure it is never virtualized out.
        let lastNode = collection.getItem(collection.getLastKey());
        if (lastNode?.type === 'loader') {
            let rect = new (0, _virtualizer.Rect)(horizontalSpacing, y, itemWidth, 0);
            let layoutInfo = new (0, _virtualizer.LayoutInfo)('loader', lastNode.key, rect);
            newLayoutInfos.set(lastNode.key, layoutInfo);
        }
        this.layoutInfos = newLayoutInfos;
        this.contentSize = new (0, _virtualizer.Size)(this.virtualizer.visibleRect.width, y);
    }
    getLayoutInfo(key) {
        return this.layoutInfos.get(key) || null;
    }
    getContentSize() {
        return this.contentSize;
    }
    getVisibleLayoutInfos(rect) {
        let layoutInfos = [];
        for (let layoutInfo of this.layoutInfos.values())if (layoutInfo.rect.intersects(rect) || this.virtualizer.isPersistedKey(layoutInfo.key) || layoutInfo.type === 'loader') layoutInfos.push(layoutInfo);
        return layoutInfos;
    }
    updateItemSize(key, size) {
        let layoutInfo = this.layoutInfos.get(key);
        if (!size || !layoutInfo) return false;
        if (size.height !== layoutInfo.rect.height) {
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect.height = size.height;
            newLayoutInfo.estimatedSize = false;
            this.layoutInfos.set(key, newLayoutInfo);
            return true;
        }
        return false;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        if (this.layoutInfos.size === 0) return {
            type: 'root'
        };
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let key = null;
        if (this.numColumns === 1) {
            let searchRect = new (0, _virtualizer.Rect)(x, Math.max(0, y - this.gap.height), 1, Math.max(1, this.gap.height * 2));
            let candidates = this.getVisibleLayoutInfos(searchRect);
            let minDistance = Infinity;
            for (let candidate of candidates){
                // Ignore items outside the search rect, e.g. persisted keys.
                if (!candidate.rect.intersects(searchRect)) continue;
                let yDist = Math.abs(candidate.rect.y - y);
                let maxYDist = Math.abs(candidate.rect.maxY - y);
                let dist = Math.min(yDist, maxYDist);
                if (dist < minDistance) {
                    minDistance = dist;
                    key = candidate.key;
                }
            }
        } else {
            let searchRect = new (0, _virtualizer.Rect)(Math.max(0, x - this.gap.width), y, this.gap.width * 2, 1);
            let candidates = this.getVisibleLayoutInfos(searchRect);
            let minDistance = Infinity;
            for (let candidate of candidates){
                // Ignore items outside the search rect, e.g. persisted keys.
                if (!candidate.rect.intersects(searchRect)) continue;
                let xDist = Math.abs(candidate.rect.x - x);
                let maxXDist = Math.abs(candidate.rect.maxX - x);
                let dist = Math.min(xDist, maxXDist);
                if (dist < minDistance) {
                    minDistance = dist;
                    key = candidate.key;
                }
            }
        }
        let layoutInfo = key != null ? this.getLayoutInfo(key) : null;
        if (!layoutInfo) return {
            type: 'root'
        };
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        let pos = this.numColumns === 1 ? y : x;
        let layoutInfoPos = this.numColumns === 1 ? layoutInfo.rect.y : layoutInfo.rect.x;
        let size = this.numColumns === 1 ? layoutInfo.rect.height : layoutInfo.rect.width;
        if (isValidDropTarget(target)) {
            // If dropping on the item is accepted, try the before/after positions
            // if within 5px of the start or end of the item.
            if (pos < layoutInfoPos + 5) target.dropPosition = 'before';
            else if (pos > layoutInfoPos + size - 5) target.dropPosition = 'after';
        } else {
            // If dropping on the item isn't accepted, try the target before or after depending on the position.
            let mid = layoutInfoPos + size / 2;
            if (pos <= mid && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (pos >= mid && isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        }
        return target;
    }
    getDropTargetLayoutInfo(target) {
        let layoutInfo = this.getLayoutInfo(target.key);
        let rect;
        if (this.numColumns === 1) // Flip from vertical to horizontal if only one column is visible.
        rect = new (0, _virtualizer.Rect)(layoutInfo.rect.x, target.dropPosition === 'before' ? layoutInfo.rect.y - this.gap.height / 2 - this.dropIndicatorThickness / 2 : layoutInfo.rect.maxY + this.gap.height / 2 - this.dropIndicatorThickness / 2, layoutInfo.rect.width, this.dropIndicatorThickness);
        else rect = new (0, _virtualizer.Rect)(target.dropPosition === 'before' ? layoutInfo.rect.x - this.gap.width / 2 - this.dropIndicatorThickness / 2 : layoutInfo.rect.maxX + this.gap.width / 2 - this.dropIndicatorThickness / 2, layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height);
        return new (0, _virtualizer.LayoutInfo)('dropIndicator', target.key + ':' + target.dropPosition, rect);
    }
    constructor(...args){
        super(...args), this.gap = DEFAULT_OPTIONS.minSpace, this.dropIndicatorThickness = 2, this.numColumns = 0, this.contentSize = new (0, _virtualizer.Size)(), this.layoutInfos = new Map(), this.margin = 0;
    }
}

},{"@react-stately/virtualizer":[["Layout","fnAag"],["LayoutInfo","6H2VJ"],["Rect","l3p76"],["Size","F8cca"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PPGS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a list component with interactive children.
 * A grid list displays data in a single column and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the list.
 * @param state - State for the list, as returned by `useListState`.
 * @param ref - The ref attached to the list element.
 */ parcelHelpers.export(exports, "useGridList", ()=>useGridList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _grid = require("@react-aria/grid");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useGridList(props, state, ref) {
    let { isVirtualized, keyboardDelegate, layoutDelegate, onAction, disallowTypeAhead, linkBehavior = 'action', keyboardNavigationBehavior = 'arrow', escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps } = (0, _selection.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref,
        keyboardDelegate,
        layoutDelegate,
        isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior,
        disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listMap).set(state, {
        id,
        onAction,
        linkBehavior,
        keyboardNavigationBehavior,
        shouldSelectOnPressUp
    });
    let descriptionProps = (0, _grid.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: 'grid',
        id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, _grid.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useId","jbI4Y"]],"./utils":"aJkqW","@react-aria/grid":[["useGridSelectionAnnouncement","deyzk"],["useHighlightSelectionDescription","eO4Xt"]],"@react-aria/focus":"eSQu0","@react-aria/selection":"ldksp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJkqW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listMap", ()=>listMap);
parcelHelpers.export(exports, "getRowId", ()=>getRowId);
parcelHelpers.export(exports, "normalizeKey", ()=>normalizeKey);
const listMap = new WeakMap();
function getRowId(state, key) {
    let { id } = listMap.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${normalizeKey(key)}`;
}
function normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fNHH4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid list.
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useListState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useGridListItem", ()=>useGridListItem);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
var _i18N = require("@react-aria/i18n");
const EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function useGridListItem(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node, isVirtualized } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction } = (0, _i18N.useLocale)();
    let { onAction, linkBehavior, keyboardNavigationBehavior, shouldSelectOnPressUp } = (0, _utils1.listMap).get(state);
    let descriptionId = (0, _utils.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !(0, _utils.nodeContains)(ref.current, document.activeElement))) (0, _focus.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        if (node.level > 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = state.collection.getChildren?.(parent.key);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': node?.index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps, ...itemStates } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, _utils.chain)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus,
        linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        if (!(0, _utils.nodeContains)(e.currentTarget, e.target) || !ref.current || !document.activeElement) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        if ('expandedKeys' in state && document.activeElement === ref.current) {
            if (e.key === EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && (0, _utils.nodeContains)(ref.current, e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let onKeyDown = (e)=>{
        if (!(0, _utils.nodeContains)(e.currentTarget, e.target) || !ref.current || !document.activeElement) return;
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = document.activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, _utils.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, _utils.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture,
        onKeyDown,
        onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node['aria-label'] || node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && (node['aria-label'] || node.textValue) ? `${(0, _utils1.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, _utils1.getRowId)(state, node.key)
    });
    if (isVirtualized) {
        let { collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, _utils.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/utils":[["chain","ij7eS"],["getScrollParent","1Tu7U"],["mergeProps","aNvcY"],["nodeContains","9OiSj"],["scrollIntoViewport","1lzpw"],["useSlotId","jbI4Y"],["useSyntheticLinkProps","4FGnT"]],"@react-aria/focus":[["focusSafely","2ysUy"],["getFocusableTreeWalker","9oPIl"]],"./utils":"aJkqW","react":"a1TxN","@react-aria/interactions":"dkfxW","@react-aria/selection":"cJdJS","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gU4lG":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBarContext", ()=>ActionBarContext);
parcelHelpers.export(exports, "ActionBar", ()=>ActionBar);
parcelHelpers.export(exports, "useActionBarContainer", ()=>useActionBarContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _liveAnnouncer = require("@react-aria/live-announcer");
var _closeButton = require("./CloseButton");
var _react = require("react");
var _reactAria = require("react-aria");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-stately/utils");
var _utils1 = require("@react-spectrum/utils");
var _utils2 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const actionBarStyles = function anonymous(props) {
    let rules = " ";
    rules += ' o5NLVAe11';
    rules += ' n5NLVAe11';
    rules += ' k5NLVAe11';
    rules += ' j5NLVAe11';
    if (props.isEmphasized) rules += ' -Ovbhqd-g011';
    else rules += ' -Ovbhqd-g_g11';
    rules += ' gEzkoQe11';
    rules += ' _nLeasBb11';
    rules += ' _oa11';
    rules += ' _Lf11';
    rules += ' _Mb11';
    if (props.isEmphasized) rules += ' Oj11';
    else rules += ' Oye39g11';
    rules += ' OlOVIhfcCp4usd11';
    rules += ' OlOVIhfcCp4usd11';
    rules += ' St11';
    rules += ' Rt11';
    rules += ' Te11';
    rules += ' Qe11';
    rules += ' sd11';
    rules += ' UB1JKEb11';
    rules += ' qB1JKEb11';
    rules += ' eb11';
    if (props.isInContainer) rules += ' _Pa11';
    rules += ' _lr11';
    rules += ' _AI11';
    rules += ' -F3Iohc-_zI11';
    if (props.isInContainer) rules += ' Zd11';
    else rules += ' Za11';
    rules += ' IM11';
    rules += ' HM11';
    rules += ' LStAi2d11';
    rules += ' Yg11';
    rules += ' Xc11';
    rules += ' _2b11';
    if (props.isExiting) {
        rules += ' -_8PloMd-t11';
        rules += ' __Ya11';
    } else if (props.isEntering) {
        rules += ' -_8PloMd-t11';
        rules += ' __Ya11';
    } else {
        rules += ' -_8PloMd-q11';
        rules += ' __Ya11';
    }
    return rules;
};
const ActionBarContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ActionBar = /*#__PURE__*/ (0, _react.forwardRef)(function ActionBar(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ActionBarContext);
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isOpen = props.selectedItemCount !== 0;
    let isExiting = (0, _utils2.useExitAnimation)(domRef, isOpen && props.scrollRef != null);
    if (!isOpen && !isExiting) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBarInner, {
        ...props,
        ref: domRef,
        isExiting: isExiting
    });
});
const ActionBarInner = /*#__PURE__*/ (0, _react.forwardRef)(function ActionBarInner(props1, ref) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { isEmphasized, selectedItemCount = 0, children, onClearSelection, isExiting, slot, scrollRef, ...otherProps } = props1;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    // Store the last count greater than zero so that we can retain it while rendering the fade-out animation.
    let [lastCount, setLastCount] = (0, _react.useState)(selectedItemCount);
    if ((selectedItemCount === 'all' || selectedItemCount > 0) && selectedItemCount !== lastCount) setLastCount(selectedItemCount);
    // Measure the width of the collection's scrollbar and offset the action bar by that amount.
    let [scrollbarWidth, setScrollbarWidth] = (0, _react.useState)(0);
    let updateScrollbarWidth = (0, _react.useCallback)(()=>{
        let el = scrollRef?.current;
        if (el) {
            let w = el.offsetWidth - el.clientWidth;
            setScrollbarWidth(w);
        }
    }, [
        scrollRef
    ]);
    (0, _utils2.useResizeObserver)({
        ref: scrollRef,
        onResize: updateScrollbarWidth
    });
    let { keyboardProps } = (0, _reactAria.useKeyboard)({
        onKeyDown (e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                onClearSelection?.();
            } else e.continuePropagation();
        }
    });
    // Announce "actions available" on mount.
    let isInitial = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (isInitial.current && scrollRef) {
            isInitial.current = false;
            (0, _liveAnnouncer.announce)(stringFormatter.format('actionbar.actionsAvailable'));
        }
    }, [
        stringFormatter,
        scrollRef
    ]);
    let objectRef = (0, _utils2.useObjectRef)(ref);
    let isEntering = (0, _utils2.useEnterAnimation)(objectRef, !!scrollRef);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAria.FocusScope), {
        restoreFocus: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            ref: objectRef,
            ...otherProps,
            ...keyboardProps,
            className: (props1.UNSAFE_className || '') + actionBarStyles({
                isEmphasized,
                isInContainer: !!scrollRef,
                isEntering,
                isExiting
            }),
            style: {
                insetInlineEnd: `calc(var(--insetEnd) + ${scrollbarWidth}px)`,
                ...props1.UNSAFE_style
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: " _Jb11 IM11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButtonGroup.ActionButtonGroup), {
                        staticColor: isEmphasized ? 'auto' : undefined,
                        isQuiet: true,
                        "aria-label": stringFormatter.format('actionbar.actions'),
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: " _Ja11 sd11 eb11 UR3ltQc11 qR3ltQc11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButton.CloseButton), {
                            staticColor: isEmphasized ? 'auto' : undefined,
                            "aria-label": stringFormatter.format('actionbar.clearSelection'),
                            onPress: ()=>onClearSelection?.()
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: function anonymous(props) {
                                let rules = " ";
                                rules += ' uk11';
                                rules += ' ucJ9TBTb11';
                                rules += ' ud3Euai11';
                                rules += ' uea11';
                                rules += ' ugb11';
                                rules += ' uhd11';
                                rules += ' uje11';
                                rules += ' u2NhKxcl11';
                                rules += ' uic11';
                                rules += ' -_6BNtrc-c11';
                                rules += ' vFHT6Dd11';
                                rules += ' xb11';
                                rules += ' _xa11';
                                rules += ' _Fd11';
                                rules += ' _FnuYUweb11';
                                if (props.isEmphasized) rules += ' pr11';
                                else rules += ' pt11';
                                return rules;
                            }({
                                isEmphasized
                            }),
                            children: lastCount === 'all' ? stringFormatter.format('actionbar.selectedAll') : stringFormatter.format('actionbar.selected', {
                                count: lastCount
                            })
                        })
                    ]
                })
            ]
        })
    });
});
function useActionBarContainer(props) {
    let { renderActionBar, scrollRef } = props;
    let [selectedKeys, setSelectedKeys] = (0, _utils.useControlledState)(props.selectedKeys, props.defaultSelectedKeys || new Set(), props.onSelectionChange);
    let selectedKeysSet = (0, _react.useMemo)(()=>selectedKeys === 'all' ? selectedKeys : new Set(selectedKeys), [
        selectedKeys
    ]);
    let actionBar = (0, _react.useMemo)(()=>renderActionBar?.(selectedKeysSet), [
        renderActionBar,
        selectedKeysSet
    ]);
    let selectedItemCount = selectedKeysSet === 'all' ? 'all' : selectedKeysSet.size;
    let [actionBarHeight, setActionBarHeight] = (0, _react.useState)(0);
    let actionBarRef = (0, _react.useCallback)((ref)=>{
        let actionBar = ref?.UNSAFE_getDOMNode();
        if (actionBar) setActionBarHeight(actionBar.offsetHeight + 8);
        else setActionBarHeight(0);
    }, []);
    let actionBarContext = (0, _react.useMemo)(()=>({
            ref: actionBarRef,
            scrollRef,
            selectedItemCount,
            onClearSelection: ()=>setSelectedKeys(new Set())
        }), [
        scrollRef,
        actionBarRef,
        selectedItemCount,
        setSelectedKeys
    ]);
    let wrappedActionBar = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBarContext.Provider, {
            value: actionBarContext,
            children: actionBar
        }), [
        actionBarContext,
        actionBar
    ]);
    return {
        selectedKeys,
        onSelectionChange: setSelectedKeys,
        actionBar: wrappedActionBar,
        actionBarHeight
    };
}

},{"0":"frYaX","1":"jeYGC","2":"bRL5Y","3":"2YRKv","react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","@react-aria/live-announcer":"3nbSW","./CloseButton":"8LP64","react":"a1TxN","react-aria":[["FocusScope","9oPIl"],["useKeyboard","vsbUl"]],"../intl/*.json":"gDH3q","@react-stately/utils":"4Nj6T","@react-spectrum/utils":"jqfrX","@react-aria/utils":[["useEnterAnimation","a1dBG"],["useExitAnimation","a1dBG"],["useObjectRef","laqO5"],["useResizeObserver","7OAb4"]],"@react-aria/i18n":"7lxyl","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"frYaX":[function() {},{}],"jeYGC":[function() {},{}],"bRL5Y":[function() {},{}],"2YRKv":[function() {},{}],"8WxyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"jbI4Y","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {}, "./", "/")

//# sourceMappingURL=s2.db8733c9.js.map
